import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useRef, useState, useEffect, forwardRef, memo } from 'react';
import styled from 'styled-components';
import { formatDate } from '@eir/utils';
import { API } from 'aws-amplify';
import { useHistory } from 'react-router-dom';
import { useSpring, animated } from 'react-spring';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var createQuoteService = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(apiName, body) {
    var myInit;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            myInit = {
              body: body
            };
            _context.next = 3;
            return API.post(apiName, 'osa/quote', myInit);

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createQuoteService(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

const Button = ({ children, theme = 'partnerPrimary', size = 'medium', onClick, type = 'button', disabled = false, }) => {
    const colors = {
        partnerPrimary: {
            fontColor: '#fff',
            backgroundColor: 'var(--eir-partner-button-primary-color)',
            border: 'none',
            textDecoration: 'none',
            hover: {
                backgroundColor: 'var(--eir-partner-button-primary-hover-color)',
                borderColor: 'inherit',
                boxShadow: 'none',
            },
        },
        green: {
            fontColor: '#fff',
            backgroundColor: '#4cbfa0',
            border: 'none',
            textDecoration: 'none',
            hover: {
                backgroundColor: '#5bc4a8',
                borderColor: 'inherit',
                boxShadow: 'none',
            },
        },
    };
    const sizes = {
        large: {
            padding: '1.6rem',
            fontSize: '1.8rem',
        },
        medium: {
            padding: '1.2rem 0',
            fontSize: '1.4rem',
        },
        small: {
            padding: '0.5rem',
            fontSize: '0.75rem',
        },
    };
    const handleClick = () => {
        onClick && onClick();
    };
    return (jsx(StyledButton, Object.assign({ type: type, themeColors: colors[theme], size: sizes[size], disabled: disabled, onClick: handleClick }, { children: children })));
};
const StyledButton = styled.button `
  border-radius: 0.25rem;
  line-height: 1;
  background-color: ${({ themeColors }) => themeColors.backgroundColor};
  border: ${({ themeColors }) => themeColors.border};
  outline: none;
  font-weight: 400;
  font-size: ${({ size }) => size.fontSize};
  color: ${({ themeColors }) => themeColors.fontColor};
  padding: ${({ size }) => size.padding};
  text-decoration: ${({ themeColors }) => themeColors.textDecoration};
  cursor: pointer;

  &:hover {
    background-color: ${({ themeColors }) => themeColors.hover.backgroundColor};
    box-shadow: rgba(30, 56, 174, 0.3) 0 1px 3px 1px;
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

var img$2 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='97.803' height='28.609' viewBox='0 0 283.465 82.894' xmlSpace='preserve'%3e %3cg%3e %3cpath fill='%23005775' d='M1.308%2c81.586C0.476%2c81.586%2c0%2c81.11%2c0%2c80.277V25.085c0-0.714%2c0.238-1.308%2c0.951-1.665 c6.78-2.855%2c14.631-4.639%2c22.838-4.639c15.94%2c0%2c26.764%2c7.494%2c26.764%2c25.693v35.804c0%2c0.832-0.475%2c1.308-1.427%2c1.308h-7.018 c-0.832%2c0-1.308-0.476-1.308-1.308V44.711c0-12.371-6.304-17.129-17.01-17.129c-4.996%2c0-10.348%2c0.951-14.036%2c2.141v50.554 c0%2c0.832-0.476%2c1.308-1.427%2c1.308H1.308z'/%3e %3cpath fill='%23005775' d='M114.307%2c54.108c0%2c0.951-0.476%2c1.427-1.308%2c1.427H74.102v4.996c0%2c8.921%2c6.661%2c13.679%2c15.464%2c13.679 c8.207%2c0%2c13.798-3.212%2c18.199-6.661c0.714-0.476%2c1.427-0.357%2c1.903%2c0.357l3.449%2c4.52c0.596%2c0.714%2c0.476%2c1.308-0.238%2c1.903 c-5.947%2c4.996-13.56%2c8.564-23.551%2c8.564c-12.847%2c0-25.099-7.375-25.099-22.362V42.451c0-16.296%2c12.133-23.671%2c25.217-23.671 c12.966%2c0%2c24.861%2c7.375%2c24.861%2c23.671V54.108z M89.446%2c27.583c-8.921%2c0-15.344%2c4.639-15.344%2c14.869v4.996h30.689v-4.996 C104.792%2c32.34%2c98.13%2c27.583%2c89.446%2c27.583z'/%3e %3cpath fill='%23005775' d='M148.799%2c73.854c1.308%2c0%2c3.568-0.119%2c5.709-0.238c0.952%2c0%2c1.428%2c0.476%2c1.428%2c1.308v6.304 c0%2c0.714-0.358%2c1.308-1.19%2c1.427c-2.141%2c0.119-4.876%2c0.238-6.423%2c0.238c-11.896%2c0-20.698-6.423-20.698-21.054V6.409 c0-0.951%2c0.476-1.427%2c1.427-1.427h6.186c0.714%2c0%2c1.189%2c0.476%2c1.308%2c1.308l0.832%2c14.393h15.464c0.832%2c0%2c1.308%2c0.476%2c1.308%2c1.308 v5.947c0%2c0.952-0.476%2c1.427-1.308%2c1.427h-15.464v31.998C137.379%2c69.215%2c141.423%2c73.854%2c148.799%2c73.854z'/%3e %3cpath fill='%23005775' d='M186.267%2c82.894c-8.207%2c0-16.416-2.379-23.553-7.613c-0.714-0.476-0.714-1.189-0.356-1.903 l3.211-5.471c0.476-0.833%2c1.07-0.951%2c1.903-0.357c5.71%2c4.282%2c12.252%2c6.661%2c19.033%2c6.661c7.969%2c0%2c14.036-3.331%2c14.036-9.516 c0-6.661-7.375-8.207-14.036-9.516c-8.565-1.784-23.196-5.115-23.196-18.913c0-12.133%2c11.538-17.486%2c23.434-17.486 c7.493%2c0%2c14.155%2c1.903%2c20.696%2c5.59c0.834%2c0.357%2c0.952%2c1.07%2c0.476%2c1.784l-3.211%2c5.352c-0.356%2c0.714-1.07%2c0.952-1.784%2c0.476 c-4.876-2.617-10.706-4.401-16.653-4.401c-8.327%2c0-13.323%2c3.33-13.323%2c8.683c0%2c6.542%2c7.018%2c8.326%2c15.464%2c9.992 c9.516%2c1.903%2c22.006%2c4.639%2c22.006%2c17.962C210.414%2c76.352%2c200.184%2c82.894%2c186.267%2c82.894z'/%3e %3c/g%3e %3cg%3e %3ccircle fill='%2303bfef' cx='241.95' cy='13.832' r='13.832'/%3e %3ccircle fill='%2303bfef' cx='271.292' cy='13.832' r='8.852'/%3e %3ccircle fill='%2303bfef' cx='271.292' cy='43.107' r='12.172'/%3e %3ccircle fill='%2303bfef' cx='241.95' cy='72.382' r='10.512'/%3e %3c/g%3e%3c/svg%3e";

var img$1 = "data:image/png;base64,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";

const PaymentMethod = ({ paymentProvider, selectedPaymentProvider, onChange, }) => {
    var _a;
    const inputRef = useRef(null);
    const [isChecked, setIsChecked] = useState(true);
    useEffect(() => {
        if (inputRef.current) {
            setIsChecked(inputRef.current.checked);
        }
    }, [(_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.checked]);
    const paymentProviderSettings = (() => {
        switch (paymentProvider) {
            case 'nets':
                return {
                    typeOfPayment: 'Kort',
                    logo: jsx("img", { src: img$2, alt: 'Nets' }),
                };
            case 'trustly':
                return {
                    typeOfPayment: 'Autogiro',
                    logo: jsx("img", { src: img$1, alt: 'Trustly' }),
                };
            default:
                return null;
        }
    })();
    return (jsxs(PaymentMethodLabel, Object.assign({ isChecked: isChecked }, { children: [jsx("div", { children: jsx(Input$2, { ref: inputRef, type: 'radio', name: 'paymentMethod', value: paymentProvider, onChange: onChange, checked: paymentProvider === selectedPaymentProvider }) }), jsxs(TextWrapper, { children: [jsx("span", { children: "Betala med" }), jsx("span", { children: paymentProviderSettings === null || paymentProviderSettings === void 0 ? void 0 : paymentProviderSettings.typeOfPayment })] }), jsx("div", { children: paymentProviderSettings === null || paymentProviderSettings === void 0 ? void 0 : paymentProviderSettings.logo })] })));
};
const PaymentMethodLabel = styled.label `
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
  border: 0.125rem solid
    ${({ isChecked }) => (isChecked ? '#20d8a9' : '#dedede')};
  background-color: ${({ isChecked }) => isChecked ? 'rgba(237, 252, 249, 0.8)' : 'rgba(245, 245, 245, 0.4)'};
  border-radius: 0.5rem;
  align-items: center;
  color: #444;
  cursor: pointer;

  div {
    line-height: 1;
  }

  img {
    width: auto;
    height: 1.2rem;
  }
`;
const TextWrapper = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;

  span {
    &:first-child {
      font-size: 0.8rem;
    }

    &:last-child {
      font-size: 1.2rem;
    }
  }
`;
const Input$2 = styled.input `
  height: 1.25rem;
  width: 1.25rem;
  padding: 0;
  appearance: none;
  border-radius: 50%;
  background-color: #f5f5f5;
  border: 0.1875rem solid #fff;
  box-shadow: 0 0 0 0.0625rem #dedede;

  &:checked {
    background-color: #20d8a9;
    box-shadow: 0 0 0 0.0625rem #1ecb9f;

    &:hover {
      background-color: #20d8a9;
      box-shadow: 0 0 0 0.0625rem #1ecb9f;
    }
  }

  &:hover {
    border: 0.1875rem solid #fff;
    box-shadow: 0 0 0 0.0625rem #dedede;
  }
`;

const Section = styled.section `
  background-color: var(--eir-partner-section-background-color);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  @media (min-width: 54rem) {
    border-radius: 0.5rem;
  }
`;

const Price = forwardRef(({ quote }, ref) => {
    const [paymentProvider, setPaymentProvider] = useState('trustly');
    const history = useHistory();
    const scaleAnimation = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: {
            duration: 200,
        },
    });
    const { number } = useSpring({
        from: { number: 0 },
        // number: response.premium.monthly,
        number: 987,
    });
    const handlePaymentProvoderChagne = (event) => setPaymentProvider(event.target.value);
    const handlePurchaseClick = () => history.push(`/pay/${paymentProvider}/${quote.id}`);
    return (jsxs(PriceSection, Object.assign({ ref: ref, style: scaleAnimation }, { children: [jsx("header", { children: jsx("h3", { children: "Ditt pris" }) }), jsxs(Main, { children: [jsxs(MonthlyPrice, { children: [jsx(animated.span, { children: number.to(n => n.toLocaleString('sv-SE', {
                                    maximumFractionDigits: 0,
                                    minimumFractionDigits: 0,
                                })) }), ' ', jsx("span", { children: "kr/m\u00E5nad" })] }), jsx(PaymentMethod, { paymentProvider: 'trustly', selectedPaymentProvider: paymentProvider, onChange: handlePaymentProvoderChagne }), jsx(PaymentMethod, { paymentProvider: 'nets', selectedPaymentProvider: paymentProvider, onChange: handlePaymentProvoderChagne }), jsx(ButtonWrapper$1, { children: jsx(Button, Object.assign({ size: 'medium', theme: 'green', onClick: handlePurchaseClick }, { children: "Teckna f\u00F6rs\u00E4kring" })) })] }), jsx(Footer, { children: jsx("p", { children: "* Den premie som visas bygger p\u00E5 ditt pris f\u00F6r 1 \u00E5rs f\u00F6rs\u00E4kring och delas sedan p\u00E5 12 m\u00E5nader. Din faktiska m\u00E5nadspremie ber\u00E4knas p\u00E5 exakt antal dagar i m\u00E5naden." }) })] })));
});
const PriceSection = styled(animated(Section)) `
  color: #fff;
  background: rgb(23, 161, 126);
  background: linear-gradient(
    133deg,
    rgba(31, 214, 168, 1) 0%,
    rgba(26, 179, 140, 1) 20%,
    rgba(23, 161, 126, 1) 100%
  );
  transform-origin: top;

  h3 {
    color: #fff;
  }

  main {
  }
`;
const MonthlyPrice = styled.span `
  font-size: 2.5rem;
  font-weight: 500;

  span {
    &:last-child {
      font-size: 1.5rem;
    }
  }
`;
const Main = styled.main `
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
const Footer = styled.footer `
  border-top: 0.0625rem solid #fff;
  padding-top: 0.5rem;
  p {
    font-size: 0.8rem;
  }
`;
const ButtonWrapper$1 = styled.div `
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`;

const response = {
    paymentMethodField: {
        fieldSchema: {
            contents: ['Monthly', 'Annually'],
            tag: 'OneOf',
        },
        defaultValue: 'Monthly',
        questionName: 'paymentMethod',
        section: {
            tag: 'MandatoryQuoteInputs',
        },
        friendlyName: 'paymentMethod',
        humanReadableName: 'Payment Schedule',
    },
    productFields: [
        {
            fieldSchema: {
                contents: { rFrom: 18, rTo: 100 },
                tag: 'ValueInRanges',
            },
            defaultValue: null,
            questionName: 'GUI_CustomerAge',
            section: {
                tag: 'ProductArguments',
            },
            friendlyName: 'customerAge',
            humanReadableName: 'Customer age',
        },
        {
            fieldSchema: {
                contents: ['true', 'false'],
                tag: 'OneOf',
            },
            defaultValue: null,
            questionName: 'OPT_Travel',
            section: {
                tag: 'ProductArguments',
            },
            friendlyName: 'optTravel',
            humanReadableName: 'Travel?',
        },
        {
            fieldSchema: {
                contents: [
                    '37495',
                    '19271',
                    '80260',
                    '18360',
                    '58238',
                    '61931',
                    '27238',
                    '53138',
                    '12843',
                    '43366',
                    '33141',
                    '11361',
                    '36256',
                    '43245',
                    '41458',
                    '24651',
                    '33491',
                    '87232',
                    '17543',
                    '19532',
                    '76151',
                    '59176',
                    '75240',
                    '26176',
                    '77491',
                    '86192',
                    '16847',
                    '16254',
                    '37145',
                    '42534',
                    '77141',
                    '23195',
                    '34333',
                    '71930',
                    '22369',
                    '16939',
                    '16838',
                    '54432',
                    '66532',
                    '51796',
                    '45140',
                    '19477',
                    '14771',
                    '89140',
                    '17460',
                    '12249',
                    '21623',
                    '84495',
                    '22477',
                    '88051',
                    '58955',
                    '18591',
                    '41876',
                    '78443',
                    '58595',
                    '27595',
                    '78193',
                    '23591',
                    '15392',
                    '57439',
                    '23162',
                    '64152',
                    '19433',
                    '25663',
                    '94494',
                    '77693',
                    '26437',
                    '91598',
                    '93086',
                    '46372',
                    '61830',
                    '71831',
                    '43443',
                    '25223',
                    '85652',
                    '47160',
                    '57341',
                    '74531',
                    '28341',
                    '15167',
                    '67041',
                    '16355',
                    '41706',
                    '51392',
                    '42736',
                    '57691',
                    '42435',
                    '76454',
                    '28691',
                    '51833',
                    '62448',
                    '26734',
                    '46732',
                    '54533',
                    '16452',
                    '46431',
                    '66433',
                    '81962',
                    '81841',
                    '37293',
                    '84091',
                    '78560',
                    '87030',
                    '19730',
                    '41265',
                    '41832',
                    '58562',
                    '73743',
                    '79332',
                    '14573',
                    '27562',
                    '83171',
                    '46237',
                    '17741',
                    '96193',
                    '73293',
                    '34131',
                    '97435',
                    '11848',
                    '30236',
                    '70232',
                    '93732',
                    '93431',
                    '41742',
                    '14133',
                    '83799',
                    '41661',
                    '42471',
                    '54630',
                    '66730',
                    '22235',
                    '62374',
                    '33378',
                    '21421',
                    '93237',
                    '58247',
                    '88150',
                    '79277',
                    '31196',
                    '68291',
                    '46134',
                    '29153',
                    '41302',
                    '42332',
                    '46273',
                    '84293',
                    '14230',
                    '13666',
                    '75446',
                    '76049',
                    '87131',
                    '44455',
                    '58393',
                    '51440',
                    '19631',
                    '27393',
                    '25461',
                    '26536',
                    '78391',
                    '93134',
                    '58724',
                    '16553',
                    '66840',
                    '79174',
                    '58643',
                    '11419',
                    '97332',
                    '56250',
                    '44895',
                    '35596',
                    '46170',
                    '94292',
                    '43139',
                    '39237',
                    '79233',
                    '79570',
                    '62275',
                    '60354',
                    '42174',
                    '41463',
                    '42673',
                    '18379',
                    '18278',
                    '39248',
                    '46530',
                    '54731',
                    '62176',
                    '66631',
                    '26572',
                    '93170',
                    '79130',
                    '13547',
                    '75327',
                    '12557',
                    '96139',
                    '59572',
                    '18638',
                    '73091',
                    '13439',
                    '72212',
                    '50472',
                    '13538',
                    '59132',
                    '57178',
                    '16964',
                    '26132',
                    '65465',
                    '81151',
                    '53460',
                    '14331',
                    '44941',
                    '42130',
                    '50331',
                    '57538',
                    '97233',
                    '28538',
                    '18764',
                    '11325',
                    '44253',
                    '31394',
                    '82592',
                    '11646',
                    '11765',
                    '72357',
                    '70380',
                    '90588',
                    '21227',
                    '61146',
                    '75644',
                    '83348',
                    '47197',
                    '61496',
                    '38593',
                    '31240',
                    '65227',
                    '59473',
                    '16751',
                    '22730',
                    '11242',
                    '70281',
                    '50634',
                    '27191',
                    '59374',
                    '41119',
                    '21618',
                    '13952',
                    '35244',
                    '68138',
                    '44150',
                    '78478',
                    '60211',
                    '57295',
                    '28295',
                    '67195',
                    '22480',
                    '12456',
                    '74236',
                    '30575',
                    '11127',
                    '21744',
                    '25658',
                    '19334',
                    '50670',
                    '59330',
                    '54137',
                    '25267',
                    '22271',
                    '62330',
                    '30272',
                    '18162',
                    '12052',
                    '45296',
                    '82240',
                    '45746',
                    '31161',
                    '54148',
                    '25218',
                    '83135',
                    '54234',
                    '34175',
                    '66334',
                    '13341',
                    '74171',
                    '57262',
                    '74632',
                    '28262',
                    '11523',
                    '68695',
                    '71596',
                    '37239',
                    '17266',
                    '18647',
                    '74896',
                    '65340',
                    '90746',
                    '37338',
                    '11444',
                    '14634',
                    '24750',
                    '47395',
                    '41346',
                    '75592',
                    '43164',
                    '73338',
                    '90342',
                    '34232',
                    '82161',
                    '38241',
                    '74942',
                    '23638',
                    '29168',
                    '45692',
                    '19136',
                    '50771',
                    '38791',
                    '59231',
                    '26231',
                    '92395',
                    '83531',
                    '21142',
                    '12153',
                    '15594',
                    '90621',
                    '85357',
                    '96164',
                    '98014',
                    '57493',
                    '17147',
                    '21834',
                    '71192',
                    '54335',
                    '13464',
                    '66235',
                    '12654',
                    '57143',
                    '74373',
                    '28143',
                    '71177',
                    '75432',
                    '11430',
                    '11531',
                    '67152',
                    '51434',
                    '25448',
                    '83567',
                    '81394',
                    '21136',
                    '18655',
                    '75234',
                    '13555',
                    '75335',
                    '59193',
                    '75269',
                    '12545',
                    '12639',
                    '26193',
                    '61198',
                    '59542',
                    '80250',
                    '83242',
                    '18350',
                    '71472',
                    '62193',
                    '74972',
                    '29194',
                    '50763',
                    '89134',
                    '82432',
                    '17449',
                    '19546',
                    '12260',
                    '57599',
                    '12949',
                    '11337',
                    '74361',
                    '28151',
                    '17155',
                    '21840',
                    '55337',
                    '16264',
                    '21532',
                    '21235',
                    '21369',
                    '61176',
                    '24562',
                    '45170',
                    '81538',
                    '76196',
                    '45897',
                    '17890',
                    '59391',
                    '26391',
                    '41129',
                    '12950',
                    '33153',
                    '68155',
                    '69594',
                    '43257',
                    '53199',
                    '24643',
                    '45530',
                    '17450',
                    '45431',
                    '17551',
                    '89530',
                    '35230',
                    '54295',
                    '11632',
                    '74297',
                    '11733',
                    '51276',
                    '19465',
                    '98107',
                    '31234',
                    '81196',
                    '21370',
                    '55632',
                    '71230',
                    '61132',
                    '90431',
                    '46397',
                    '71331',
                    '47150',
                    '12747',
                    '76394',
                    '45237',
                    '19340',
                    '41648',
                    '61734',
                    '25374',
                    '25275',
                    '13757',
                    '44294',
                    '64296',
                    '78451',
                    '52338',
                    '60238',
                    '61275',
                    '54240',
                    '66340',
                    '13252',
                    '74242',
                    '12343',
                    '15535',
                    '36345',
                    '77250',
                    '74693',
                    '46195',
                    '54161',
                    '43451',
                    '25231',
                    '62344',
                    '81592',
                    '31498',
                    '16347',
                    '91294',
                    '27156',
                    '51535',
                    '14640',
                    '79595',
                    '45732',
                    '35573',
                    '45633',
                    '46159',
                    '42346',
                    '61330',
                    '39591',
                    '88160',
                    '34293',
                    '73399',
                    '84012',
                    '93195',
                    '56792',
                    '83163',
                    '29792',
                    '64692',
                    '43080',
                    '17753',
                    '83693',
                    '90732',
                    '71991',
                    '79144',
                    '71133',
                    '97346',
                    '74491',
                    '98060',
                    '51470',
                    '25437',
                    '13151',
                    '51131',
                    '24339',
                    '21433',
                    '46591',
                    '58255',
                    '24494',
                    '56141',
                    '64360',
                    '46140',
                    '29141',
                    '52145',
                    '60364',
                    '19142',
                    '42144',
                    '87293',
                    '85460',
                    '19593',
                    '72138',
                    '97595',
                    '53155',
                    '63354',
                    '41534',
                    '70365',
                    '65598',
                    '86133',
                    '69145',
                    '14930',
                    '69392',
                    '93591',
                    '44447',
                    '14831',
                    '25473',
                    '93140',
                    '58750',
                    '94332',
                    '50497',
                    '22359',
                    '59146',
                    '16954',
                    '26146',
                    '16855',
                    '53450',
                    '37157',
                    '54493',
                    '66593',
                    '51737',
                    '89431',
                    '83361',
                    '82995',
                    '77153',
                    '61572',
                    '94534',
                    '76143',
                    '66142',
                    '51993',
                    '61033',
                    '43653',
                    '62146',
                    '18754',
                    '11348',
                    '72596',
                    '41471',
                    '41130',
                    '19791',
                    '21631',
                    '37452',
                    '73892',
                    '22465',
                    '14442',
                    '36543',
                    '14763',
                    '57454',
                    '45134',
                    '72222',
                    '50442',
                    '94471',
                    '44492',
                    '86331',
                    '92051',
                    '11236',
                    '23152',
                    '64162',
                    '76341',
                    '23053',
                    '98143',
                    '73113',
                    '72479',
                    '25671',
                    '51333',
                    '59344',
                    '54691',
                    '93027',
                    '36192',
                    '66791',
                    '35274',
                    '35229',
                    '46793',
                    '44160',
                    '44241',
                    '72345',
                    '91492',
                    '59740',
                    '26740',
                    '61231',
                    '11825',
                    '41277',
                    '14291',
                    '60247',
                    '79393',
                    '82775',
                    '93793',
                    '72460',
                    '50640',
                    '16743',
                    '79023',
                    '27453',
                    '21774',
                    '12738',
                    '23251',
                    '98341',
                    '41673',
                    '31137',
                    '22227',
                    '26874',
                    '12466',
                    '11135',
                    '11861',
                    '82630',
                    '24292',
                    '82731',
                    '25734',
                    '59597',
                    '52392',
                    '13656',
                    '79191',
                    '11429',
                    '45336',
                    '46261',
                    '85741',
                    '31173',
                    '59830',
                    '94233',
                    '55474',
                    '59931',
                    '80285',
                    '30242',
                    '26931',
                    '65631',
                    '12062',
                    '22593',
                    '24760',
                    '24441',
                    '42832',
                    '42933',
                    '31432',
                    '19258',
                    '57894',
                    '26267',
                    '18349',
                    '90336',
                    '71436',
                    '93261',
                    '57796',
                    '23931',
                    '19255',
                    '83256',
                    '18267',
                    '79150',
                    '38832',
                    '23344',
                    '12177',
                    '76175',
                    '17837',
                    '75239',
                    '13558',
                    '75264',
                    '12548',
                    '12634',
                    '81131',
                    '21526',
                    '16270',
                    '57167',
                    '37161',
                    '61195',
                    '78692',
                    '18694',
                    '77165',
                    '17163',
                    '21854',
                    '56634',
                    '38661',
                    '29634',
                    '45597',
                    '43836',
                    '63340',
                    '69630',
                    '70353',
                    '52173',
                    '60370',
                    '73835',
                    '42150',
                    '14755',
                    '56331',
                    '29331',
                    '17444',
                    '64231',
                    '15295',
                    '17567',
                    '57594',
                    '12944',
                    '89597',
                    '21643',
                    '12867',
                    '43342',
                    '89139',
                    '16863',
                    '17158',
                    '95431',
                    '84394',
                    '51295',
                    '59152',
                    '31293',
                    '16940',
                    '26152',
                    '55626',
                    '16731',
                    '81535',
                    '64132',
                    '51262',
                    '19453',
                    '21238',
                    '21364',
                    '24271',
                    '53194',
                    '44130',
                    '44233',
                    '58935',
                    '77596',
                    '95732',
                    '11741',
                    '69234',
                    '41124',
                    '78467',
                    '61243',
                    '64635',
                    '68194',
                    '16432',
                    '43296',
                    '43937',
                    '69731',
                    '19468',
                    '11222',
                    '91130',
                    '91992',
                    '91233',
                    '24172',
                    '59350',
                    '26350',
                    '16775',
                    '79015',
                    '63502',
                    '69432',
                    '98333',
                    '73363',
                    '41722',
                    '73196',
                    '27142',
                    '14153',
                    '38540',
                    '42455',
                    '56436',
                    '29436',
                    '43544',
                    '25278',
                    '54157',
                    '27492',
                    '62350',
                    '45391',
                    '16476',
                    '85236',
                    '18461',
                    '12331',
                    '57932',
                    '28932',
                    '44534',
                    '52335',
                    '82660',
                    '60235',
                    '69335',
                    '85733',
                    '97455',
                    '14557',
                    '29573',
                    '24433',
                    '31145',
                    '46198',
                    '84196',
                    '91534',
                    '62349',
                    '94205',
                    '31495',
                    '26943',
                    '12032',
                    '14168',
                    '91299',
                    '70216',
                    '71491',
                    '41766',
                    '46154',
                    '29177',
                    '41326',
                    '26251',
                    '44332',
                    '73394',
                    '13833',
                    '93198',
                    '53396',
                    '90641',
                    '13642',
                    '11460',
                    '74652',
                    '11543',
                    '29537',
                    '65339',
                    '97756',
                    '26655',
                    '93154',
                    '94593',
                    '16577',
                    '91332',
                    '42253',
                    '60387',
                    '24334',
                    '82495',
                    '80323',
                    '90322',
                    '34252',
                    '58227',
                    '68361',
                    '42149',
                    '41564',
                    '52137',
                    '63227',
                    '24631',
                    '82462',
                    '72135',
                    '97598',
                    '27294',
                    '62152',
                    '97253',
                    '38292',
                    '18740',
                    '53158',
                    '63359',
                    '74010',
                    '70368',
                    '60369',
                    '52234',
                    '69674',
                    '13563',
                    '74450',
                    '65595',
                    '21562',
                    '69148',
                    '12573',
                    '69137',
                    '45193',
                    '76131',
                    '13440',
                    '75220',
                    '16959',
                    '16858',
                    '24532',
                    '82998',
                    '57440',
                    '72483',
                    '22354',
                    '50456',
                    '19552',
                    '51691',
                    '13044',
                    '47292',
                    '11345',
                    '71693',
                    '88031',
                    '36531',
                    '59053',
                    '24235',
                    '13932',
                    '35260',
                    '33192',
                    '44174',
                    '22468',
                    '44277',
                    '38696',
                    '11662',
                    '95336',
                    '92292',
                    '77192',
                    '98131',
                    '71260',
                    '61162',
                    '44637',
                    '13761',
                    '11266',
                    '72474',
                    '24136',
                    '89391',
                    '43973',
                    '47540',
                    '72348',
                    '98232',
                    '72337',
                    '34151',
                    '12472',
                    '11828',
                    '33596',
                    '82679',
                    '11857',
                    '16371',
                    '73970',
                    '93451',
                    '29472',
                    '23542',
                    '45795',
                    '39356',
                    '25360',
                    '85632',
                    '59897',
                    '47144',
                    '12735',
                    '23830',
                    '43140',
                    '28833',
                    '88130',
                    '36430',
                    '86491',
                    '43490',
                    '95699',
                    '26978',
                    '57392',
                    '57833',
                    '21441',
                    '30256',
                    '18146',
                    '13246',
                    '11138',
                    '47494',
                    '81892',
                    '37240',
                    '81333',
                    '11147',
                    '54993',
                    '37363',
                    '14250',
                    '66893',
                    '52432',
                    '83155',
                    '17765',
                    '51493',
                    '21122',
                    '12133',
                    '80596',
                    '18496',
                    '61591',
                    '73790',
                    '81470',
                    '75426',
                    '11424',
                    '86141',
                    '87151',
                    '96140',
                    '92494',
                    '77794',
                    '56133',
                    '64330',
                    '29133',
                    '42941',
                    '80288',
                    '42352',
                    '13796',
                    '43159',
                    '22651',
                    '14654',
                    '56230',
                    '56134',
                    '29134',
                    '42355',
                    '13791',
                    '30248',
                    '18158',
                    '12068',
                    '14653',
                    '92493',
                    '77793',
                    '74961',
                    '28791',
                    '23936',
                    '19252',
                    '83251',
                    '18260',
                    '39250',
                    '90361',
                    '57791',
                    '57258',
                    '23343',
                    '51463',
                    '25442',
                    '13160',
                    '17830',
                    '59199',
                    '75263',
                    '12633',
                    '81136',
                    '75340',
                    '12530',
                    '74350',
                    '61192',
                    '78695',
                    '18693',
                    '92262',
                    '17164',
                    '21853',
                    '76172',
                    '56633',
                    '29633',
                    '64733',
                    '62199',
                    '62256',
                    '63347',
                    '41527',
                    '70354',
                    '52174',
                    '60377',
                    '73832',
                    '42157',
                    '14752',
                    '29336',
                    '17443',
                    '64236',
                    '76271',
                    '17560',
                    '57593',
                    '12943',
                    '21644',
                    '28593',
                    '43345',
                    '68391',
                    '68830',
                    '16864',
                    '36132',
                    '92341',
                    '84393',
                    '51292',
                    '59155',
                    '31294',
                    '21240',
                    '16736',
                    '43741',
                    '64135',
                    '78064',
                    '76334',
                    '78291',
                    '51265',
                    '19454',
                    '21363',
                    '53193',
                    '44137',
                    '37441',
                    '44234',
                    '36231',
                    '14451',
                    '29372',
                    '69233',
                    '41123',
                    '56732',
                    '29732',
                    '61244',
                    '64632',
                    '68193',
                    '16435',
                    '84562',
                    '43291',
                    '43930',
                    '11638',
                    '11739',
                    '81631',
                    '93896',
                    '78543',
                    '52376',
                    '78460',
                    '82953',
                    '11225',
                    '91995',
                    '91234',
                    '24175',
                    '26357',
                    '61138',
                    '37191',
                    '16772',
                    '27462',
                    '15144',
                    '63505',
                    '69435',
                    '98334',
                    '41725',
                    '73191',
                    '27145',
                    '14154',
                    '56431',
                    '29431',
                    '64531',
                    '43543',
                    '54150',
                    '43460',
                    '62357',
                    '16471',
                    '85231',
                    '44533',
                    '52332',
                    '82667',
                    '60232',
                    '59753',
                    '84441',
                    '69332',
                    '85734',
                    '97452',
                    '12349',
                    '36330',
                    '14550',
                    '29574',
                    '31142',
                    '84191',
                    '31492',
                    '26944',
                    '81730',
                    '70211',
                    '41761',
                    '46153',
                    '29170',
                    '41321',
                    '44335',
                    '73393',
                    '53391',
                    '13645',
                    '11544',
                    '17759',
                    '64430',
                    '46250',
                    '97751',
                    '13834',
                    '26652',
                    '93153',
                    '16570',
                    '27660',
                    '44432',
                    '91335',
                    '42254',
                    '90738',
                    '60380',
                    '50752',
                    '24333',
                    '82492',
                    '21439',
                    '80324',
                    '90325',
                    '34255',
                    '44371',
                    '58220',
                    '82142',
                    '44731',
                    '52130',
                    '63220',
                    '19269',
                    '24636',
                    '82465',
                    '42650',
                    '91432',
                    '72132',
                    '27293',
                    '62155',
                    '97254',
                    '80647',
                    '12237',
                    '19148',
                    '52233',
                    '69673',
                    '41563',
                    '65592',
                    '86139',
                    '21565',
                    '12574',
                    '59551',
                    '45194',
                    '75227',
                    '12677',
                    '57197',
                    '28197',
                    '24535',
                    '91731',
                    '72231',
                    '22353',
                    '50451',
                    '19555',
                    '51696',
                    '13043',
                    '47295',
                    '11342',
                    '71694',
                    '43266',
                    '24232',
                    '13935',
                    '33195',
                    '44173',
                    '44270',
                    '11665',
                    '95331',
                    '81576',
                    '92295',
                    '45163',
                    '72228',
                    '98136',
                    '61165',
                    '13766',
                    '21767',
                    '11261',
                    '72473',
                    '24131',
                    '89396',
                    '68597',
                    '35223',
                    '43974',
                    '11621',
                    '98235',
                    '62450',
                    '13971',
                    '17975',
                    '38493',
                    '12475',
                    '33591',
                    '12372',
                    '57971',
                    '28971',
                    '11850',
                    '29475',
                    '39351',
                    '25244',
                    '85635',
                    '26890',
                    '47143',
                    '12732',
                    '23837',
                    '16376',
                    '41679',
                    '42469',
                    '86496',
                    '89242',
                    '43497',
                    '57395',
                    '21446',
                    '30251',
                    '28395',
                    '18141',
                    '12071',
                    '43147',
                    '28834',
                    '13241',
                    '47493',
                    '81895',
                    '12431',
                    '74842',
                    '81334',
                    '11140',
                    '37364',
                    '66894',
                    '60209',
                    '24298',
                    '83152',
                    '84595',
                    '17762',
                    '51494',
                    '21125',
                    '12134',
                    '80591',
                    '52398',
                    '18491',
                    '61596',
                    '75421',
                    '11423',
                    '57241',
                    '67141',
                    '73247',
                    '96147',
                    '27533',
                    '92131',
                    '77231',
                    '78171',
                    '17732',
                    '34142',
                    '79493',
                    '18537',
                    '97439',
                    '18436',
                    '74146',
                    '62378',
                    '57376',
                    '28376',
                    '16362',
                    '41713',
                    '27173',
                    '77671',
                    '83795',
                    '23537',
                    '29407',
                    '43531',
                    '25351',
                    '70593',
                    '43430',
                    '25250',
                    '13736',
                    '55451',
                    '74597',
                    '61351',
                    '33374',
                    '24745',
                    '28637',
                    '53273',
                    '57736',
                    '54191',
                    '71897',
                    '46138',
                    '42363',
                    '24394',
                    '73631',
                    '14261',
                    '58577',
                    '73730',
                    '83146',
                    '38892',
                    '23331',
                    '78632',
                    '87142',
                    '73271',
                    '13130',
                    '18670',
                    '21157',
                    '17237',
                    '93138',
                    '81441',
                    '11415',
                    '86152',
                    '21586',
                    '36445',
                    '22642',
                    '53237',
                    '41317',
                    '26279',
                    '43135',
                    '93497',
                    '43896',
                    '81292',
                    '74740',
                    '82893',
                    '60358',
                    '80275',
                    '29641',
                    '18375',
                    '18274',
                    '43632',
                    '39244',
                    '18634',
                    '58731',
                    '79161',
                    '27731',
                    '27630',
                    '46291',
                    '23375',
                    '14951',
                    '98045',
                    '96135',
                    '51455',
                    '25456',
                    '13174',
                    '59693',
                    '64831',
                    '92276',
                    '26693',
                    '64192',
                    '17170',
                    '72243',
                    '13435',
                    '79691',
                    '13534',
                    '26163',
                    '53431',
                    '57174',
                    '16968',
                    '65469',
                    '58371',
                    '73532',
                    '14342',
                    '38333',
                    '41511',
                    '70340',
                    '11329',
                    '44932',
                    '52160',
                    '36296',
                    '42161',
                    '82453',
                    '38773',
                    '95792',
                    '93291',
                    '50342',
                    '62242',
                    '57534',
                    '44833',
                    '28534',
                    '18768',
                    '53170',
                    '43236',
                    '41481',
                    '14746',
                    '89155',
                    '89054',
                    '11769',
                    '74795',
                    '43337',
                    '59127',
                    '16971',
                    '16870',
                    '37136',
                    '58335',
                    '27335',
                    '42565',
                    '75648',
                    '91932',
                    '50467',
                    '50638',
                    '64596',
                    '94151',
                    '22761',
                    '58432',
                    '27432',
                    '64147',
                    '87340',
                    '34395',
                    '69492',
                    '19440',
                    '73136',
                    '57992',
                    '23436',
                    '28992',
                    '41115',
                    '21614',
                    '35248',
                    '93695',
                    '68134',
                    '17068',
                    '33572',
                    '53372',
                    '52362',
                    '74139',
                    '41252',
                    '78474',
                    '51840',
                    '16447',
                    '66440',
                    '47535',
                    '11257',
                    '21748',
                    '25654',
                    '59361',
                    '26361',
                    '16766',
                    '54144',
                    '62361',
                    '30223',
                    '18133',
                    '70227',
                    '15150',
                    '44392',
                    '41757',
                    '14140',
                    '27137',
                    '41656',
                    '77635',
                    '59491',
                    '42446',
                    '26491',
                    '77734',
                    '82750',
                    '83139',
                    '78168',
                    '76018',
                    '13233',
                    '13332',
                    '28947',
                    '60226',
                    '81494',
                    '28233',
                    '67133',
                    '11448',
                    '72692',
                    '66495',
                    '37235',
                    '74193',
                    '37334',
                    '13673',
                    '75453',
                    '43168',
                    '73334',
                    '14638',
                    '28673',
                    '57772',
                    '47399',
                    '28772',
                    '98494',
                    '33231',
                    '30267',
                    '12047',
                    '55448',
                    '33330',
                    '53530',
                    '34263',
                    '38232',
                    '56830',
                    '23735',
                    '64930',
                    '46165',
                    '23634',
                    '59242',
                    '26242',
                    '21113',
                    '30597',
                    '17273',
                    '92399',
                    '90753',
                    '90652',
                    '13637',
                    '11451',
                    '11550',
                    '96168',
                    '24592',
                    '93165',
                    '21838',
                    '55329',
                    '16564',
                    '21553',
                    '68633',
                    '38276',
                    '47232',
                    '52294',
                    '18331',
                    '17677',
                    '18230',
                    '76292',
                    '58234',
                    '47333',
                    '27234',
                    '33132',
                    '53134',
                    '45991',
                    '41555',
                    '63234',
                    '41454',
                    '38737',
                    '14739',
                    '87263',
                    '79295',
                    '23199',
                    '12641',
                    '13570',
                    '75310',
                    '67331',
                    '12560',
                    '67230',
                    '16258',
                    '37149',
                    '25483',
                    '83597',
                    '42538',
                    '92232',
                    '77132',
                    '55312',
                    '54393',
                    '24196',
                    '16935',
                    '74391',
                    '43733',
                    '16834',
                    '75651',
                    '57471',
                    '98292',
                    '12931',
                    '80635',
                    '12245',
                    '12830',
                    '18735',
                    '33176',
                    '37433',
                    '11356',
                    '37532',
                    '98203',
                    '73433',
                    '58599',
                    '35251',
                    '17071',
                    '44145',
                    '68431',
                    '68530',
                    '94148',
                    '83391',
                    '57435',
                    '23133',
                    '28435',
                    '45155',
                    '51253',
                    '42439',
                    '64543',
                    '91594',
                    '47131',
                    '57332',
                    '21751',
                    '28332',
                    '68071',
                    '52492',
                    '41269',
                    '60592',
                    '62444',
                    '26738',
                    '17996',
                    '47470',
                    '81832',
                    '78430',
                    '41262',
                    '41835',
                    '60599',
                    '82760',
                    '26733',
                    '46735',
                    '54534',
                    '16455',
                    '66434',
                    '81965',
                    '37294',
                    '11830',
                    '84096',
                    '27538',
                    '58565',
                    '73744',
                    '79335',
                    '14574',
                    '17739',
                    '83176',
                    '46230',
                    '17746',
                    '96194',
                    '73294',
                    '34136',
                    '79498',
                    '97432',
                    '37263',
                    '30231',
                    '41718',
                    '70235',
                    '27178',
                    '41745',
                    '14134',
                    '41666',
                    '95250',
                    '70598',
                    '53296',
                    '31441',
                    '21459',
                    '21426',
                    '58240',
                    '51593',
                    '31191',
                    '82832',
                    '54893',
                    '46133',
                    '29154',
                    '41305',
                    '97775',
                    '84294',
                    '13661',
                    '75441',
                    '38899',
                    '11560',
                    '69150',
                    '14943',
                    '44452',
                    '58394',
                    '19636',
                    '27394',
                    '25466',
                    '59531',
                    '38392',
                    '26531',
                    '59632',
                    '26632',
                    '93133',
                    '58723',
                    '16554',
                    '79173',
                    '58644',
                    '97335',
                    '79234',
                    '44892',
                    '35591',
                    '46177',
                    '45930',
                    '94295',
                    '50732',
                    '26272',
                    '39230',
                    '22649',
                    '62171',
                    '82191',
                    '63363',
                    '60353',
                    '51197',
                    '42173',
                    '41464',
                    '82441',
                    '42674',
                    '43639',
                    '59575',
                    '26575',
                    '91892',
                    '93177',
                    '79137',
                    '13540',
                    '75320',
                    '74330',
                    '26698',
                    '64199',
                    '72215',
                    '50475',
                    '59135',
                    '16963',
                    '26135',
                    '65462',
                    '14897',
                    '38338',
                    '41547',
                    '42137',
                    '95799',
                    '19571',
                    '50336',
                    '97234',
                    '62236',
                    '18763',
                    '11322',
                    '86591',
                    '44254',
                    '38440',
                    '31393',
                    '82595',
                    '11641',
                    '11762',
                    '72350',
                    '41107',
                    '62430',
                    '77461',
                    '65459',
                    '21220',
                    '75643',
                    '47190',
                    '59373',
                    '38594',
                    '26373',
                    '65220',
                    '59474',
                    '58439',
                    '16756',
                    '11218',
                    '69499',
                    '11245',
                    '45831',
                    '70286',
                    '15241',
                    '11726',
                    '13955',
                    '77290',
                    '35243',
                    '17063',
                    '44157',
                    '11759',
                    '74231',
                    '30572',
                    '11120',
                    '18442',
                    '41259',
                    '60216',
                    '57292',
                    '28292',
                    '67192',
                    '26777',
                    '82393',
                    '12451',
                    '13742',
                    '21743',
                    '68063',
                    '19333',
                    '59337',
                    '26337',
                    '64551',
                    '46331',
                    '54130',
                    '30228',
                    '18138',
                    '62337',
                    '30275',
                    '18165',
                    '12055',
                    '45291',
                    '89301',
                    '45741',
                    '45662',
                    '83132',
                    '54233',
                    '13238',
                    '34172',
                    '66333',
                    '13339',
                    '80425',
                    '11164',
                    '12356',
                    '37340',
                    '93331',
                    '11443',
                    '74635',
                    '28265',
                    '11524',
                    '68692',
                    '71591',
                    '17261',
                    '18640',
                    '74891',
                    '65347',
                    '90741',
                    '43163',
                    '14633',
                    '47392',
                    '42371',
                    '75595',
                    '26236',
                    '43851',
                    '90345',
                    '34235',
                    '61972',
                    '38239',
                    '28540',
                    '38246',
                    '74945',
                    '19232',
                    '38796',
                    '94691',
                    '21118',
                    '17278',
                    '13144',
                    '21145',
                    '12154',
                    '93991',
                    '15593',
                    '90626',
                    '85350',
                    '79630',
                    '53490',
                    '98013',
                    '14860',
                    '57494',
                    '21833',
                    '55322',
                    '76112',
                    '71195',
                    '54332',
                    '66131',
                    '13463',
                    '66232',
                    '21558',
                    '12653',
                    '74374',
                    '28144',
                    '43792',
                    '53140',
                    '37492',
                    '70370',
                    '19276',
                    '80267',
                    '18367',
                    '54772',
                    '61936',
                    '79533',
                    '80627',
                    '12844',
                    '43361',
                    '68140',
                    '11366',
                    '36251',
                    '43242',
                    '14431',
                    '14732',
                    '87235',
                    '17544',
                    '19535',
                    '73492',
                    '34334',
                    '50431',
                    '59171',
                    '26171',
                    '86195',
                    '16840',
                    '16253',
                    '37142',
                    '42533',
                    '23192',
                    '19470',
                    '66298',
                    '73142',
                    '43738',
                    '54435',
                    '66535',
                    '51791',
                    '73061',
                    '23442',
                    '98299',
                    '41143',
                    '37438',
                    '21624',
                    '84492',
                    '43279',
                    '58952',
                    '79432',
                    '15258',
                    '73438',
                    '41871',
                    '78444',
                    '58592',
                    '27592',
                    '78194',
                    '46472',
                    '15395',
                    '94143',
                    '81569',
                    '23138',
                    '23165',
                    '19434',
                    '25664',
                    '94493',
                    '59430',
                    '76453',
                    '54673',
                    '93081',
                    '46375',
                    '43444',
                    '25224',
                    '57339',
                    '74536',
                    '15160',
                    '16352',
                    '73340',
                    '41701',
                    '14170',
                    '51395',
                    '57696',
                    '42432',
                    '71392',
                    '54171',
                    '61832',
                    '71833',
                    '43441',
                    '25221',
                    '85650',
                    '47162',
                    '57343',
                    '74533',
                    '28343',
                    '15165',
                    '67043',
                    '16357',
                    '41704',
                    '14175',
                    '42734',
                    '57693',
                    '42437',
                    '76456',
                    '41267',
                    '41830',
                    '51831',
                    '26736',
                    '17998',
                    '46730',
                    '54531',
                    '46433',
                    '66431',
                    '81843',
                    '37291',
                    '84093',
                    '78562',
                    '87032',
                    '44556',
                    '19732',
                    '73741',
                    '79330',
                    '14571',
                    '83173',
                    '46235',
                    '17743',
                    '96191',
                    '54272',
                    '73291',
                    '34133',
                    '18539',
                    '97437',
                    '18438',
                    '30234',
                    '70230',
                    '23241',
                    '69450',
                    '41740',
                    '51561',
                    '14131',
                    '41663',
                    '23539',
                    '23791',
                    '53293',
                    '54632',
                    '66732',
                    '13738',
                    '22237',
                    '62376',
                    '74599',
                    '21423',
                    '93235',
                    '58245',
                    '88152',
                    '79275',
                    '57738',
                    '31194',
                    '56151',
                    '68293',
                    '29151',
                    '61292',
                    '85751',
                    '90788',
                    '84291',
                    '14232',
                    '13664',
                    '75444',
                    '83148',
                    '55592',
                    '23362',
                    '87133',
                    '58391',
                    '51442',
                    '19633',
                    '27391',
                    '25463',
                    '59534',
                    '21159',
                    '17239',
                    '26534',
                    '78393',
                    '93136',
                    '58726',
                    '79176',
                    '38850',
                    '79231',
                    '35594',
                    '41319',
                    '43898',
                    '39235',
                    '44350',
                    '62174',
                    '82194',
                    '93631',
                    '60356',
                    '19248',
                    '51192',
                    '41461',
                    '82444',
                    '42671',
                    '43643',
                    '79132',
                    '13545',
                    '75325',
                    '12555',
                    '74335',
                    '25458',
                    '59570',
                    '72210',
                    '50470',
                    '59130',
                    '16966',
                    '26130',
                    '65467',
                    '81153',
                    '53462',
                    '93532',
                    '14892',
                    '92278',
                    '41542',
                    '44943',
                    '42132',
                    '50333',
                    '97231',
                    '18766',
                    '11327',
                    '36298',
                    '70382',
                    '44251',
                    '31396',
                    '11644',
                    '11767',
                    '72355',
                    '41102',
                    '43339',
                    '43238',
                    '83775',
                    '37138',
                    '74386',
                    '21225',
                    '61144',
                    '75646',
                    '47195',
                    '72209',
                    '61494',
                    '59376',
                    '38591',
                    '26376',
                    '65225',
                    '59471',
                    '26471',
                    '16753',
                    '22732',
                    '23179',
                    '64149',
                    '11240',
                    '70283',
                    '50636',
                    '27193',
                    '15244',
                    '13950',
                    '92195',
                    '35246',
                    '17066',
                    '39477',
                    '43955',
                    '23438',
                    '28950',
                    '60213',
                    '57297',
                    '26772',
                    '22482',
                    '12454',
                    '74234',
                    '30577',
                    '11259',
                    '21746',
                    '45870',
                    '19336',
                    '59332',
                    '26332',
                    '46334',
                    '54135',
                    '62332',
                    '30270',
                    '70229',
                    '18160',
                    '12050',
                    '45294',
                    '27139',
                    '41658',
                    '42448',
                    '31163',
                    '83137',
                    '54236',
                    '34177',
                    '13343',
                    '11161',
                    '12353',
                    '37345',
                    '93334',
                    '60228',
                    '82792',
                    '11446',
                    '57260',
                    '74630',
                    '11521',
                    '67160',
                    '68697',
                    '45340',
                    '71594',
                    '17264',
                    '18645',
                    '74894',
                    '65342',
                    '43166',
                    '14636',
                    '24752',
                    '47397',
                    '89340',
                    '30269',
                    '55446',
                    '21467',
                    '43854',
                    '90340',
                    '34230',
                    '82163',
                    '38243',
                    '74940',
                    '19134',
                    '38793',
                    '59992',
                    '26992',
                    '26233',
                    '13141',
                    '92397',
                    '83533',
                    '21140',
                    '12151',
                    '93994',
                    '13639',
                    '75419',
                    '53495',
                    '98016',
                    '83335',
                    '57491',
                    '28491',
                    '17145',
                    '21836',
                    '54337',
                    '13466',
                    '66237',
                    '57141',
                    '68495',
                    '74371',
                    '28141',
                    '74731',
                    '70375',
                    '52155',
                    '19273',
                    '80262',
                    '18362',
                    '61933',
                    '79536',
                    '82158',
                    '74959',
                    '12841',
                    '43364',
                    '33143',
                    '11363',
                    '36254',
                    '43247',
                    '87230',
                    '17541',
                    '19530',
                    '76153',
                    '50434',
                    '59174',
                    '75242',
                    '77493',
                    '74432',
                    '16845',
                    '16256',
                    '37147',
                    '42536',
                    '77143',
                    '23197',
                    '21872',
                    '34331',
                    '71932',
                    '51930',
                    '83731',
                    '54430',
                    '90421',
                    '66530',
                    '51794',
                    '45142',
                    '19475',
                    '89142',
                    '17462',
                    '11358',
                    '21621',
                    '84497',
                    '22475',
                    '58957',
                    '18593',
                    '45492',
                    '41874',
                    '78441',
                    '58597',
                    '83432',
                    '78191',
                    '23593',
                    '94146',
                    '92041',
                    '64150',
                    '19431',
                    '96203',
                    '25661',
                    '77691',
                    '26435',
                    '51630',
                    '62467',
                    '35236',
                    '54293',
                    '16439',
                    '47552',
                    '11634',
                    '74291',
                    '11735',
                    '15270',
                    '81541',
                    '19463',
                    '11229',
                    '73151',
                    '31232',
                    '21376',
                    '61134',
                    '12741',
                    '74561',
                    '76392',
                    '45231',
                    '15148',
                    '63509',
                    '41729',
                    '14158',
                    '61732',
                    '61633',
                    '46461',
                    '44292',
                    '93391',
                    '41840',
                    '46740',
                    '61273',
                    '71531',
                    '37252',
                    '74831',
                    '37353',
                    '14242',
                    '15533',
                    '79340',
                    '74695',
                    '24438',
                    '46830',
                    '46193',
                    '54167',
                    '25237',
                    '62342',
                    '81594',
                    '70240',
                    '15173',
                    '12039',
                    '63510',
                    '16341',
                    '98303',
                    '41730',
                    '93461',
                    '14163',
                    '91292',
                    '27150',
                    '51533',
                    '44339',
                    '14646',
                    '35575',
                    '51173',
                    '42340',
                    '61336',
                    '39597',
                    '93193',
                    '93931',
                    '14567',
                    '13649',
                    '83165',
                    '29794',
                    '64694',
                    '11548',
                    '17755',
                    '94631',
                    '83695',
                    '12147',
                    '21174',
                    '90734',
                    '79142',
                    '71135',
                    '66191',
                    '74497',
                    '87161',
                    '42258',
                    '13157',
                    '21435',
                    '46597',
                    '58253',
                    '90329',
                    '29147',
                    '52143',
                    '60362',
                    '19144',
                    '42142',
                    '77551',
                    '87295',
                    '85466',
                    '19595',
                    '97593',
                    '53153',
                    '63352',
                    '41532',
                    '70363',
                    '56596',
                    '13568',
                    '75308',
                    '86135',
                    '21569',
                    '69143',
                    '69394',
                    '72620',
                    '44441',
                    '25475',
                    '93146',
                    '45198',
                    '50491',
                    '16952',
                    '26140',
                    '16853',
                    '37151',
                    '15371',
                    '77155',
                    '61574',
                    '94532',
                    '76145',
                    '51995',
                    '43655',
                    '91441',
                    '19559',
                    '62140',
                    '62261',
                    '18752',
                    '72590',
                    '63217',
                    '41477',
                    '82470',
                    '38750',
                    '31333',
                    '38651',
                    '41136',
                    '52196',
                    '58941',
                    '14444',
                    '45132',
                    '72224',
                    '50444',
                    '44494',
                    '15335',
                    '36194',
                    '86337',
                    '11230',
                    '23154',
                    '64164',
                    '98145',
                    '73115',
                    '51335',
                    '59342',
                    '94136',
                    '35272',
                    '90132',
                    '46795',
                    '44247',
                    '11771',
                    '72343',
                    '91494',
                    '98239',
                    '61237',
                    '84085',
                    '11823',
                    '52341',
                    '41271',
                    '82672',
                    '60241',
                    '82773',
                    '93795',
                    '72466',
                    '50646',
                    '44696',
                    '16745',
                    '79025',
                    '25248',
                    '21772',
                    '30291',
                    '68052',
                    '15137',
                    '41675',
                    '95243',
                    '42465',
                    '31131',
                    '59872',
                    '22221',
                    '26872',
                    '95692',
                    '26973',
                    '57399',
                    '12460',
                    '30561',
                    '18451',
                    '11867',
                    '82636',
                    '24294',
                    '17960',
                    '25732',
                    '84599',
                    '59591',
                    '21129',
                    '12138',
                    '52394',
                    '13650',
                    '74640',
                    '45330',
                    '31175',
                    '89231',
                    '56138',
                    '29138',
                    '59836',
                    '94235',
                    '55472',
                    '80283',
                    '42359',
                    '30244',
                    '26937',
                    '65637',
                    '12064',
                    '89330',
                    '57751',
                    '42834',
                    '42935',
                    '31434',
                    '57892',
                    '26261',
                    '90330',
                    '71430',
                    '58217',
                    '82131',
                    '95296',
                    '75434',
                    '11436',
                    '11537',
                    '51432',
                    '83561',
                    '21130',
                    '18653',
                    '66832',
                    '17168',
                    '13452',
                    '75232',
                    '13553',
                    '75333',
                    '59195',
                    '12543',
                    '21570',
                    '59544',
                    '80256',
                    '83244',
                    '18356',
                    '18257',
                    '62195',
                    '56192',
                    '29192',
                    '86531',
                    '70358',
                    '50765',
                    '89132',
                    '82434',
                    '19540',
                    '13056',
                    '12266',
                    '74046',
                    '11331',
                    '21648',
                    '43349',
                    '16868',
                    '77010',
                    '17153',
                    '21846',
                    '55331',
                    '61530',
                    '61431',
                    '12626',
                    '16262',
                    '31298',
                    '21534',
                    '21233',
                    '61170',
                    '24564',
                    '45176',
                    '45891',
                    '64139',
                    '78068',
                    '59397',
                    '90572',
                    '12956',
                    '83497',
                    '43350',
                    '33155',
                    '68153',
                    '69592',
                    '43251',
                    '44238',
                    '22458',
                    '17456',
                    '17557',
                    '12953',
                    '33150',
                    '69597',
                    '43254',
                    '45533',
                    '17453',
                    '45432',
                    '76261',
                    '17552',
                    '62462',
                    '35233',
                    '43298',
                    '11631',
                    '74294',
                    '11730',
                    '81544',
                    '19466',
                    '73154',
                    '81195',
                    '21373',
                    '55631',
                    '71233',
                    '61131',
                    '90432',
                    '46394',
                    '71332',
                    '61892',
                    '12744',
                    '45234',
                    '98195',
                    '73198',
                    '96298',
                    '29438',
                    '25276',
                    '13754',
                    '46464',
                    '44297',
                    '16478',
                    '85238',
                    '29395',
                    '64295',
                    '15231',
                    '78452',
                    '73451',
                    '61276',
                    '54243',
                    '43993',
                    '66343',
                    '13251',
                    '74241',
                    '14559',
                    '86233',
                    '41768',
                    '46196',
                    '54162',
                    '43452',
                    '25232',
                    '62347',
                    '81591',
                    '28350',
                    '16344',
                    '45270',
                    '91297',
                    '70218',
                    '27155',
                    '79596',
                    '45731',
                    '41328',
                    '61333',
                    '34290',
                    '93196',
                    '56791',
                    '83160',
                    '29791',
                    '64691',
                    '43083',
                    '17750',
                    '29539',
                    '21171',
                    '90731',
                    '71992',
                    '90630',
                    '79147',
                    '71130',
                    '66194',
                    '36393',
                    '97345',
                    '74492',
                    '98063',
                    '13152',
                    '81793',
                    '21430',
                    '58256',
                    '58229',
                    '56142',
                    '46143',
                    '29142',
                    '19141',
                    '42147',
                    '63229',
                    '77554',
                    '42659',
                    '85463',
                    '97596',
                    '53156',
                    '63357',
                    '41537',
                    '70366',
                    '52146',
                    '60367',
                    '56593',
                    '69146',
                    '14933',
                    '69391',
                    '93592',
                    '44444',
                    '14832',
                    '25470',
                    '59558',
                    '94331',
                    '50494',
                    '50458',
                    '16957',
                    '26145',
                    '16856',
                    '37154',
                    '51734',
                    '94199',
                    '42543',
                    '82996',
                    '77150',
                    '61571',
                    '76140',
                    '66141',
                    '51990',
                    '59145',
                    '43650',
                    '62145',
                    '41573',
                    '23940',
                    '72595',
                    '41472',
                    '41133',
                    '19792',
                    '59796',
                    '21632',
                    '37451',
                    '52193',
                    '73891',
                    '88040',
                    '22466',
                    '14760',
                    '51770',
                    '72221',
                    '50441',
                    '94472',
                    '81140',
                    '69193',
                    '44491',
                    '15330',
                    '86332',
                    '11235',
                    '23151',
                    '64161',
                    '76342',
                    '98140',
                    '73110',
                    '24165',
                    '31273',
                    '24138',
                    '54692',
                    '94133',
                    '36191',
                    '90137',
                    '44163',
                    '44242',
                    '29340',
                    '11628',
                    '72346',
                    '91491',
                    '72339',
                    '84451',
                    '61232',
                    '84080',
                    '11826',
                    '52344',
                    '41274',
                    '82677',
                    '11859',
                    '60244',
                    '79390',
                    '82776',
                    '59743',
                    '72463',
                    '50643',
                    '44693',
                    '16740',
                    '39358',
                    '79020',
                    '27450',
                    '30294',
                    '18148',
                    '12078',
                    '41670',
                    '31134',
                    '22224',
                    '26877',
                    '26976',
                    '30258',
                    '23252',
                    '15132',
                    '12465',
                    '13248',
                    '30564',
                    '11136',
                    '11862',
                    '91693',
                    '11149',
                    '24291',
                    '82732',
                    '17965',
                    '59594',
                    '80598',
                    '52391',
                    '13655',
                    '79192',
                    '75428',
                    '45335',
                    '85742',
                    '89234',
                    '26833',
                    '59932',
                    '80286',
                    '83294',
                    '30241',
                    '26932',
                    '65632',
                    '18151',
                    '12061',
                    '24763',
                    '31170',
                    '57798',
                    '42831',
                    '42930',
                    '31431',
                    '26264',
                    '90335',
                    '71435',
                    '44361',
                    '18269',
                    '58212',
                    '82134',
                    '95293',
                    '74935',
                    '75431',
                    '11433',
                    '57251',
                    '11532',
                    '67151',
                    '83564',
                    '21135',
                    '18656',
                    '90728',
                    '17839',
                    '75237',
                    '75336',
                    '59190',
                    '12546',
                    '57169',
                    '59541',
                    '80253',
                    '83241',
                    '18353',
                    '18252',
                    '43838',
                    '74971',
                    '29197',
                    '50760',
                    '82530',
                    '19545',
                    '17569',
                    '12263',
                    '89599',
                    '11334',
                    '12869',
                    '44950',
                    '89137',
                    '82431',
                    '28152',
                    '27357',
                    '83359',
                    '17156',
                    '55334',
                    '61434',
                    '75273',
                    '16267',
                    '74362',
                    '55628',
                    '24561',
                    '45173',
                    '45894',
                    '17893',
                    '59392',
                    '26392',
                    '21236',
                    '61175',
                    '21242',
                    '94165',
                    '45178',
                    '64137',
                    '78066',
                    '19456',
                    '21361',
                    '83499',
                    '53191',
                    '44135',
                    '44236',
                    '22456',
                    '89178',
                    '17458',
                    '69231',
                    '41121',
                    '78462',
                    '35238',
                    '56730',
                    '86292',
                    '61246',
                    '64630',
                    '68191',
                    '16437',
                    '43293',
                    '43932',
                    '93894',
                    '87011',
                    '52374',
                    '82951',
                    '11227',
                    '23143',
                    '91135',
                    '31261',
                    '37193',
                    '27460',
                    '15146',
                    '63507',
                    '69437',
                    '73931',
                    '98336',
                    '41727',
                    '73193',
                    '14156',
                    '42450',
                    '56433',
                    '76431',
                    '29433',
                    '64533',
                    '43541',
                    '54152',
                    '41390',
                    '62355',
                    '16473',
                    '18464',
                    '12334',
                    '52330',
                    '60230',
                    '69330',
                    '94640',
                    '14552',
                    '56576',
                    '24436',
                    '31140',
                    '84193',
                    '45644',
                    '91531',
                    '70213',
                    '71494',
                    '41763',
                    '24735',
                    '98431',
                    '46151',
                    '41323',
                    '55438',
                    '61338',
                    '26254',
                    '73391',
                    '14648',
                    '14569',
                    '13647',
                    '56532',
                    '11546',
                    '29532',
                    '64432',
                    '46252',
                    '14992',
                    '97753',
                    '13836',
                    '93151',
                    '16572',
                    '58662',
                    '44430',
                    '42256',
                    '12149',
                    '50750',
                    '24331',
                    '90327',
                    '93252',
                    '44373',
                    '58222',
                    '56149',
                    '82140',
                    '29149',
                    '41561',
                    '44733',
                    '52132',
                    '63222',
                    '69572',
                    '24634',
                    '82467',
                    '42652',
                    '85468',
                    '72130',
                    '27291',
                    '62157',
                    '80645',
                    '18745',
                    '52231',
                    '21567',
                    '69132',
                    '59553',
                    '93148',
                    '45196',
                    '58758',
                    '76134',
                    '75225',
                    '57195',
                    '28195',
                    '67295',
                    '94192',
                    '24537',
                    '72233',
                    '22351',
                    '50453',
                    '19557',
                    '51694',
                    '13041',
                    '47297',
                    '11340',
                    '63219',
                    '43264',
                    '41479',
                    '42669',
                    '41138',
                    '24230',
                    '35265',
                    '33197',
                    '52198',
                    '44171',
                    '44272',
                    '38693',
                    '11667',
                    '95333',
                    '45161',
                    '98134',
                    '61167',
                    '44632',
                    '13764',
                    '21765',
                    '11263',
                    '45204',
                    '72471',
                    '24133',
                    '26452',
                    '94138',
                    '13973',
                    '35221',
                    '44249',
                    '47545',
                    '11623',
                    '98237',
                    '82692',
                    '62452',
                    '38491',
                    '33593',
                    '28973',
                    '11852',
                    '50648',
                    '45240',
                    '29477',
                    '39353',
                    '25246',
                    '59892',
                    '47141',
                    '12730',
                    '23835',
                    '72468',
                    '16374',
                    '88135',
                    '24771',
                    '95232',
                    '89240',
                    '43495',
                    '55465',
                    '57397',
                    '21444',
                    '30253',
                    '15139',
                    '18143',
                    '43145',
                    '13243',
                    '47491',
                    '12433',
                    '74840',
                    '81336',
                    '11869',
                    '37366',
                    '92141',
                    '83150',
                    '84597',
                    '17760',
                    '21127',
                    '12136',
                    '18493',
                    '61594',
                    '75423',
                    '11421',
                    '46269',
                    '73245',
                    '87154',
                    '96145',
                    '56136',
                    '29136',
                    '59838',
                    '42944',
                    '13793',
                    '26939',
                    '65639',
                    '22654',
                    '77791',
                    '74963',
                    '28793',
                    '23934',
                    '89196',
                    '83253',
                    '18341',
                    '18262',
                    '58219',
                    '90363',
                    '57793',
                    '79155',
                    '11438',
                    '11539',
                    '81431',
                    '23341',
                    '51461',
                    '25440',
                    '17832',
                    '54350',
                    '75261',
                    '66250',
                    '12631',
                    '81134',
                    '75342',
                    '12532',
                    '57162',
                    '37164',
                    '61190',
                    '78697',
                    '18691',
                    '77160',
                    '17166',
                    '21851',
                    '18358',
                    '56631',
                    '38664',
                    '29631',
                    '64731',
                    '45592',
                    '43833',
                    '62254',
                    '63345',
                    '23691',
                    '41525',
                    '70356',
                    '60375',
                    '73830',
                    '80258',
                    '14750',
                    '89161',
                    '29334',
                    '17441',
                    '69275',
                    '64234',
                    '17562',
                    '57591',
                    '12941',
                    '89592',
                    '21646',
                    '28591',
                    '12862',
                    '43347',
                    '68393',
                    '90592',
                    '16866',
                    '36130',
                    '95434',
                    '84391',
                    '51290',
                    '12628',
                    '31296',
                    '81170',
                    '18636',
                    '58733',
                    '13549',
                    '75329',
                    '12559',
                    '46293',
                    '44460',
                    '96137',
                    '25454',
                    '59691',
                    '78335',
                    '26691',
                    '17172',
                    '72241',
                    '78234',
                    '76164',
                    '13437',
                    '59161',
                    '75257',
                    '13536',
                    '26161',
                    '16243',
                    '57176',
                    '14340',
                    '38331',
                    '41513',
                    '70342',
                    '44930',
                    '52162',
                    '36294',
                    '42163',
                    '82451',
                    '38771',
                    '93293',
                    '62240',
                    '57536',
                    '44831',
                    '28536',
                    '43234',
                    '41483',
                    '14744',
                    '81694',
                    '11648',
                    '66695',
                    '72359',
                    '43335',
                    '16973',
                    '77468',
                    '16872',
                    '90586',
                    '37134',
                    '21229',
                    '58337',
                    '91831',
                    '50465',
                    '61498',
                    '65229',
                    '29494',
                    '64594',
                    '94153',
                    '22763',
                    '27430',
                    '23175',
                    '64145',
                    '34397',
                    '19442',
                    '73134',
                    '57990',
                    '11750',
                    '23434',
                    '28990',
                    '41117',
                    '15248',
                    '21616',
                    '92199',
                    '68136',
                    '12458',
                    '11129',
                    '52360',
                    '41250',
                    '78476',
                    '51842',
                    '16445',
                    '47537',
                    '54139',
                    '25269',
                    '11255',
                    '25656',
                    '26363',
                    '84134',
                    '16764',
                    '54146',
                    '62363',
                    '30221',
                    '18131',
                    '70225',
                    '23232',
                    '15152',
                    '41755',
                    '14142',
                    '27135',
                    '41654',
                    '59493',
                    '42444',
                    '26493',
                    '64392',
                    '45748',
                    '82752',
                    '95592',
                    '13231',
                    '18470',
                    '53334',
                    '60224',
                    '57231',
                    '28231',
                    '67131',
                    '97444',
                    '37237',
                    '74191',
                    '17268',
                    '37336',
                    '41285',
                    '13671',
                    '33332',
                    '73336',
                    '95262',
                    '31154',
                    '45751',
                    '45650',
                    '51169',
                    '33233',
                    '30265',
                    '34261',
                    '44345',
                    '58272',
                    '38230',
                    '56832',
                    '29832',
                    '23737',
                    '46167',
                    '69692',
                    '23636',
                    '29166',
                    '44794',
                    '19138',
                    '59240',
                    '83540',
                    '21111',
                    '30595',
                    '17271',
                    '90751',
                    '90650',
                    '13635',
                    '85359',
                    '11453',
                    '83191',
                    '57275',
                    '28275',
                    '42242',
                    '17149',
                    '16566',
                    '91794',
                    '21551',
                    '68631',
                    '38274',
                    '50744',
                    '18333',
                    '17675',
                    '18232',
                    '90355',
                    '58236',
                    '47331',
                    '27236',
                    '18773',
                    '33130',
                    '53136',
                    '45993',
                    '43368',
                    '44192',
                    '41557',
                    '63236',
                    '36258',
                    '41456',
                    '38735',
                    '38634',
                    '26295',
                    '19561',
                    '79297',
                    '13033',
                    '97242',
                    '13990',
                    '50438',
                    '75312',
                    '59178',
                    '57132',
                    '28132',
                    '67232',
                    '16849',
                    '25481',
                    '92331',
                    '83595',
                    '95394',
                    '77130',
                    '55310',
                    '54391',
                    '91192',
                    '19479',
                    '66291',
                    '24194',
                    '16937',
                    '74393',
                    '43731',
                    '16836',
                    '75653',
                    '24545',
                    '57473',
                    '22479',
                    '61995',
                    '12933',
                    '80637',
                    '12247',
                    '12832',
                    '18737',
                    '33174',
                    '37431',
                    '11354',
                    '37530',
                    '14791',
                    '33435',
                    '38472',
                    '15251',
                    '73431',
                    '41878',
                    '59042',
                    '35253',
                    '17073',
                    '44266',
                    '21212',
                    '26439',
                    '68532',
                    '83393',
                    '57437',
                    '23131',
                    '28437',
                    '51251',
                    '73170',
                    '51350',
                    '77435',
                    '65212',
                    '64541',
                    '39365',
                    '71840',
                    '91596',
                    '13770',
                    '75550',
                    '47133',
                    '12760',
                    '21753',
                    '41708',
                    '24792',
                    '42738',
                    '78432',
                    '62446',
                    '84431',
                    '46440',
                    '43962',
                    '81830',
                    '27531',
                    '92133',
                    '78173',
                    '17730',
                    '34140',
                    '79491',
                    '18535',
                    '18434',
                    '74144',
                    '11846',
                    '57374',
                    '30238',
                    '63531',
                    '41711',
                    '88192',
                    '27171',
                    '36492',
                    '77673',
                    '83797',
                    '23535',
                    '43533',
                    '25353',
                    '70591',
                    '93091',
                    '43432',
                    '85645',
                    '25252',
                    '13734',
                    '55453',
                    '74595',
                    '21450',
                    '33376',
                    '41681',
                    '58249',
                    '24747',
                    '57635',
                    '42491',
                    '24466',
                    '28635',
                    '57734',
                    '31198',
                    '28734',
                    '54193',
                    '71895',
                    '42361',
                    '24396',
                    '46495',
                    '37273',
                    '11156',
                    '73633',
                    '37372',
                    '14263',
                    '58575',
                    '73732',
                    '27575',
                    '13668',
                    '75448',
                    '83144',
                    '23333',
                    '87140',
                    '96173',
                    '73273',
                    '19640',
                    '13132',
                    '21155',
                    '17235',
                    '26538',
                    '11417',
                    '21584',
                    '53235',
                    '35598',
                    '41315',
                    '31451',
                    '80309',
                    '43137',
                    '93495',
                    '43894',
                    '39239',
                    '75752',
                    '62178',
                    '81290',
                    '74742',
                    '82891',
                    '82198',
                    '68334',
                    '77570',
                    '80277',
                    '18377',
                    '18276',
                    '39246',
                    '66640',
                    '75755',
                    '68232',
                    '68333',
                    '19162',
                    '51199',
                    '80270',
                    '18370',
                    '43637',
                    '39241',
                    '18631',
                    '58734',
                    '27635',
                    '46294',
                    '73230',
                    '51450',
                    '25453',
                    '13171',
                    '92273',
                    '78332',
                    '64197',
                    '72246',
                    '78233',
                    '76163',
                    '13430',
                    '13531',
                    '53434',
                    '16244',
                    '57171',
                    '74341',
                    '87192',
                    '19692',
                    '73537',
                    '14347',
                    '58329',
                    '38336',
                    '36293',
                    '42164',
                    '82456',
                    '42139',
                    '93294',
                    '50338',
                    '57531',
                    '62238',
                    '44836',
                    '28531',
                    '53175',
                    '41514',
                    '70345',
                    '43233',
                    '41484',
                    '14462',
                    '14743',
                    '89150',
                    '81693',
                    '89051',
                    '54792',
                    '66692',
                    '41109',
                    '43332',
                    '16974',
                    '65457',
                    '16875',
                    '90581',
                    '37133',
                    '58330',
                    '27330',
                    '83341',
                    '91702',
                    '50462',
                    '27198',
                    '29493',
                    '64593',
                    '21251',
                    '22764',
                    '58437',
                    '16758',
                    '27437',
                    '11216',
                    '23172',
                    '34390',
                    '69497',
                    '19445',
                    '73133',
                    '96233',
                    '11757',
                    '23433',
                    '64263',
                    '41110',
                    '11728',
                    '21611',
                    '68131',
                    '58923',
                    '41257',
                    '60218',
                    '16442',
                    '84573',
                    '47431',
                    '82960',
                    '11252',
                    '73991',
                    '31250',
                    '26364',
                    '59339',
                    '76491',
                    '26339',
                    '84133',
                    '16763',
                    '62364',
                    '30226',
                    '18136',
                    '70222',
                    '23235',
                    '15155',
                    '23840',
                    '73375',
                    '41752',
                    '14145',
                    '27132',
                    '41653',
                    '77630',
                    '59494',
                    '42443',
                    '92431',
                    '26494',
                    '77731',
                    '64395',
                    '31168',
                    '54141',
                    '95595',
                    '13236',
                    '13337',
                    '53333',
                    '13348',
                    '28942',
                    '12358',
                    '60223',
                    '81491',
                    '54590',
                    '97443',
                    '37230',
                    '65349',
                    '37331',
                    '41282',
                    '51890',
                    '57236',
                    '73331',
                    '38530',
                    '57777',
                    '45756',
                    '98491',
                    '33234',
                    '30262',
                    '44342',
                    '58275',
                    '38237',
                    '56240',
                    '56161',
                    '82168',
                    '46160',
                    '69695',
                    '23631',
                    '29161',
                    '44793',
                    '56691',
                    '29691',
                    '64791',
                    '21116',
                    '30592',
                    '17276',
                    '65350',
                    '90628',
                    '11454',
                    '28272',
                    '46241',
                    '42245',
                    '84331',
                    '16561',
                    '91793',
                    '91342',
                    '74952',
                    '52291',
                    '50743',
                    '19278',
                    '18334',
                    '80269',
                    '17672',
                    '18235',
                    '18369',
                    '76297',
                    '90352',
                    '58231',
                    '27231',
                    '38273',
                    '53030',
                    '33137',
                    '53131',
                    '45994',
                    '44195',
                    '11368',
                    '63231',
                    '41451',
                    '38732',
                    '59292',
                    '38633',
                    '26292',
                    '69291',
                    '79290',
                    '13034',
                    '97245',
                    '18774',
                    '75315',
                    '57135',
                    '77498',
                    '28135',
                    '83592',
                    '95393',
                    '55317',
                    '66296',
                    '24193',
                    '16930',
                    '74394',
                    '61156',
                    '43736',
                    '16831',
                    '75654',
                    '24542',
                    '57474',
                    '61992',
                    '12934',
                    '80630',
                    '12240',
                    '12835',
                    '18730',
                    '43376',
                    '33173',
                    '37436',
                    '11353',
                    '43277',
                    '33432',
                    '33533',
                    '15256',
                    '98206',
                    '73436',
                    '59045',
                    '35254',
                    '17074',
                    '44140',
                    '21215',
                    '83394',
                    '23136',
                    '45150',
                    '77432',
                    '55612',
                    '91591',
                    '57337',
                    '21754',
                    '74538',
                    '24795',
                    '65215',
                    '60597',
                    '43965',
                    '38431',
                    '84098',
                    '78435',
                    '27536',
                    '92134',
                    '78174',
                    '17737',
                    '83178',
                    '34138',
                    '80432',
                    '18532',
                    '11115',
                    '12363',
                    '18433',
                    '74143',
                    '47170',
                    '57373',
                    '63536',
                    '16367',
                    '41716',
                    '88195',
                    '27176',
                    '36495',
                    '77674',
                    '41668',
                    '23532',
                    '25354',
                    '70596',
                    '43435',
                    '85642',
                    '74592',
                    '21457',
                    '33371',
                    '21428',
                    '57632',
                    '28632',
                    '57733',
                    '28733',
                    '54194',
                    '71892',
                    '24391',
                    '55454',
                    '46492',
                    '37274',
                    '11151',
                    '73634',
                    '37375',
                    '14264',
                    '58572',
                    '52442',
                    '27572',
                    '83143',
                    '77270',
                    '38897',
                    '96174',
                    '19638',
                    '13135',
                    '25468',
                    '21152',
                    '17232',
                    '21583',
                    '23334',
                    '53232',
                    '41312',
                    '51155',
                    '46179',
                    '43130',
                    '93492',
                    '88140',
                    '43893',
                    '22647',
                    '79237',
                    '29128',
                    '89292',
                    '44891',
                    '35592',
                    '51158',
                    '45933',
                    '50731',
                    '26271',
                    '39233',
                    '75758',
                    '82192',
                    '63360',
                    '60350',
                    '51194',
                    '42170',
                    '41467',
                    '82442',
                    '42677',
                    '61025',
                    '43645',
                    '58739',
                    '91891',
                    '26675',
                    '17853',
                    '79134',
                    '13543',
                    '75323',
                    '12553',
                    '59576',
                    '72216',
                    '79699',
                    '59136',
                    '16960',
                    '26136',
                    '65461',
                    '41544',
                    '42134',
                    '19572',
                    '50335',
                    '18760',
                    '70348',
                    '11321',
                    '86592',
                    '60349',
                    '82596',
                    '11642',
                    '11761',
                    '72353',
                    '41104',
                    '16979',
                    '77462',
                    '16878',
                    '21223',
                    '47193',
                    '61492',
                    '59370',
                    '38597',
                    '65223',
                    '16755',
                    '22734',
                    '11246',
                    '45832',
                    '70285',
                    '50630',
                    '27195',
                    '15242',
                    '59037',
                    '89540',
                    '13956',
                    '92193',
                    '35240',
                    '39471',
                    '43953',
                    '11123',
                    '18441',
                    '74131',
                    '82640',
                    '60215',
                    '57291',
                    '28291',
                    '67191',
                    '26774',
                    '22484',
                    '12452',
                    '74232',
                    '30571',
                    '25263',
                    '13741',
                    '12751',
                    '74571',
                    '68060',
                    '37693',
                    '19330',
                    '59334',
                    '26334',
                    '64552',
                    '46332',
                    '54133',
                    '62369',
                    '59840',
                    '80293',
                    '30276',
                    '23238',
                    '18166',
                    '12056',
                    '45292',
                    '14148',
                    '64398',
                    '45742',
                    '31165',
                    '45661',
                    '86240',
                    '83131',
                    '23393',
                    '78160',
                    '54230',
                    '34171',
                    '66330',
                    '80426',
                    '12355',
                    '37343',
                    '93332',
                    '82794',
                    '11440',
                    '67393',
                    '74636',
                    '28266',
                    '11527',
                    '68691',
                    '71592',
                    '17262',
                    '18643',
                    '74892',
                    '65344',
                    '90742',
                    '43160',
                    '14630',
                    '24754',
                    '47391',
                    '61690',
                    '51163',
                    '42372',
                    '75596',
                    '61340',
                    '18247',
                    '58278',
                    '43852',
                    '90346',
                    '34236',
                    '61971',
                    '38245',
                    '74946',
                    '38795',
                    '59994',
                    '26994',
                    '26235',
                    '94692',
                    '13147',
                    '21146',
                    '93992',
                    '90625',
                    '85353',
                    '11459',
                    '11558',
                    '53493',
                    '98010',
                    '83333',
                    '57497',
                    '17143',
                    '55321',
                    '34373',
                    '76111',
                    '71196',
                    '54331',
                    '66132',
                    '13460',
                    '66231',
                    '12650',
                    '68493',
                    '28147',
                    '43791',
                    '42248',
                    '53143',
                    '37491',
                    '70373',
                    '52153',
                    '19275',
                    '18339',
                    '80264',
                    '18238',
                    '18364',
                    '64750',
                    '61935',
                    '79530',
                    '12847',
                    '43362',
                    '68143',
                    '11365',
                    '36252',
                    '43241',
                    '14432',
                    '14731',
                    '24655',
                    '87236',
                    '17547',
                    '19536',
                    '73491',
                    '13039',
                    '34337',
                    '75219',
                    '50432',
                    '12649',
                    '75318',
                    '59172',
                    '75244',
                    '97633',
                    '57138',
                    '26172',
                    '28138',
                    '16843',
                    '16250',
                    '37141',
                    '58360',
                    '42530',
                    '23191',
                    '21874',
                    '19473',
                    '73141',
                    '54436',
                    '75659',
                    '51792',
                    '45144',
                    '23441',
                    '17464',
                    '41140',
                    '12939',
                    '12838',
                    '84491',
                    '22473',
                    '58951',
                    '79431',
                    '18595',
                    '45494',
                    '73693',
                    '41872',
                    '58591',
                    '27591',
                    '35259',
                    '17079',
                    '83434',
                    '64651',
                    '78197',
                    '46471',
                    '26433',
                    '15396',
                    '94140',
                    '83399',
                    '23166',
                    '19437',
                    '96205',
                    '25667',
                    '77697',
                    '21218',
                    '93082',
                    '71394',
                    '54177',
                    '61834',
                    '43447',
                    '25227',
                    '21759',
                    '28345',
                    '15163',
                    '16351',
                    '41702',
                    '14173',
                    '24798',
                    '51396',
                    '65218',
                    '57695',
                    '42431',
                    '28695',
                    '41261',
                    '41836',
                    '82763',
                    '59730',
                    '81966',
                    '81845',
                    '37297',
                    '84095',
                    '19734',
                    '73747',
                    '79336',
                    '27566',
                    '83175',
                    '46233',
                    '17745',
                    '96197',
                    '54274',
                    '73297',
                    '34135',
                    '37260',
                    '30232',
                    '70236',
                    '41746',
                    '14137',
                    '41665',
                    '43539',
                    '53295',
                    '54634',
                    '66734',
                    '62370',
                    '21425',
                    '93233',
                    '58243',
                    '31192',
                    '82831',
                    '46130',
                    '29157',
                    '41306',
                    '55459',
                    '42336',
                    '31442',
                    '61294',
                    '37378',
                    '14234',
                    '13662',
                    '75442',
                    '55594',
                    '69153',
                    '14940',
                    '23364',
                    '51444',
                    '19635',
                    '13138',
                    '27397',
                    '25465',
                    '59532',
                    '38391',
                    '26532',
                    '59631',
                    '26631',
                    '93130',
                    '16557',
                    '79170',
                    '58647',
                    '23339',
                    '93832',
                    '69792',
                    '93191',
                    '14565',
                    '64696',
                    '43084',
                    '17757',
                    '12145',
                    '21176',
                    '90736',
                    '71995',
                    '90637',
                    '79140',
                    '66193',
                    '36394',
                    '97342',
                    '74495',
                    '14871',
                    '25433',
                    '13155',
                    '29145',
                    '81794',
                    '21437',
                    '46595',
                    '46144',
                    '70361',
                    '52141',
                    '60360',
                    '19146',
                    '42140',
                    '19267',
                    '77553',
                    '87297',
                    '97591',
                    '80649',
                    '12239',
                    '53151',
                    '63350',
                    '75229',
                    '27655',
                    '56594',
                    '12679',
                    '29594',
                    '69141',
                    '14934',
                    '44443',
                    '14835',
                    '25477',
                    '93144',
                    '55308',
                    '94336',
                    '50493',
                    '51997',
                    '16950',
                    '26142',
                    '16851',
                    '37153',
                    '51733',
                    '89435',
                    '82991',
                    '94431',
                    '43657',
                    '62142',
                    '18750',
                    '41574',
                    '72592',
                    '43268',
                    '41475',
                    '82472',
                    '38752',
                    '31331',
                    '41134',
                    '59791',
                    '52194',
                    '58943',
                    '44496',
                    '15337',
                    '57450',
                    '45130',
                    '72226',
                    '98138',
                    '50446',
                    '69194',
                    '44641',
                    '94134',
                    '36196',
                    '13768',
                    '86335',
                    '11232',
                    '23156',
                    '98147',
                    '24162',
                    '59340',
                    '54695',
                    '35270',
                    '90130',
                    '71630',
                    '44245',
                    '72341',
                    '91496',
                    '82771',
                    '61235',
                    '11821',
                    '52343',
                    '41273',
                    '82670',
                    '60243',
                    '79397',
                    '23839',
                    '72464',
                    '50644',
                    '44694',
                    '30293',
                    '21448',
                    '15135',
                    '43149',
                    '41677',
                    '95241',
                    '42467',
                    '31133',
                    '59870',
                    '43499',
                    '22223',
                    '26971',
                    '65671',
                    '12462',
                    '11131',
                    '18453',
                    '11865',
                    '82634',
                    '24296',
                    '82735',
                    '17962',
                    '25730',
                    '59593',
                    '52396',
                    '79195',
                    '45332',
                    '73249',
                    '96149',
                    '45772',
                    '31177',
                    '89233',
                    '59834',
                    '26834',
                    '80281',
                    '83293',
                    '30246',
                    '26935',
                    '65635',
                    '18156',
                    '12066',
                    '43150',
                    '24764',
                    '24445',
                    '82133',
                    '95294',
                    '42836',
                    '80311',
                    '26263',
                    '28890',
                    '90332',
                    '71432',
                    '58215',
                    '66830',
                    '75436',
                    '11434',
                    '57256',
                    '11535',
                    '96150',
                    '98020',
                    '73250',
                    '83563',
                    '21132',
                    '18651',
                    '17841',
                    '13450',
                    '75230',
                    '13551',
                    '75331',
                    '59197',
                    '12541',
                    '21572',
                    '81138',
                    '71940',
                    '42159',
                    '80254',
                    '83246',
                    '18354',
                    '18255',
                    '86432',
                    '62258',
                    '86533',
                    '63349',
                    '60379',
                    '89130',
                    '29338',
                    '19542',
                    '12264',
                    '11333',
                    '16260',
                    '21536',
                    '27350',
                    '77012',
                    '17151',
                    '55333',
                    '61532',
                    '61433',
                    '21231',
                    '61172',
                    '16738',
                    '24566',
                    '45893',
                    '19391',
                    '59395',
                    '26395',
                    '12954',
                    '43352',
                    '68151',
                    '43253',
                    '44139',
                    '45534',
                    '17454',
                    '17555',
                    '52378',
                    '51632',
                    '62465',
                    '35234',
                    '54291',
                    '36592',
                    '66391',
                    '47550',
                    '11636',
                    '74293',
                    '11737',
                    '19740',
                    '19461',
                    '73153',
                    '31230',
                    '81192',
                    '21374',
                    '71234',
                    '61136',
                    '90435',
                    '46393',
                    '61895',
                    '62359',
                    '12743',
                    '74563',
                    '45233',
                    '98192',
                    '77751',
                    '61730',
                    '64562',
                    '61631',
                    '25271',
                    '46463',
                    '44290',
                    '56392',
                    '29392',
                    '64292',
                    '41842',
                    '78455',
                    '82669',
                    '61271',
                    '54244',
                    '43994',
                    '85592',
                    '37250',
                    '12347',
                    '37351',
                    '14240',
                    '15531',
                    '36341',
                    '86234',
                    '82230',
                    '38550',
                    '46832',
                    '54831',
                    '46191',
                    '66931',
                    '54165',
                    '62340',
                    '81596',
                    '70242',
                    '15171',
                    '63512',
                    '16343',
                    '14161',
                    '91290',
                    '27152',
                    '79591',
                    '23651',
                    '51171',
                    '42342',
                    '39595',
                    '26258',
                    '14641',
                    '35572',
                    '45632',
                    '51174',
                    '46158',
                    '42347',
                    '61331',
                    '39590',
                    '34292',
                    '73398',
                    '84013',
                    '81340',
                    '93194',
                    '14560',
                    '56793',
                    '89632',
                    '83162',
                    '64693',
                    '43081',
                    '17752',
                    '71572',
                    '83692',
                    '12140',
                    '21173',
                    '90733',
                    '79145',
                    '71132',
                    '66196',
                    '93158',
                    '36391',
                    '97347',
                    '23351',
                    '87166',
                    '98061',
                    '25436',
                    '13150',
                    '81791',
                    '21432',
                    '58254',
                    '24495',
                    '56140',
                    '46141',
                    '29140',
                    '52144',
                    '60365',
                    '19143',
                    '42145',
                    '41568',
                    '87292',
                    '85461',
                    '19592',
                    '97594',
                    '53154',
                    '63355',
                    '41535',
                    '70364',
                    '27650',
                    '56591',
                    '29591',
                    '86132',
                    '69144',
                    '14931',
                    '69393',
                    '44446',
                    '14830',
                    '25472',
                    '93141',
                    '94333',
                    '50496',
                    '22358',
                    '59147',
                    '16955',
                    '26147',
                    '16854',
                    '37156',
                    '54492',
                    '66592',
                    '51736',
                    '42541',
                    '89430',
                    '77152',
                    '61573',
                    '76142',
                    '66143',
                    '51992',
                    '43652',
                    '62147',
                    '62266',
                    '41571',
                    '11349',
                    '23942',
                    '72597',
                    '41470',
                    '82477',
                    '41131',
                    '59794',
                    '21630',
                    '37453',
                    '52191',
                    '22464',
                    '36542',
                    '14762',
                    '57455',
                    '72223',
                    '50443',
                    '69191',
                    '44493',
                    '15332',
                    '11237',
                    '23153',
                    '64163',
                    '76340',
                    '98142',
                    '73112',
                    '72478',
                    '51332',
                    '31271',
                    '94131',
                    '36193',
                    '46792',
                    '44240',
                    '29342',
                    '72344',
                    '91493',
                    '26741',
                    '61230',
                    '84552',
                    '88240',
                    '11824',
                    '41276',
                    '82675',
                    '60246',
                    '79392',
                    '93792',
                    '72461',
                    '50641',
                    '44691',
                    '79022',
                    '21775',
                    '30296',
                    '12739',
                    '51570',
                    '41672',
                    '95244',
                    '31136',
                    '22226',
                    '26875',
                    '26974',
                    '12467',
                    '11134',
                    '11860',
                    '91691',
                    '82631',
                    '24293',
                    '82730',
                    '59596',
                    '52393',
                    '13657',
                    '11428',
                    '45337',
                    '46260',
                    '85740',
                    '31172',
                    '59831',
                    '94232',
                    '26831',
                    '55475',
                    '80284',
                    '83296',
                    '30243',
                    '12063',
                    '22592',
                    '24761',
                    '42833',
                    '42932',
                    '31433',
                    '19259',
                    '57895',
                    '26266',
                    '18348',
                    '90337',
                    '71437',
                    '82136',
                    '95291',
                    '75433',
                    '11431',
                    '11530',
                    '51435',
                    '25449',
                    '81395',
                    '13840',
                    '21137',
                    '18654',
                    '71176',
                    '75235',
                    '13554',
                    '75334',
                    '59192',
                    '75268',
                    '12544',
                    '12638',
                    '26192',
                    '61199',
                    '59543',
                    '80251',
                    '83243',
                    '18351',
                    '29638',
                    '18250',
                    '62192',
                    '56195',
                    '29195',
                    '50762',
                    '82532',
                    '17448',
                    '19547',
                    '57598',
                    '12948',
                    '11336',
                    '89135',
                    '82433',
                    '28150',
                    '27355',
                    '17154',
                    '21841',
                    '55336',
                    '84398',
                    '75271',
                    '16265',
                    '21533',
                    '21368',
                    '24563',
                    '95442',
                    '45171',
                    '76197',
                    '45896',
                    '17891',
                    '21234',
                    '41128',
                    '12951',
                    '33152',
                    '68154',
                    '69595',
                    '43256',
                    '53198',
                    '58939',
                    '24642',
                    '45531',
                    '17451',
                    '45430',
                    '17550',
                    '69238',
                    '62460',
                    '35231',
                    '54294',
                    '68891',
                    '11633',
                    '74296',
                    '11732',
                    '51277',
                    '19464',
                    '31235',
                    '81197',
                    '21371',
                    '55633',
                    '90531',
                    '71231',
                    '61133',
                    '46396',
                    '71330',
                    '12746',
                    '45236',
                    '19341',
                    '41649',
                    '25375',
                    '61634',
                    '13756',
                    '47151',
                    '46466',
                    '44295',
                    '64297',
                    '78450',
                    '19060',
                    '52339',
                    '60239',
                    '61274',
                    '54241',
                    '43991',
                    '85597',
                    '66341',
                    '13253',
                    '74243',
                    '12342',
                    '37354',
                    '15534',
                    '36344',
                    '86231',
                    '74692',
                    '88295',
                    '61771',
                    '46194',
                    '43450',
                    '25230',
                    '81593',
                    '63517',
                    '16346',
                    '91295',
                    '27157',
                    '51534',
                    '24733',
                    '24430',
                    '95270',
                    '31146',
                    '45642',
                    '31496',
                    '26940',
                    '12031',
                    '63518',
                    '70215',
                    '71492',
                    '96024',
                    '41765',
                    '79250',
                    '46157',
                    '41325',
                    '24373',
                    '26252',
                    '33393',
                    '44331',
                    '73397',
                    '13830',
                    '53395',
                    '90642',
                    '13641',
                    '56534',
                    '74651',
                    '11540',
                    '29534',
                    '64434',
                    '46254',
                    '97755',
                    '93157',
                    '16574',
                    '72631',
                    '25439',
                    '91331',
                    '42250',
                    '82496',
                    '80320',
                    '90321',
                    '34251',
                    '58224',
                    '25592',
                    '68362',
                    '41567',
                    '44735',
                    '52134',
                    '60337',
                    '63224',
                    '24632',
                    '82461',
                    '42654',
                    '72136',
                    '27297',
                    '62151',
                    '80643',
                    '38291',
                    '18743',
                    '12233',
                    '52237',
                    '13560',
                    '65596',
                    '21561',
                    '12570',
                    '69134',
                    '55302',
                    '45190',
                    '76132',
                    '13443',
                    '75223',
                    '65561',
                    '57193',
                    '28193',
                    '67293',
                    '24531',
                    '57443',
                    '72480',
                    '22357',
                    '50455',
                    '76231',
                    '19551',
                    '51692',
                    '47291',
                    '11346',
                    '72598',
                    '82478',
                    '36532',
                    '13931',
                    '35263',
                    '33191',
                    '44274',
                    '38695',
                    '11661',
                    '95335',
                    '92291',
                    '98132',
                    '77441',
                    '61161',
                    '90440',
                    '44634',
                    '13762',
                    '11238',
                    '21763',
                    '11265',
                    '72477',
                    '24135',
                    '89392',
                    '26454',
                    '68593',
                    '62454',
                    '13975',
                    '29772',
                    '37591',
                    '11625',
                    '98231',
                    '72334',
                    '82694',
                    '34152',
                    '18541',
                    '12471',
                    '33595',
                    '41279',
                    '11854',
                    '16372',
                    '93452',
                    '77760',
                    '29471',
                    '23541',
                    '64571',
                    '45796',
                    '39355',
                    '25240',
                    '85631',
                    '59894',
                    '12736',
                    '23833',
                    '43143',
                    '88133',
                    '36433',
                    '31139',
                    '95234',
                    '86492',
                    '45761',
                    '43493',
                    '22229',
                    '55463',
                    '57391',
                    '21442',
                    '30255',
                    '28391',
                    '18145',
                    '13245',
                    '81891',
                    '81330',
                    '11144',
                    '14253',
                    '52431',
                    '83156',
                    '84591',
                    '21121',
                    '17241',
                    '18660',
                    '12130',
                    '80595',
                    '18495',
                    '61592',
                    '13658',
                    '75425',
                    '11427',
                    '45338',
                    '86142',
                    '87152',
                    '96143',
                    '56130',
                    '64333',
                    '42942',
                    '42351',
                    '13795',
                    '57874',
                    '22652',
                    '56233',
                    '57795',
                    '23932',
                    '19256',
                    '89190',
                    '83255',
                    '18347',
                    '90338',
                    '18264',
                    '90365',
                    '79153',
                    '38831',
                    '14840',
                    '21138',
                    '76176',
                    '17834',
                    '75267',
                    '21578',
                    '12637',
                    '81132',
                    '12534',
                    '16273',
                    '57164',
                    '37162',
                    '61196',
                    '78691',
                    '89440',
                    '18697',
                    '92266',
                    '17160',
                    '38662',
                    '29637',
                    '53593',
                    '43835',
                    '56893',
                    '62252',
                    '29893',
                    '63343',
                    '69633',
                    '41523',
                    '70350',
                    '69530',
                    '52170',
                    '60373',
                    '42153',
                    '56332',
                    '29332',
                    '17447',
                    '69273',
                    '64232',
                    '17564',
                    '57597',
                    '12947',
                    '11339',
                    '81231',
                    '12864',
                    '43341',
                    '68160',
                    '68395',
                    '90594',
                    '71294',
                    '16860',
                    '95432',
                    '55339',
                    '84397',
                    '59151',
                    '26151',
                    '61790',
                    '21244',
                    '16732',
                    '94163',
                    '73591',
                    '58422',
                    '81536',
                    '76198',
                    '64131',
                    '87350',
                    '76330',
                    '51261',
                    '21367',
                    '55625',
                    '24272',
                    '53197',
                    '44133',
                    '44230',
                    '77595',
                    '95731',
                    '69237',
                    '41127',
                    '86294',
                    '61240',
                    '16431',
                    '88230',
                    '43295',
                    '66450',
                    '43934',
                    '93892',
                    '69732',
                    '52372',
                    '92064',
                    '11221',
                    '23145',
                    '91133',
                    '91991',
                    '24171',
                    '59353',
                    '81198',
                    '26353',
                    '16776',
                    '74569',
                    '15140',
                    '69431',
                    '73360',
                    '41721',
                    '73195',
                    '27141',
                    '14150',
                    '42456',
                    '56435',
                    '29435',
                    '64535',
                    '54154',
                    '27491',
                    '62353',
                    '12749',
                    '45392',
                    '16475',
                    '85235',
                    '64298',
                    '18462',
                    '12332',
                    '57931',
                    '93399',
                    '28931',
                    '44537',
                    '52336',
                    '82740',
                    '85598',
                    '85730',
                    '36334',
                    '69333',
                    '85735',
                    '97453',
                    '12348',
                    '36331',
                    '14551',
                    '60570',
                    '42750',
                    '31143',
                    '45647',
                    '91532',
                    '94203',
                    '31493',
                    '70210',
                    '23261',
                    '41760',
                    '24736',
                    '98432',
                    '46152',
                    '41320',
                    '26257',
                    '44334',
                    '73392',
                    '13644',
                    '56531',
                    '11545',
                    '17758',
                    '29531',
                    '64431',
                    '46251',
                    '14991',
                    '13835',
                    '90638',
                    '26653',
                    '93152',
                    '16571',
                    '91334',
                    '42255',
                    '90739',
                    '60381',
                    '50753',
                    '24332',
                    '82493',
                    '21438',
                    '80325',
                    '34254',
                    '93251',
                    '44370',
                    '58221',
                    '82143',
                    '44730',
                    '52131',
                    '63221',
                    '19268',
                    '42651',
                    '87298',
                    '91433',
                    '72133',
                    '27292',
                    '62154',
                    '80646',
                    '38294',
                    '18746',
                    '19149',
                    '52232',
                    '41562',
                    '65593',
                    '86138',
                    '21564',
                    '69131',
                    '25478',
                    '59550',
                    '26550',
                    '55307',
                    '45195',
                    '75226',
                    '94191',
                    '24534',
                    '22352',
                    '50450',
                    '43658',
                    '19554',
                    '13042',
                    '47294',
                    '11343',
                    '43267',
                    '88037',
                    '24233',
                    '13934',
                    '33194',
                    '44172',
                    '44271',
                    '38690',
                    '11664',
                    '92294',
                    '77194',
                    '45162',
                    '98137',
                    '61164',
                    '15338',
                    '13767',
                    '21766',
                    '11260',
                    '72472',
                    '24130',
                    '26451',
                    '35222',
                    '43975',
                    '11620',
                    '98234',
                    '91631',
                    '82691',
                    '13970',
                    '85229',
                    '38492',
                    '12474',
                    '12373',
                    '11851',
                    '29474',
                    '45793',
                    '39350',
                    '25245',
                    '85634',
                    '59891',
                    '47142',
                    '12733',
                    '23836',
                    '16377',
                    '41678',
                    '24772',
                    '42468',
                    '24471',
                    '95231',
                    '89243',
                    '43496',
                    '55466',
                    '57394',
                    '21447',
                    '30250',
                    '28394',
                    '18140',
                    '12070',
                    '43146',
                    '41779',
                    '13240',
                    '47492',
                    '12430',
                    '74250',
                    '81335',
                    '37365',
                    '66895',
                    '60208',
                    '92142',
                    '83153',
                    '84594',
                    '17763',
                    '51495',
                    '21124',
                    '12135',
                    '52399',
                    '75420',
                    '11422',
                    '57240',
                    '67140',
                    '73246',
                    '96146',
                    '29135',
                    '42354',
                    '30249',
                    '18159',
                    '12069',
                    '22657',
                    '14652',
                    '31178',
                    '92492',
                    '56135',
                    '74960',
                    '19253',
                    '89195',
                    '18261',
                    '90360',
                    '57790',
                    '79156',
                    '75439',
                    '81432',
                    '23342',
                    '51462',
                    '25443',
                    '13161',
                    '21160',
                    '59198',
                    '75262',
                    '12632',
                    '81137',
                    '75341',
                    '12531',
                    '57161',
                    '61193',
                    '78694',
                    '18692',
                    '92263',
                    '17165',
                    '21852',
                    '76173',
                    '17831',
                    '56632',
                    '29632',
                    '64732',
                    '45591',
                    '29896',
                    '63346',
                    '41526',
                    '70355',
                    '52175',
                    '60376',
                    '19150',
                    '73833',
                    '89162',
                    '29337',
                    '17442',
                    '64237',
                    '17561',
                    '57592',
                    '12942',
                    '89591',
                    '21645',
                    '43344',
                    '68831',
                    '82439',
                    '14753',
                    '36133',
                    '83351',
                    '84392',
                    '51293',
                    '59154',
                    '31295',
                    '81173',
                    '90591',
                    '71291',
                    '16865',
                    '21241',
                    '16737',
                    '94166',
                    '43740',
                    '64134',
                    '76335',
                    '78290',
                    '51264',
                    '19455',
                    '21362',
                    '53192',
                    '44136',
                    '37440',
                    '44235',
                    '36230',
                    '58933',
                    '29373',
                    '69232',
                    '41122',
                    '56733',
                    '86291',
                    '61245',
                    '64633',
                    '68192',
                    '16434',
                    '43931',
                    '11639',
                    '11738',
                    '81630',
                    '78542',
                    '52377',
                    '73440',
                    '78461',
                    '82952',
                    '11224',
                    '91136',
                    '91994',
                    '24174',
                    '31262',
                    '61139',
                    '16773',
                    '27463',
                    '15145',
                    '63504',
                    '69434',
                    '98335',
                    '41724',
                    '27144',
                    '14155',
                    '42453',
                    '39349',
                    '64530',
                    '43542',
                    '27494',
                    '62356',
                    '85230',
                    '81940',
                    '44532',
                    '52333',
                    '82666',
                    '60233',
                    '59752',
                    '57995',
                    '11755',
                    '23431',
                    '64261',
                    '41112',
                    '59038',
                    '21613',
                    '93692',
                    '68133',
                    '58921',
                    '41255',
                    '78473',
                    '16440',
                    '84571',
                    '85561',
                    '47532',
                    '82962',
                    '11250',
                    '31252',
                    '76493',
                    '84131',
                    '16761',
                    '54143',
                    '79090',
                    '62366',
                    '30224',
                    '18134',
                    '30279',
                    '87392',
                    '23237',
                    '15157',
                    '23842',
                    '12059',
                    '44395',
                    '19492',
                    '41750',
                    '14147',
                    '41651',
                    '77632',
                    '42441',
                    '77733',
                    '64397',
                    '13234',
                    '13335',
                    '80429',
                    '57940',
                    '53331',
                    '60221',
                    '81493',
                    '28234',
                    '67134',
                    '54592',
                    '74639',
                    '28269',
                    '11528',
                    '66492',
                    '97441',
                    '37232',
                    '74194',
                    '37333',
                    '41280',
                    '13674',
                    '75454',
                    '96033',
                    '73333',
                    '38532',
                    '28674',
                    '57775',
                    '31151',
                    '45655',
                    '22241',
                    '33236',
                    '30260',
                    '12040',
                    '64793',
                    '34264',
                    '44340',
                    '18248',
                    '58277',
                    '17669',
                    '14192',
                    '38235',
                    '56242',
                    '23732',
                    '56163',
                    '74949',
                    '46162',
                    '69697',
                    '23633',
                    '29163',
                    '44791',
                    '56693',
                    '21114',
                    '17274',
                    '13148',
                    '65352',
                    '90754',
                    '21149',
                    '90655',
                    '11456',
                    '11557',
                    '67170',
                    '45350',
                    '42247',
                    '84232',
                    '57498',
                    '93162',
                    '16563',
                    '91791',
                    '68634',
                    '28148',
                    '82151',
                    '38271',
                    '74950',
                    '52293',
                    '50741',
                    '18336',
                    '17670',
                    '18237',
                    '76295',
                    '58233',
                    '47334',
                    '27233',
                    '18776',
                    '53032',
                    '33135',
                    '53133',
                    '12848',
                    '41552',
                    '63233',
                    '41453',
                    '38631',
                    '87264',
                    '69293',
                    '79292',
                    '17548',
                    '13036',
                    '34338',
                    '75317',
                    '57137',
                    '28137',
                    '25484',
                    '95391',
                    '77135',
                    '55315',
                    '78275',
                    '54394',
                    '22362',
                    '24191',
                    '16932',
                    '43734',
                    '16833',
                    '75656',
                    '57476',
                    '12936',
                    '80632',
                    '12242',
                    '18732',
                    '33171',
                    '37434',
                    '11351',
                    '43275',
                    '33531',
                    '15254',
                    '98204',
                    '73434',
                    '13940',
                    '35256',
                    '17076',
                    '44142',
                    '78198',
                    '21217',
                    '83396',
                    '57432',
                    '23134',
                    '28432',
                    '45152',
                    '51254',
                    '23169',
                    '19438',
                    '25668',
                    '77430',
                    '55610',
                    '77698',
                    '64544',
                    '39360',
                    '91593',
                    '54178',
                    '43448',
                    '25228',
                    '57335',
                    '21756',
                    '28335',
                    '67035',
                    '24797',
                    '65217',
                    '52495',
                    '51650',
                    '41839',
                    '60595',
                    '81835',
                    '37298',
                    '78437',
                    '27534',
                    '73748',
                    '92136',
                    '17735',
                    '96198',
                    '73298',
                    '80430',
                    '12361',
                    '18431',
                    '74141',
                    '47172',
                    '28371',
                    '63534',
                    '16365',
                    '41714',
                    '45251',
                    '70239',
                    '27174',
                    '36497',
                    '41749',
                    '14138',
                    '83792',
                    '25356',
                    '70594',
                    '43437',
                    '85640',
                    '13731',
                    '55456',
                    '42339',
                    '21455',
                    '37636',
                    '33373',
                    '24463',
                    '53274',
                    '57731',
                    '28731',
                    '89251',
                    '54196',
                    '29158',
                    '41309',
                    '24393',
                    '17771',
                    '37276',
                    '11153',
                    '73636',
                    '37377',
                    '14266',
                    '27570',
                    '83141',
                    '38895',
                    '87145',
                    '96176',
                    '13137',
                    '27398',
                    '21150',
                    '17230',
                    '16558',
                    '58648',
                    '21581',
                    '23336',
                    '22645',
                    '53230',
                    '41310',
                    '51157',
                    '43132',
                    '43891',
                    '36442',
                    '75757',
                    '82894',
                    '68230',
                    '86551',
                    '68331',
                    '19160',
                    '41468',
                    '80272',
                    '18372',
                    '18273',
                    '43635',
                    '39243',
                    '18633',
                    '12163',
                    '58736',
                    '27736',
                    '27637',
                    '38840',
                    '46296',
                    '98042',
                    '73232',
                    '78671',
                    '44465',
                    '96132',
                    '51452',
                    '25451',
                    '13173',
                    '78330',
                    '26694',
                    '64195',
                    '72244',
                    '78231',
                    '76161',
                    '13432',
                    '72219',
                    '13533',
                    '59139',
                    '16246',
                    '57173',
                    '26139',
                    '73535',
                    '14345',
                    '38334',
                    '44935',
                    '36291',
                    '42166',
                    '82454',
                    '38774',
                    '95795',
                    '62139',
                    '57533',
                    '97238',
                    '44834',
                    '28533',
                    '41516',
                    '70347',
                    '43231',
                    '58965',
                    '14741',
                    '81691',
                    '74792',
                    '81240',
                    '37470',
                    '43330',
                    '65455',
                    '81161',
                    '16877',
                    '90583',
                    '37131',
                    '58332',
                    '27332',
                    '50460',
                    '56491',
                    '38598',
                    '29491',
                    '64591',
                    '58435',
                    '27435',
                    '11214',
                    '23170',
                    '34392',
                    '69495',
                    '11249',
                    '19447',
                    '73131',
                    '96231',
                    '59372',
                    '38595',
                    '26372',
                    '65221',
                    '59475',
                    '16757',
                    '22736',
                    '11219',
                    '33291',
                    '30283',
                    '69498',
                    '11244',
                    '45830',
                    '70287',
                    '50632',
                    '15240',
                    '11727',
                    '13954',
                    '92191',
                    '35242',
                    '17062',
                    '44156',
                    '43951',
                    '11758',
                    '11121',
                    '18443',
                    '41258',
                    '60217',
                    '57293',
                    '28293',
                    '67193',
                    '26776',
                    '82392',
                    '12450',
                    '13743',
                    '21742',
                    '19332',
                    '59336',
                    '26336',
                    '64550',
                    '46330',
                    '54131',
                    '30229',
                    '18139',
                    '62336',
                    '80291',
                    '30274',
                    '18164',
                    '12054',
                    '45290',
                    '45740',
                    '31167',
                    '83133',
                    '23391',
                    '78162',
                    '54232',
                    '13239',
                    '34173',
                    '66332',
                    '13338',
                    '80424',
                    '12357',
                    '37341',
                    '79370',
                    '11442',
                    '67391',
                    '74634',
                    '28264',
                    '11525',
                    '68693',
                    '18641',
                    '65346',
                    '90740',
                    '43162',
                    '14632',
                    '24756',
                    '47393',
                    '23641',
                    '51161',
                    '42370',
                    '75594',
                    '21463',
                    '26237',
                    '18245',
                    '90344',
                    '34234',
                    '61973',
                    '38238',
                    '82167',
                    '74944',
                    '45694',
                    '26996',
                    '21119',
                    '17279',
                    '13145',
                    '21144',
                    '12155',
                    '84341',
                    '15592',
                    '90627',
                    '85351',
                    '79631',
                    '53491',
                    '96162',
                    '83331',
                    '57495',
                    '17141',
                    '21832',
                    '55323',
                    '34371',
                    '76113',
                    '71194',
                    '54333',
                    '66130',
                    '13462',
                    '66233',
                    '21559',
                    '12652',
                    '68491',
                    '28145',
                    '43793',
                    '53141',
                    '37493',
                    '70371',
                    '52151',
                    '19277',
                    '80266',
                    '18366',
                    '76298',
                    '64752',
                    '79532',
                    '80626',
                    '12845',
                    '43360',
                    '68141',
                    '11367',
                    '36250',
                    '43243',
                    '14430',
                    '14733',
                    '24657',
                    '78591',
                    '87234',
                    '17545',
                    '19534',
                    '73493',
                    '34335',
                    '50430',
                    '59170',
                    '97631',
                    '77497',
                    '86194',
                    '16841',
                    '16252',
                    '37143',
                    '36153',
                    '42532',
                    '55318',
                    '23193',
                    '19471',
                    '73143',
                    '54434',
                    '66534',
                    '73060',
                    '23443',
                    '17466',
                    '37439',
                    '21625',
                    '84493',
                    '43278',
                    '22471',
                    '58953',
                    '79433',
                    '15259',
                    '73439',
                    '73691',
                    '41870',
                    '78445',
                    '58593',
                    '27593',
                    '78195',
                    '26431',
                    '15394',
                    '94142',
                    '23164',
                    '19435',
                    '25665',
                    '94492',
                    '77695',
                    '59431',
                    '54672',
                    '25342',
                    '43445',
                    '25225',
                    '57338',
                    '74537',
                    '15161',
                    '63520',
                    '16353',
                    '14171',
                    '27160',
                    '51394',
                    '57697',
                    '42433',
                    '19736',
                    '41263',
                    '41834',
                    '82761',
                    '59732',
                    '26732',
                    '54535',
                    '81964',
                    '37295',
                    '84097',
                    '44552',
                    '27539',
                    '58564',
                    '73745',
                    '14575',
                    '27564',
                    '17738',
                    '29551',
                    '83177',
                    '46231',
                    '17747',
                    '96195',
                    '73295',
                    '34137',
                    '97433',
                    '37262',
                    '84024',
                    '30230',
                    '16368',
                    '70234',
                    '41744',
                    '14135',
                    '41667',
                    '95251',
                    '62372',
                    '21458',
                    '21427',
                    '93231',
                    '58241',
                    '51592',
                    '31190',
                    '82833',
                    '54892',
                    '46132',
                    '29155',
                    '66992',
                    '41304',
                    '42334',
                    '61296',
                    '13660',
                    '75440',
                    '38898',
                    '69151',
                    '44453',
                    '19637',
                    '97499',
                    '27395',
                    '25467',
                    '59530',
                    '59633',
                    '26633',
                    '93132',
                    '16555',
                    '79172',
                    '58645',
                    '97334',
                    '79235',
                    '45931',
                    '94294',
                    '50733',
                    '26273',
                    '80301',
                    '15196',
                    '39231',
                    '22648',
                    '62170',
                    '82899',
                    '63362',
                    '41502',
                    '60352',
                    '51196',
                    '42172',
                    '41465',
                    '82440',
                    '43638',
                    '61027',
                    '26574',
                    '17851',
                    '93176',
                    '79136',
                    '13541',
                    '75321',
                    '12551',
                    '64198',
                    '72214',
                    '16962',
                    '26134',
                    '65463',
                    '73538',
                    '14896',
                    '38339',
                    '41546',
                    '19570',
                    '62248',
                    '50337',
                    '97235',
                    '18762',
                    '11323',
                    '44255',
                    '31392',
                    '11640',
                    '11763',
                    '72351',
                    '41106',
                    '77460',
                    '83771',
                    '65458',
                    '74382',
                    '21221',
                    '75642',
                    '47191',
                    '61490',
                    '77467',
                    '21226',
                    '61147',
                    '58338',
                    '75645',
                    '83349',
                    '61497',
                    '59375',
                    '38592',
                    '26375',
                    '65226',
                    '59472',
                    '22731',
                    '11243',
                    '50635',
                    '41118',
                    '21619',
                    '13953',
                    '35245',
                    '17065',
                    '39474',
                    '44151',
                    '18444',
                    '11872',
                    '60210',
                    '28294',
                    '67194',
                    '26771',
                    '22481',
                    '12457',
                    '25266',
                    '21745',
                    '68065',
                    '25659',
                    '19335',
                    '59331',
                    '26331',
                    '54136',
                    '22270',
                    '62331',
                    '30273',
                    '18163',
                    '12053',
                    '45297',
                    '45747',
                    '31160',
                    '54149',
                    '43479',
                    '25219',
                    '83134',
                    '76015',
                    '54235',
                    '34174',
                    '80423',
                    '12350',
                    '82791',
                    '11445',
                    '57263',
                    '74633',
                    '28263',
                    '11522',
                    '68694',
                    '37238',
                    '17267',
                    '18646',
                    '65341',
                    '37339',
                    '73339',
                    '24751',
                    '47394',
                    '98499',
                    '75593',
                    '55445',
                    '90343',
                    '34233',
                    '82160',
                    '38240',
                    '74943',
                    '46168',
                    '29169',
                    '45693',
                    '19137',
                    '50770',
                    '38790',
                    '59991',
                    '59230',
                    '26991',
                    '13142',
                    '92394',
                    '21143',
                    '12152',
                    '90620',
                    '85356',
                    '13492',
                    '89693',
                    '53496',
                    '83336',
                    '57492',
                    '28492',
                    '55324',
                    '71193',
                    '54334',
                    '13465',
                    '66234',
                    '12655',
                    '57142',
                    '74372',
                    '28142',
                    '74732',
                    '37494',
                    '70376',
                    '52156',
                    '19270',
                    '80261',
                    '18361',
                    '58239',
                    '61930',
                    '27239',
                    '79535',
                    '53139',
                    '12842',
                    '43367',
                    '33140',
                    '11360',
                    '63239',
                    '36257',
                    '43244',
                    '41459',
                    '14437',
                    '14734',
                    '24650',
                    '87233',
                    '79298',
                    '19533',
                    '73494',
                    '76150',
                    '50437',
                    '59177',
                    '75241',
                    '97636',
                    '74431',
                    '86193',
                    '16846',
                    '16255',
                    '37144',
                    '36154',
                    '42535',
                    '77140',
                    '23194',
                    '21871',
                    '34332',
                    '71931',
                    '16938',
                    '83732',
                    '16839',
                    '54433',
                    '90422',
                    '66533',
                    '45141',
                    '19476',
                    '14770',
                    '89141',
                    '17461',
                    '80638',
                    '12248',
                    '18738',
                    '21622',
                    '84494',
                    '22476',
                    '88050',
                    '79434',
                    '45491',
                    '41877',
                    '78442',
                    '58594',
                    '27594',
                    '83431',
                    '78192',
                    '84144',
                    '15393',
                    '57438',
                    '28438',
                    '89491',
                    '92042',
                    '23163',
                    '64153',
                    '19432',
                    '25662',
                    '77692',
                    '26436',
                    '71391',
                    '61831',
                    '71830',
                    '43442',
                    '25222',
                    '85653',
                    '47161',
                    '57340',
                    '74530',
                    '15166',
                    '67040',
                    '16354',
                    '41707',
                    '45260',
                    '51393',
                    '42737',
                    '42434',
                    '51832',
                    '62449',
                    '26735',
                    '54532',
                    '16453',
                    '46430',
                    '66432',
                    '81963',
                    '37292',
                    '84090',
                    '78561',
                    '87031',
                    '44555',
                    '19731',
                    '41264',
                    '41833',
                    '58563',
                    '73742',
                    '79333',
                    '14572',
                    '27563',
                    '83170',
                    '46236',
                    '17740',
                    '96192',
                    '73292',
                    '97434',
                    '11849',
                    '30237',
                    '70233',
                    '93733',
                    '41743',
                    '14132',
                    '83798',
                    '41660',
                    '42470',
                    '54631',
                    '66731',
                    '62375',
                    '21420',
                    '93236',
                    '58246',
                    '88151',
                    '31197',
                    '82834',
                    '46135',
                    '41303',
                    '42333',
                    '85752',
                    '84292',
                    '14231',
                    '13667',
                    '75447',
                    '61291',
                    '14945',
                    '23361',
                    '87130',
                    '44454',
                    '58392',
                    '51441',
                    '19630',
                    '27392',
                    '25460',
                    '26537',
                    '59634',
                    '78390',
                    '54941',
                    '26634',
                    '93135',
                    '58725',
                    '16552',
                    '79175',
                    '58642',
                    '11418',
                    '97333',
                    '35597',
                    '46171',
                    '94293',
                    '50734',
                    '26274',
                    '43138',
                    '39236',
                    '79232',
                    '41505',
                    '93632',
                    '60355',
                    '51191',
                    '41462',
                    '42672',
                    '18378',
                    '18279',
                    '39249',
                    '46531',
                    '54730',
                    '43640',
                    '62177',
                    '66630',
                    '79131',
                    '13546',
                    '75326',
                    '12556',
                    '96138',
                    '59573',
                    '18639',
                    '13438',
                    '72213',
                    '75258',
                    '13539',
                    '16965',
                    '26133',
                    '65464',
                    '81150',
                    '53461',
                    '93531',
                    '14891',
                    '14330',
                    '41541',
                    '44940',
                    '42131',
                    '50330',
                    '57539',
                    '13025',
                    '97232',
                    '62230',
                    '28539',
                    '18765',
                    '11324',
                    '44252',
                    '31395',
                    '82593',
                    '11647',
                    '11764',
                    '72356',
                    '41101',
                    '62436',
                    '70381',
                    '43654',
                    '19558',
                    '62141',
                    '62260',
                    '18753',
                    '47298',
                    '72591',
                    '41476',
                    '82471',
                    '31332',
                    '38650',
                    '11668',
                    '41137',
                    '33198',
                    '52197',
                    '36544',
                    '57453',
                    '45133',
                    '72225',
                    '50445',
                    '61168',
                    '44495',
                    '36195',
                    '86336',
                    '11231',
                    '23155',
                    '98144',
                    '73114',
                    '51334',
                    '24161',
                    '59343',
                    '31277',
                    '94137',
                    '35273',
                    '90133',
                    '46794',
                    '72342',
                    '91495',
                    '98238',
                    '61236',
                    '11822',
                    '52340',
                    '41270',
                    '82673',
                    '60240',
                    '79394',
                    '82772',
                    '93794',
                    '72467',
                    '50647',
                    '44697',
                    '16744',
                    '79024',
                    '25249',
                    '27454',
                    '21773',
                    '30290',
                    '15136',
                    '41674',
                    '95242',
                    '31130',
                    '59873',
                    '22220',
                    '26873',
                    '95693',
                    '26972',
                    '65672',
                    '57398',
                    '12461',
                    '18551',
                    '30560',
                    '18450',
                    '11866',
                    '82637',
                    '24295',
                    '17961',
                    '25733',
                    '84598',
                    '26590',
                    '21128',
                    '12139',
                    '52395',
                    '79196',
                    '75471',
                    '74641',
                    '45331',
                    '31174',
                    '89230',
                    '56139',
                    '29139',
                    '59837',
                    '94234',
                    '55473',
                    '80282',
                    '30245',
                    '26936',
                    '65636',
                    '18155',
                    '12065',
                    '43153',
                    '22594',
                    '89331',
                    '24446',
                    '57750',
                    '42835',
                    '42934',
                    '57893',
                    '26260',
                    '28893',
                    '90331',
                    '71431',
                    '58216',
                    '82130',
                    '95297',
                    '75435',
                    '11437',
                    '57255',
                    '11536',
                    '51433',
                    '21131',
                    '18652',
                    '17169',
                    '13453',
                    '75233',
                    '13552',
                    '75332',
                    '59194',
                    '12542',
                    '21571',
                    '26194',
                    '80257',
                    '83245',
                    '18357',
                    '18256',
                    '62194',
                    '56193',
                    '86431',
                    '29193',
                    '70359',
                    '50764',
                    '89133',
                    '82435',
                    '19541',
                    '74047',
                    '11330',
                    '21649',
                    '43348',
                    '16869',
                    '17152',
                    '21847',
                    '55330',
                    '61531',
                    '61430',
                    '16263',
                    '21535',
                    '21232',
                    '71372',
                    '24565',
                    '45177',
                    '76191',
                    '64138',
                    '78069',
                    '59396',
                    '12957',
                    '43351',
                    '33154',
                    '68152',
                    '69593',
                    '43250',
                    '44239',
                    '89177',
                    '17457',
                    '17556',
                    '51631',
                    '62466',
                    '35237',
                    '54292',
                    '16438',
                    '36591',
                    '66392',
                    '47553',
                    '11635',
                    '11734',
                    '15271',
                    '81540',
                    '19462',
                    '11228',
                    '73150',
                    '51370',
                    '31233',
                    '81191',
                    '21377',
                    '82299',
                    '61135',
                    '90436',
                    '12740',
                    '74560',
                    '76393',
                    '67010',
                    '45230',
                    '98191',
                    '63508',
                    '41728',
                    '14159',
                    '64561',
                    '25373',
                    '61632',
                    '44293',
                    '56391',
                    '29391',
                    '64291',
                    '41841',
                    '78456',
                    '61272',
                    '88293',
                    '34160',
                    '85591',
                    '37253',
                    '74830',
                    '12344',
                    '37352',
                    '14243',
                    '15532',
                    '36342',
                    '79341',
                    '74694',
                    '24439',
                    '46831',
                    '54832',
                    '46192',
                    '66932',
                    '54166',
                    '25236',
                    '62343',
                    '81595',
                    '70241',
                    '15172',
                    '12038',
                    '63511',
                    '16340',
                    '14162',
                    '91293',
                    '27151',
                    '51532',
                    '79592',
                    '35574',
                    '45634',
                    '51172',
                    '42341',
                    '61337',
                    '34294',
                    '44338',
                    '93831',
                    '13839',
                    '69791',
                    '93192',
                    '13648',
                    '83164',
                    '29795',
                    '64695',
                    '11549',
                    '17754',
                    '83694',
                    '12146',
                    '21175',
                    '90735',
                    '79143',
                    '71134',
                    '97341',
                    '74496',
                    '87160',
                    '42259',
                    '13156',
                    '21434',
                    '46596',
                    '58252',
                    '90328',
                    '22660',
                    '24493',
                    '56146',
                    '29146',
                    '52142',
                    '60363',
                    '19145',
                    '42143',
                    '91088',
                    '77550',
                    '87294',
                    '85467',
                    '19594',
                    '97592',
                    '62158',
                    '53152',
                    '63353',
                    '41533',
                    '70362',
                    '27656',
                    '56597',
                    '13569',
                    '75309',
                    '86134',
                    '21568',
                    '69142',
                    '69395',
                    '44440',
                    '25474',
                    '94335',
                    '50490',
                    '16953',
                    '26141',
                    '16852',
                    '37150',
                    '54494',
                    '66594',
                    '24538',
                    '77154',
                    '61575',
                    '94533',
                    '76144',
                    '94432',
                    '51994',
                    '50457',
                    '16958',
                    '16859',
                    '57191',
                    '28191',
                    '67291',
                    '24533',
                    '57441',
                    '91803',
                    '72482',
                    '22355',
                    '19553',
                    '51690',
                    '13045',
                    '47293',
                    '11344',
                    '71692',
                    '88030',
                    '45561',
                    '24234',
                    '13933',
                    '35261',
                    '33193',
                    '44175',
                    '11663',
                    '44636',
                    '95337',
                    '92293',
                    '98130',
                    '73160',
                    '83752',
                    '61163',
                    '21761',
                    '95632',
                    '67020',
                    '11267',
                    '72475',
                    '24137',
                    '68591',
                    '62456',
                    '46450',
                    '43972',
                    '47541',
                    '72349',
                    '72336',
                    '60580',
                    '34150',
                    '12473',
                    '11829',
                    '11856',
                    '23831',
                    '16370',
                    '23543',
                    '39357',
                    '25361',
                    '85633',
                    '59896',
                    '12734',
                    '18147',
                    '43141',
                    '28832',
                    '88131',
                    '36431',
                    '95236',
                    '43491',
                    '26878',
                    '95698',
                    '57393',
                    '57832',
                    '21440',
                    '30257',
                    '28393',
                    '13247',
                    '11139',
                    '47495',
                    '81332',
                    '11146',
                    '54992',
                    '37362',
                    '14251',
                    '66892',
                    '52433',
                    '92145',
                    '84593',
                    '69370',
                    '17764',
                    '51492',
                    '12132',
                    '80597',
                    '18497',
                    '73791',
                    '75427',
                    '11425',
                    '87150',
                    '92495',
                    '23741',
                    '56132',
                    '64331',
                    '29132',
                    '51142',
                    '42353',
                    '13797',
                    '23291',
                    '22650',
                    '56231',
                    '57797',
                    '23930',
                    '19254',
                    '89192',
                    '18266',
                    '79151',
                    '25444',
                    '90727',
                    '76174',
                    '17836',
                    '75238',
                    '13559',
                    '75265',
                    '12635',
                    '81130',
                    '21527',
                    '16271',
                    '57166',
                    '37160',
                    '61194',
                    '78693',
                    '18695',
                    '17162',
                    '21855',
                    '56635',
                    '38660',
                    '29635',
                    '64735',
                    '53591',
                    '45596',
                    '56891',
                    '62250',
                    '29198',
                    '29891',
                    '64991',
                    '63341',
                    '69631',
                    '70352',
                    '69532',
                    '52172',
                    '60371',
                    '73834',
                    '42151',
                    '14754',
                    '17445',
                    '69271',
                    '17566',
                    '57595',
                    '12945',
                    '21642',
                    '12866',
                    '43343',
                    '89138',
                    '81174',
                    '90596',
                    '16862',
                    '17159',
                    '84395',
                    '51294',
                    '59153',
                    '16268',
                    '31292',
                    '16941',
                    '26153',
                    '55627',
                    '46890',
                    '61792',
                    '21246',
                    '70510',
                    '94161',
                    '86342',
                    '64133',
                    '51263',
                    '19452',
                    '21239',
                    '21365',
                    '53195',
                    '44131',
                    '44232',
                    '11740',
                    '29374',
                    '69235',
                    '41125',
                    '78466',
                    '86296',
                    '61242',
                    '64634',
                    '68195',
                    '16433',
                    '43297',
                    '66452',
                    '43936',
                    '87015',
                    '69730',
                    '92066',
                    '19469',
                    '11223',
                    '91131',
                    '91993',
                    '91232',
                    '59351',
                    '82292',
                    '26351',
                    '16774',
                    '63503',
                    '69433',
                    '98332',
                    '73362',
                    '41723',
                    '73197',
                    '27143',
                    '14152',
                    '42454',
                    '29437',
                    '54156',
                    '27493',
                    '62351',
                    '44298',
                    '16477',
                    '85237',
                    '18460',
                    '57933',
                    '28933',
                    '52334',
                    '69774',
                    '82661',
                    '60234',
                    '59755',
                    '69334',
                    '85732',
                    '97454',
                    '14556',
                    '95531',
                    '29572',
                    '24731',
                    '24432',
                    '95272',
                    '31144',
                    '46199',
                    '84197',
                    '62348',
                    '94204',
                    '31494',
                    '26942',
                    '14169',
                    '91298',
                    '70217',
                    '41767',
                    '79252',
                    '46155',
                    '29176',
                    '41327',
                    '24371',
                    '26250',
                    '33391',
                    '44333',
                    '73395',
                    '13832',
                    '93199',
                    '53397',
                    '90640',
                    '13643',
                    '11542',
                    '29536',
                    '64436',
                    '46256',
                    '65338',
                    '26654',
                    '93155',
                    '94592',
                    '16576',
                    '27745',
                    '58666',
                    '91333',
                    '42252',
                    '60386',
                    '24335',
                    '82494',
                    '80322',
                    '90323',
                    '34253',
                    '58226',
                    '68360',
                    '42148',
                    '41565',
                    '44737',
                    '52136',
                    '63226',
                    '24630',
                    '42656',
                    '18291',
                    '72134',
                    '27295',
                    '62153',
                    '97252',
                    '80641',
                    '38293',
                    '18741',
                    '12231',
                    '53159',
                    '63358',
                    '74011',
                    '41538',
                    '70369',
                    '60368',
                    '52235',
                    '69675',
                    '13562',
                    '74451',
                    '65594',
                    '21563',
                    '12572',
                    '69136',
                    '59557',
                    '45192',
                    '76130',
                    '13441',
                    '75221',
                    '13567',
                    '65591',
                    '21566',
                    '69133',
                    '59552',
                    '93149',
                    '55305',
                    '45197',
                    '13444',
                    '75224',
                    '57194',
                    '67294',
                    '72487',
                    '91732',
                    '22350',
                    '50452',
                    '19556',
                    '51695',
                    '47296',
                    '11341',
                    '63218',
                    '43265',
                    '41478',
                    '42668',
                    '41139',
                    '24231',
                    '13936',
                    '35264',
                    '33196',
                    '44170',
                    '44273',
                    '38692',
                    '11666',
                    '95332',
                    '81575',
                    '45160',
                    '22349',
                    '98135',
                    '61166',
                    '44633',
                    '13765',
                    '21764',
                    '11262',
                    '45205',
                    '72470',
                    '24132',
                    '89395',
                    '26453',
                    '94139',
                    '68594',
                    '13972',
                    '35220',
                    '26013',
                    '44248',
                    '11622',
                    '98236',
                    '82693',
                    '62453',
                    '61238',
                    '34155',
                    '12476',
                    '33592',
                    '12371',
                    '57972',
                    '28972',
                    '11853',
                    '50649',
                    '29476',
                    '45791',
                    '39352',
                    '25247',
                    '59893',
                    '57361',
                    '12731',
                    '23834',
                    '72469',
                    '16375',
                    '88134',
                    '24770',
                    '95233',
                    '86495',
                    '89241',
                    '43494',
                    '55464',
                    '57396',
                    '21445',
                    '30252',
                    '28396',
                    '15138',
                    '18142',
                    '43144',
                    '13242',
                    '81896',
                    '12432',
                    '74841',
                    '11143',
                    '82639',
                    '77240',
                    '83151',
                    '17761',
                    '21126',
                    '12137',
                    '80592',
                    '18492',
                    '61595',
                    '75422',
                    '11420',
                    '57242',
                    '86145',
                    '67142',
                    '96144',
                    '29137',
                    '59839',
                    '42356',
                    '13792',
                    '26938',
                    '65638',
                    '22655',
                    '14650',
                    '77790',
                    '74962',
                    '28792',
                    '23935',
                    '19251',
                    '18263',
                    '58218',
                    '90362',
                    '57792',
                    '11439',
                    '11538',
                    '81430',
                    '51460',
                    '25441',
                    '17833',
                    '54351',
                    '75260',
                    '12630',
                    '81135',
                    '12533',
                    '16274',
                    '57163',
                    '37165',
                    '61191',
                    '92261',
                    '17167',
                    '76171',
                    '18359',
                    '64730',
                    '45593',
                    '43832',
                    '29894',
                    '63344',
                    '69634',
                    '41524',
                    '70357',
                    '60374',
                    '73831',
                    '42154',
                    '14751',
                    '89160',
                    '29335',
                    '64235',
                    '17563',
                    '12940',
                    '89593',
                    '21647',
                    '12863',
                    '43346',
                    '68392',
                    '90593',
                    '71293',
                    '16867',
                    '36131',
                    '95435',
                    '51291',
                    '12629',
                    '31297',
                    '81171',
                    '21243',
                    '16735',
                    '94164',
                    '43742',
                    '45179',
                    '64136',
                    '78067',
                    '19457',
                    '83498',
                    '44134',
                    '44237',
                    '36232',
                    '22457',
                    '58931',
                    '14452',
                    '17459',
                    '69230',
                    '41120',
                    '35239',
                    '56731',
                    '29731',
                    '64631',
                    '16436',
                    '84561',
                    '43292',
                    '43933',
                    '93895',
                    '87010',
                    '52375',
                    '78463',
                    '82950',
                    '11226',
                    '23142',
                    '91134',
                    '59354',
                    '31260',
                    '26354',
                    '37192',
                    '16771',
                    '27461',
                    '15147',
                    '63506',
                    '69436',
                    '73930',
                    '41726',
                    '73192',
                    '27146',
                    '14157',
                    '56432',
                    '76430',
                    '29432',
                    '64532',
                    '43540',
                    '54153',
                    '62354',
                    '16472',
                    '85232',
                    '52331',
                    '60231',
                    '59750',
                    '69331',
                    '97451',
                    '36333',
                    '14553',
                    '31141',
                    '84192',
                    '25238',
                    '31491',
                    '70212',
                    '69472',
                    '41762',
                    '24734',
                    '46150',
                    '29173',
                    '41322',
                    '55439',
                    '39598',
                    '26255',
                    '44336',
                    '14649',
                    '53392',
                    '14568',
                    '13646',
                    '56533',
                    '11547',
                    '64433',
                    '46253',
                    '97752',
                    '13837',
                    '26651',
                    '93150',
                    '16573',
                    '27740',
                    '58663',
                    '44431',
                    '42257',
                    '12148',
                    '50751',
                    '24330',
                    '82491',
                    '46598',
                    '90326',
                    '44372',
                    '58223',
                    '56148',
                    '82141',
                    '29148',
                    '44732',
                    '52133',
                    '63223',
                    '24635',
                    '82466',
                    '42653',
                    '91431',
                    '72131',
                    '62156',
                    '38296',
                    '18744',
                    '12234',
                    '52230',
                    '64795',
                    '34262',
                    '38233',
                    '56831',
                    '29831',
                    '23734',
                    '46164',
                    '69691',
                    '23635',
                    '29165',
                    '24340',
                    '26243',
                    '21112',
                    '30596',
                    '17272',
                    '92398',
                    '90752',
                    '90653',
                    '13636',
                    '11450',
                    '83192',
                    '57276',
                    '11551',
                    '28276',
                    '42241',
                    '24593',
                    '93164',
                    '21839',
                    '16565',
                    '13469',
                    '21552',
                    '18330',
                    '17676',
                    '18231',
                    '76293',
                    '58235',
                    '47332',
                    '27235',
                    '18770',
                    '33133',
                    '74020',
                    '53135',
                    '44191',
                    '41554',
                    '63235',
                    '43248',
                    '41455',
                    '38736',
                    '26296',
                    '79294',
                    '97241',
                    '23198',
                    '12640',
                    '75311',
                    '57131',
                    '28131',
                    '67231',
                    '37148',
                    '25482',
                    '92332',
                    '83596',
                    '42539',
                    '77133',
                    '55313',
                    '54392',
                    '91191',
                    '66292',
                    '55652',
                    '16934',
                    '43732',
                    '16835',
                    '75650',
                    '12930',
                    '80634',
                    '12244',
                    '12831',
                    '18734',
                    '33177',
                    '37432',
                    '11357',
                    '84498',
                    '37533',
                    '14792',
                    '38471',
                    '15252',
                    '73432',
                    '58598',
                    '35250',
                    '17070',
                    '44144',
                    '44265',
                    '21211',
                    '68430',
                    '57434',
                    '23132',
                    '28434',
                    '45154',
                    '51252',
                    '83741',
                    '42438',
                    '64542',
                    '39366',
                    '91595',
                    '47130',
                    '57333',
                    '28333',
                    '24791',
                    '78431',
                    '52493',
                    '41268',
                    '60593',
                    '84432',
                    '26739',
                    '17997',
                    '43961',
                    '47471',
                    '81833',
                    '78530',
                    '27532',
                    '77230',
                    '78170',
                    '17733',
                    '34143',
                    '79492',
                    '97438',
                    '18437',
                    '74147',
                    '62379',
                    '57377',
                    '63532',
                    '16363',
                    '41712',
                    '88191',
                    '27172',
                    '36491',
                    '77670',
                    '83794',
                    '23536',
                    '43530',
                    '70592',
                    '43431',
                    '25251',
                    '13737',
                    '55450',
                    '74596',
                    '33375',
                    '57636',
                    '24465',
                    '28636',
                    '53272',
                    '57737',
                    '71896',
                    '46139',
                    '24395',
                    '73630',
                    '37371',
                    '14260',
                    '58576',
                    '73731',
                    '27576',
                    '83147',
                    '38893',
                    '78633',
                    '34196',
                    '13131',
                    '21156',
                    '17236',
                    '93139',
                    '58729',
                    '14590',
                    '81440',
                    '36444',
                    '22643',
                    '53236',
                    '41316',
                    '31452',
                    '26278',
                    '43134',
                    '93496',
                    '43897',
                    '81293',
                    '74741',
                    '82892',
                    '63369',
                    '60359',
                    '80274',
                    '18374',
                    '18275',
                    '43633',
                    '39245',
                    '18635',
                    '79160',
                    '27730',
                    '14950',
                    '73234',
                    '96134',
                    '51454',
                    '25457',
                    '13175',
                    '59692',
                    '64830',
                    '92277',
                    '26692',
                    '64193',
                    '17171',
                    '72242',
                    '13434',
                    '79690',
                    '59162',
                    '13535',
                    '26162',
                    '53430',
                    '57175',
                    '16969',
                    '74345',
                    '65468',
                    '73533',
                    '14343',
                    '38332',
                    '70341',
                    '11328',
                    '44933',
                    '52161',
                    '36297',
                    '42160',
                    '82452',
                    '38772',
                    '95793',
                    '50343',
                    '57535',
                    '44832',
                    '28535',
                    '18769',
                    '53171',
                    '63370',
                    '43237',
                    '58963',
                    '41480',
                    '11768',
                    '74794',
                    '43336',
                    '59126',
                    '16970',
                    '16871',
                    '37137',
                    '58334',
                    '27334',
                    '75649',
                    '91832',
                    '50466',
                    '50639',
                    '64597',
                    '94150',
                    '22760',
                    '27433',
                    '23176',
                    '64146',
                    '34394',
                    '69493',
                    '19441',
                    '73137',
                    '57993',
                    '23437',
                    '28993',
                    '41114',
                    '21615',
                    '35249',
                    '93694',
                    '68135',
                    '17069',
                    '58927',
                    '33573',
                    '30578',
                    '41253',
                    '78475',
                    '51841',
                    '16446',
                    '11256',
                    '21749',
                    '25655',
                    '16767',
                    '54145',
                    '62360',
                    '30222',
                    '18132',
                    '70226',
                    '23231',
                    '15151',
                    '41756',
                    '14141',
                    '27136',
                    '41657',
                    '77634',
                    '56291',
                    '42447',
                    '64391',
                    '82751',
                    '95591',
                    '83138',
                    '92129',
                    '78169',
                    '76019',
                    '13232',
                    '13333',
                    '28946',
                    '82650',
                    '60227',
                    '57232',
                    '81495',
                    '28232',
                    '67132',
                    '11449',
                    '66494',
                    '68698',
                    '37234',
                    '74192',
                    '37335',
                    '13672',
                    '75452',
                    '43169',
                    '73335',
                    '38534',
                    '28672',
                    '57773',
                    '95261',
                    '47398',
                    '98495',
                    '33230',
                    '30266',
                    '55449',
                    '33331',
                    '96030',
                    '73330',
                    '38531',
                    '57776',
                    '31152',
                    '22242',
                    '33235',
                    '30263',
                    '44343',
                    '58274',
                    '14191',
                    '38236',
                    '56241',
                    '29834',
                    '23731',
                    '56160',
                    '46161',
                    '69694',
                    '29160',
                    '44792',
                    '21117',
                    '30593',
                    '17277',
                    '65351',
                    '90656',
                    '90629',
                    '11455',
                    '57273',
                    '28273',
                    '46240',
                    '42244',
                    '84231',
                    '93161',
                    '16560',
                    '50742',
                    '19279',
                    '18335',
                    '17673',
                    '18234',
                    '18368',
                    '76296',
                    '90353',
                    '58230',
                    '38272',
                    '33136',
                    '80628',
                    '53130',
                    '44194',
                    '41551',
                    '69560',
                    '63230',
                    '41450',
                    '38733',
                    '59293',
                    '38632',
                    '26293',
                    '79291',
                    '18775',
                    '75314',
                    '57134',
                    '77499',
                    '28134',
                    '83593',
                    '95392',
                    '77136',
                    '55316',
                    '91194',
                    '66297',
                    '22361',
                    '24192',
                    '16931',
                    '61157',
                    '16830',
                    '75655',
                    '24543',
                    '57475',
                    '31350',
                    '12935',
                    '80631',
                    '12241',
                    '12834',
                    '18731',
                    '33172',
                    '37437',
                    '11352',
                    '43276',
                    '33433',
                    '33532',
                    '15257',
                    '18599',
                    '98207',
                    '73437',
                    '59044',
                    '35255',
                    '17075',
                    '44141',
                    '44260',
                    '21214',
                    '68534',
                    '23599',
                    '83395',
                    '57431',
                    '28431',
                    '45151',
                    '77433',
                    '39363',
                    '57336',
                    '21755',
                    '28336',
                    '74539',
                    '24794',
                    '65214',
                    '64547',
                    '60596',
                    '62440',
                    '43964',
                    '47474',
                    '38430',
                    '78434',
                    '52496',
                    '27537',
                    '92135',
                    '17736',
                    '34139',
                    '80433',
                    '18533',
                    '18432',
                    '74142',
                    '47171',
                    '28372',
                    '63537',
                    '16366',
                    '41717',
                    '45252',
                    '88194',
                    '27177',
                    '83791',
                    '41669',
                    '23533',
                    '43535',
                    '25355',
                    '70597',
                    '43434',
                    '85643',
                    '13732',
                    '74593',
                    '21456',
                    '37635',
                    '21429',
                    '24741',
                    '57633',
                    '24460',
                    '28633',
                    '57732',
                    '28732',
                    '54195',
                    '71893',
                    '46493',
                    '37275',
                    '73635',
                    '37374',
                    '14265',
                    '58573',
                    '73734',
                    '83142',
                    '38896',
                    '96175',
                    '34193',
                    '19639',
                    '13134',
                    '21153',
                    '17233',
                    '21582',
                    '23335',
                    '22639',
                    '53233',
                    '41313',
                    '51154',
                    '46178',
                    '43131',
                    '93493',
                    '88141',
                    '43892',
                    '36441',
                    '22646',
                    '75754',
                    '74744',
                    '68233',
                    '68332',
                    '19163',
                    '51198',
                    '80271',
                    '18371',
                    '18270',
                    '43636',
                    '39240',
                    '61029',
                    '18630',
                    '58735',
                    '27735',
                    '79138',
                    '46295',
                    '23371',
                    '98041',
                    '73231',
                    '78672',
                    '96131',
                    '25452',
                    '26697',
                    '64196',
                    '76162',
                    '13431',
                    '13530',
                    '16245',
                    '74340',
                    '87193',
                    '19693',
                    '73536',
                    '14346',
                    '58328',
                    '38337',
                    '52164',
                    '60345',
                    '36292',
                    '42165',
                    '41548',
                    '42138',
                    '62246',
                    '44837',
                    '41515',
                    '70344',
                    '44936',
                    '43232',
                    '14463',
                    '14742',
                    '89151',
                    '81692',
                    '89050',
                    '54793',
                    '66693',
                    '41108',
                    '74791',
                    '43333',
                    '16975',
                    '81162',
                    '16874',
                    '90580',
                    '37132',
                    '58331',
                    '27331',
                    '91703',
                    '50463',
                    '27199',
                    '29492',
                    '64592',
                    '21250',
                    '58436',
                    '27436',
                    '22738',
                    '92034',
                    '11217',
                    '23173',
                    '34391',
                    '69496',
                    '19444',
                    '73132',
                    '96232',
                    '23432',
                    '64262',
                    '41111',
                    '11729',
                    '97561',
                    '93691',
                    '68130',
                    '44158',
                    '57996',
                    '11756',
                    '41256',
                    '60219',
                    '16443',
                    '84572',
                    '47531',
                    '82961',
                    '11253',
                    '31251',
                    '26365',
                    '59338',
                    '26338',
                    '84132',
                    '16762',
                    '62365',
                    '30227',
                    '18137',
                    '62338',
                    '70223',
                    '87391',
                    '23234',
                    '15154',
                    '23841',
                    '19491',
                    '41753',
                    '14144',
                    '27133',
                    '41652',
                    '77631',
                    '42442',
                    '77730',
                    '64394',
                    '31169',
                    '54140',
                    '13237',
                    '13336',
                    '53332',
                    '13349',
                    '28943',
                    '12359',
                    '60222',
                    '82754',
                    '54591',
                    '66491',
                    '97442',
                    '37231',
                    '65348',
                    '37330',
                    '51891',
                    '57237',
                    '82793',
                    '11447',
                    '57261',
                    '74631',
                    '28261',
                    '11520',
                    '68696',
                    '45341',
                    '71595',
                    '17265',
                    '18644',
                    '74895',
                    '65343',
                    '43167',
                    '14637',
                    '24753',
                    '47396',
                    '51164',
                    '30268',
                    '75591',
                    '12048',
                    '55447',
                    '21466',
                    '34231',
                    '82162',
                    '38242',
                    '74941',
                    '45691',
                    '19135',
                    '38792',
                    '59993',
                    '59232',
                    '26993',
                    '26232',
                    '83631',
                    '13140',
                    '92396',
                    '83532',
                    '21141',
                    '12150',
                    '93995',
                    '13638',
                    '90622',
                    '75418',
                    '89691',
                    '53494',
                    '96167',
                    '83334',
                    '17144',
                    '21837',
                    '34374',
                    '91799',
                    '71191',
                    '54336',
                    '13467',
                    '66236',
                    '57140',
                    '28140',
                    '74730',
                    '86441',
                    '37496',
                    '70374',
                    '52154',
                    '19272',
                    '80263',
                    '18363',
                    '61932',
                    '43365',
                    '33142',
                    '11362',
                    '43246',
                    '24652',
                    '87231',
                    '76251',
                    '19531',
                    '34330',
                    '76152',
                    '50435',
                    '59175',
                    '75243',
                    '97634',
                    '26175',
                    '77492',
                    '86191',
                    '16844',
                    '16257',
                    '37146',
                    '83598',
                    '42537',
                    '77142',
                    '23196',
                    '21873',
                    '19474',
                    '51931',
                    '54431',
                    '90420',
                    '66531',
                    '51795',
                    '45143',
                    '68090',
                    '89143',
                    '17463',
                    '33179',
                    '81251',
                    '11359',
                    '21620',
                    '84496',
                    '22474',
                    '45493',
                    '41875',
                    '78440',
                    '58596',
                    '27596',
                    '83433',
                    '78190',
                    '26434',
                    '15391',
                    '94147',
                    '89493',
                    '92040',
                    '23161',
                    '64151',
                    '87330',
                    '19430',
                    '96202',
                    '77690',
                    '46371',
                    '71393',
                    '54170',
                    '61833',
                    '71832',
                    '43440',
                    '25220',
                    '85651',
                    '57342',
                    '74532',
                    '28342',
                    '15164',
                    '16356',
                    '43190',
                    '41705',
                    '14174',
                    '51391',
                    '42735',
                    '57692',
                    '42436',
                    '76457',
                    '28692',
                    '41266',
                    '41831',
                    '51830',
                    '26737',
                    '46731',
                    '84461',
                    '54530',
                    '16451',
                    '88250',
                    '46432',
                    '66430',
                    '81961',
                    '81842',
                    '84092',
                    '78563',
                    '87033',
                    '44557',
                    '19733',
                    '58561',
                    '73740',
                    '79331',
                    '14570',
                    '27561',
                    '83172',
                    '46234',
                    '17742',
                    '54273',
                    '34132',
                    '97436',
                    '18439',
                    '30235',
                    '70231',
                    '93731',
                    '93432',
                    '41741',
                    '51560',
                    '14130',
                    '41662',
                    '23538',
                    '42472',
                    '53292',
                    '54633',
                    '66733',
                    '13739',
                    '22236',
                    '62377',
                    '74598',
                    '21422',
                    '93234',
                    '58244',
                    '28638',
                    '57739',
                    '31195',
                    '56150',
                    '68292',
                    '46137',
                    '29150',
                    '41301',
                    '61293',
                    '85750',
                    '58578',
                    '14233',
                    '13665',
                    '75445',
                    '83149',
                    '55593',
                    '69154',
                    '23363',
                    '87132',
                    '51443',
                    '19632',
                    '25462',
                    '59535',
                    '21158',
                    '17238',
                    '26535',
                    '59636',
                    '78392',
                    '93137',
                    '58727',
                    '79177',
                    '97331',
                    '79230',
                    '53238',
                    '44896',
                    '41318',
                    '35595',
                    '46173',
                    '94291',
                    '93498',
                    '39234',
                    '44351',
                    '62175',
                    '66632',
                    '62276',
                    '82195',
                    '60357',
                    '69550',
                    '51193',
                    '41460',
                    '82445',
                    '42670',
                    '43642',
                    '26571',
                    '17854',
                    '79133',
                    '13544',
                    '75324',
                    '12554',
                    '74334',
                    '25459',
                    '59571',
                    '72211',
                    '50471',
                    '16967',
                    '26131',
                    '65466',
                    '81152',
                    '14893',
                    '14332',
                    '41543',
                    '44942',
                    '42133',
                    '87275',
                    '50332',
                    '62232',
                    '18767',
                    '11326',
                    '70383',
                    '44250',
                    '31397',
                    '82591',
                    '11645',
                    '11766',
                    '41103',
                    '62434',
                    '43338',
                    '43239',
                    '37139',
                    '74387',
                    '21224',
                    '61145',
                    '75647',
                    '47194',
                    '50468',
                    '61495',
                    '38590',
                    '26377',
                    '65224',
                    '59470',
                    '26470',
                    '16752',
                    '22733',
                    '23178',
                    '64148',
                    '11241',
                    '70282',
                    '50637',
                    '27192',
                    '62470',
                    '13951',
                    '92194',
                    '77294',
                    '35247',
                    '17067',
                    '58929',
                    '43954',
                    '23439',
                    '60212',
                    '57296',
                    '16448',
                    '67196',
                    '26773',
                    '12455',
                    '74235',
                    '30576',
                    '11124',
                    '11258',
                    '21747',
                    '19337',
                    '59333',
                    '26333',
                    '46335',
                    '54134',
                    '62333',
                    '30271',
                    '70228',
                    '18161',
                    '12051',
                    '41758',
                    '45295',
                    '27138',
                    '41659',
                    '42449',
                    '45745',
                    '31162',
                    '83136',
                    '23394',
                    '76017',
                    '34176',
                    '13342',
                    '11160',
                    '12352',
                    '37344',
                    '60229',
                    '21449',
                    '23254',
                    '15134',
                    '43148',
                    '41676',
                    '42466',
                    '31132',
                    '54874',
                    '59871',
                    '43498',
                    '22222',
                    '26871',
                    '95691',
                    '12463',
                    '11130',
                    '18452',
                    '11864',
                    '91695',
                    '82635',
                    '24297',
                    '82734',
                    '76021',
                    '17963',
                    '25731',
                    '59592',
                    '52397',
                    '79194',
                    '45333',
                    '73248',
                    '96148',
                    '95204',
                    '45773',
                    '31176',
                    '89232',
                    '59835',
                    '94236',
                    '80280',
                    '30247',
                    '26934',
                    '65634',
                    '18157',
                    '12067',
                    '43151',
                    '24444',
                    '82132',
                    '95295',
                    '42837',
                    '57891',
                    '80310',
                    '26262',
                    '90333',
                    '71433',
                    '58214',
                    '66831',
                    '71172',
                    '75437',
                    '11435',
                    '57257',
                    '11534',
                    '96151',
                    '51431',
                    '83562',
                    '81391',
                    '21133',
                    '18650',
                    '54931',
                    '17840',
                    '13451',
                    '75231',
                    '13550',
                    '75330',
                    '59196',
                    '12540',
                    '21573',
                    '81139',
                    '71941',
                    '42158',
                    '80255',
                    '83247',
                    '18355',
                    '18254',
                    '62196',
                    '56191',
                    '86433',
                    '62259',
                    '29191',
                    '86532',
                    '63348',
                    '41528',
                    '60378',
                    '89131',
                    '95042',
                    '87243',
                    '29339',
                    '19543',
                    '13055',
                    '12265',
                    '74045',
                    '11332',
                    '16261',
                    '21537',
                    '74364',
                    '77013',
                    '17150',
                    '21845',
                    '55332',
                    '61533',
                    '61432',
                    '21230',
                    '61173',
                    '16739',
                    '45175',
                    '76193',
                    '45892',
                    '90571',
                    '26394',
                    '12955',
                    '43353',
                    '33156',
                    '68150',
                    '69591',
                    '43252',
                    '44138',
                    '45535',
                    '17455',
                    '17554',
                    '51633',
                    '41249',
                    '62464',
                    '35235',
                    '36593',
                    '47551',
                    '11637',
                    '74292',
                    '11736',
                    '19460',
                    '73152',
                    '31231',
                    '81193',
                    '21375',
                    '26358',
                    '61137',
                    '90434',
                    '46392',
                    '71334',
                    '12742',
                    '74562',
                    '76391',
                    '45232',
                    '98193',
                    '77750',
                    '61731',
                    '61630',
                    '25270',
                    '46462',
                    '44291',
                    '56393',
                    '29393',
                    '64293',
                    '41843',
                    '78454',
                    '51677',
                    '82668',
                    '88291',
                    '54245',
                    '71532',
                    '37251',
                    '74832',
                    '12346',
                    '14241',
                    '15530',
                    '74696',
                    '82231',
                    '38551',
                    '46833',
                    '66930',
                    '54164',
                    '25234',
                    '62341',
                    '26868',
                    '81740',
                    '63513',
                    '16342',
                    '14160',
                    '91291',
                    '27153',
                    '14645',
                    '79590',
                    '51170',
                    '42343',
                    '61335',
                    '39594',
                    '69793',
                    '93932',
                    '14564',
                    '83166',
                    '43085',
                    '17756',
                    '12144',
                    '21177',
                    '90737',
                    '71994',
                    '79141',
                    '71136',
                    '66192',
                    '97343',
                    '74494',
                    '87162',
                    '98065',
                    '14870',
                    '13154',
                    '21436',
                    '46594',
                    '24491',
                    '56144',
                    '29144',
                    '52140',
                    '60361',
                    '19147',
                    '42141',
                    '19266',
                    '87296',
                    '19596',
                    '80648',
                    '12238',
                    '53150',
                    '63351',
                    '41531',
                    '70360',
                    '75228',
                    '12678',
                    '86136',
                    '14935',
                    '44442',
                    '14834',
                    '25476',
                    '93145',
                    '50492',
                    '16951',
                    '26143',
                    '16850',
                    '37152',
                    '36142',
                    '94531',
                    '76146',
                    '51996',
                    '43656',
                    '62143',
                    '18751',
                    '72593',
                    '43269',
                    '41474',
                    '82473',
                    '31330',
                    '41135',
                    '26790',
                    '52195',
                    '22460',
                    '95723',
                    '45131',
                    '72227',
                    '98139',
                    '50447',
                    '44640',
                    '44497',
                    '15336',
                    '36197',
                    '13769',
                    '86334',
                    '11233',
                    '98146',
                    '59341',
                    '31275',
                    '89399',
                    '54694',
                    '94135',
                    '35271',
                    '90131',
                    '71631',
                    '46796',
                    '44165',
                    '44244',
                    '82330',
                    '72340',
                    '91497',
                    '61234',
                    '11820',
                    '41272',
                    '60242',
                    '82770',
                    '93796',
                    '23838',
                    '72465',
                    '65230',
                    '44695',
                    '25368',
                    '79026',
                    '27456',
                    '21771',
                    '30292',
                    '68051',
                    '93791',
                    '72462',
                    '50642',
                    '44692',
                    '16741',
                    '39359',
                    '93061',
                    '79021',
                    '27451',
                    '59898',
                    '30295',
                    '23253',
                    '15133',
                    '12079',
                    '69460',
                    '41770',
                    '42740',
                    '41671',
                    '42461',
                    '31135',
                    '54873',
                    '22225',
                    '26876',
                    '26977',
                    '30259',
                    '12464',
                    '13249',
                    '30565',
                    '11137',
                    '11863',
                    '91692',
                    '11148',
                    '82632',
                    '82733',
                    '59595',
                    '52390',
                    '18499',
                    '79193',
                    '75429',
                    '45334',
                    '31171',
                    '59832',
                    '94231',
                    '26832',
                    '59933',
                    '80287',
                    '30240',
                    '26933',
                    '65633',
                    '18150',
                    '12060',
                    '22591',
                    '24762',
                    '57799',
                    '42830',
                    '42931',
                    '26265',
                    '90334',
                    '71434',
                    '44360',
                    '18268',
                    '58213',
                    '82135',
                    '95292',
                    '90729',
                    '75430',
                    '11432',
                    '57250',
                    '11533',
                    '67150',
                    '81396',
                    '21134',
                    '17838',
                    '75236',
                    '75337',
                    '59191',
                    '12547',
                    '21574',
                    '26191',
                    '57168',
                    '59540',
                    '26540',
                    '80252',
                    '18352',
                    '18253',
                    '45598',
                    '43839',
                    '62191',
                    '56196',
                    '74970',
                    '50761',
                    '82531',
                    '19544',
                    '17568',
                    '12262',
                    '89598',
                    '11335',
                    '44850',
                    '12868',
                    '44951',
                    '89136',
                    '82430',
                    '74363',
                    '28153',
                    '27356',
                    '77014',
                    '17157',
                    '21842',
                    '55335',
                    '75272',
                    '16266',
                    '61174',
                    '55629',
                    '95441',
                    '45172',
                    '76194',
                    '17892',
                    '59393',
                    '21237',
                    '12952',
                    '33151',
                    '69596',
                    '43255',
                    '45532',
                    '17452',
                    '17553',
                    '78468',
                    '13960',
                    '35232',
                    '68892',
                    '36594',
                    '43299',
                    '11630',
                    '74295',
                    '11731',
                    '51634',
                    '81545',
                    '19467',
                    '31236',
                    '81194',
                    '21372',
                    '90532',
                    '71232',
                    '61130',
                    '90433',
                    '46395',
                    '71333',
                    '61893',
                    '12745',
                    '45235',
                    '45840',
                    '98194',
                    '96299',
                    '29439',
                    '25277',
                    '13755',
                    '46465',
                    '44296',
                    '16479',
                    '85239',
                    '56394',
                    '29394',
                    '64294',
                    '15230',
                    '78453',
                    '98260',
                    '73450',
                    '54242',
                    '43992',
                    '66342',
                    '12341',
                    '14558',
                    '86232',
                    '74691',
                    '41769',
                    '46834',
                    '46197',
                    '54163',
                    '25233',
                    '62346',
                    '63514',
                    '16345',
                    '45271',
                    '70219',
                    '27154',
                    '45730',
                    '35571',
                    '45631',
                    '61332',
                    '39593',
                    '34291',
                    '84010',
                    '69794',
                    '93197',
                    '14563',
                    '60560',
                    '89631',
                    '83161',
                    '43082',
                    '17751',
                    '29538',
                    '83691',
                    '12143',
                    '90730',
                    '71993',
                    '79146',
                    '71131',
                    '66195',
                    '36392',
                    '16578',
                    '97344',
                    '74493',
                    '87165',
                    '98062',
                    '25435',
                    '13153',
                    '81792',
                    '21431',
                    '46593',
                    '58228',
                    '56143',
                    '64362',
                    '46142',
                    '29143',
                    '19140',
                    '42146',
                    '63228',
                    '42658',
                    '87291',
                    '85462',
                    '19591',
                    '97597',
                    '53157',
                    '63356',
                    '41536',
                    '70367',
                    '52147',
                    '60366',
                    '56592',
                    '86131',
                    '69147',
                    '14932',
                    '93593',
                    '44445',
                    '69138',
                    '14833',
                    '25471',
                    '59559',
                    '93142',
                    '58752',
                    '50495',
                    '16956',
                    '26144',
                    '16857',
                    '37155',
                    '54491',
                    '66591',
                    '51735',
                    '42542',
                    '77151',
                    '76141',
                    '66140',
                    '51991',
                    '61031',
                    '43651',
                    '62144',
                    '62265',
                    '41572',
                    '23941',
                    '72594',
                    '41473',
                    '82474',
                    '41132',
                    '19793',
                    '59797',
                    '21633',
                    '37450',
                    '52192',
                    '88041',
                    '22467',
                    '14440',
                    '36541',
                    '14761',
                    '44638',
                    '51771',
                    '72220',
                    '94473',
                    '81141',
                    '69192',
                    '15331',
                    '86333',
                    '11234',
                    '76343',
                    '11269',
                    '98141',
                    '73111',
                    '24164',
                    '31272',
                    '24139',
                    '54693',
                    '94132',
                    '62458',
                    '46791',
                    '44243',
                    '11775',
                    '29341',
                    '11629',
                    '72347',
                    '91490',
                    '72338',
                    '61233',
                    '84551',
                    '11827',
                    '52345',
                    '41275',
                    '82676',
                    '11858',
                    '60245',
                    '79391',
                    '59742',
                    '12470',
                    '33594',
                    '41278',
                    '11855',
                    '16373',
                    '45797',
                    '39354',
                    '25362',
                    '25241',
                    '85630',
                    '59895',
                    '12737',
                    '23832',
                    '43142',
                    '28831',
                    '88132',
                    '31138',
                    '95235',
                    '45760',
                    '43492',
                    '22228',
                    '55462',
                    '57831',
                    '21443',
                    '30254',
                    '18144',
                    '13244',
                    '47496',
                    '81331',
                    '11145',
                    '54991',
                    '37361',
                    '14252',
                    '66891',
                    '52430',
                    '79350',
                    '92146',
                    '83157',
                    '69373',
                    '51491',
                    '21120',
                    '17240',
                    '12131',
                    '18494',
                    '61593',
                    '13659',
                    '73792',
                    '75424',
                    '11426',
                    '86143',
                    '87153',
                    '96142',
                    '23742',
                    '53240',
                    '56131',
                    '64332',
                    '23661',
                    '29131',
                    '51141',
                    '42943',
                    '42350',
                    '13794',
                    '57875',
                    '22653',
                    '56232',
                    '57794',
                    '68240',
                    '23933',
                    '19257',
                    '26268',
                    '29672',
                    '83254',
                    '90339',
                    '18265',
                    '43870',
                    '90364',
                    '79152',
                    '38830',
                    '83568',
                    '21139',
                    '13165',
                    '71178',
                    '17835',
                    '75266',
                    '21579',
                    '12636',
                    '81133',
                    '12535',
                    '16272',
                    '57165',
                    '37163',
                    '61197',
                    '89441',
                    '18696',
                    '92267',
                    '17161',
                    '56636',
                    '38663',
                    '53592',
                    '45595',
                    '43834',
                    '56892',
                    '29892',
                    '63342',
                    '69632',
                    '93651',
                    '41522',
                    '70351',
                    '69531',
                    '52171',
                    '60372',
                    '42152',
                    '29333',
                    '17446',
                    '69272',
                    '64233',
                    '15297',
                    '17565',
                    '57596',
                    '12946',
                    '89595',
                    '11338',
                    '21641',
                    '81230',
                    '12865',
                    '68394',
                    '90595',
                    '71295',
                    '16861',
                    '95433',
                    '55338',
                    '84396',
                    '59150',
                    '31291',
                    '61791',
                    '21245',
                    '16733',
                    '94162',
                    '86341',
                    '81537',
                    '64130',
                    '78061',
                    '51260',
                    '19451',
                    '21366',
                    '53196',
                    '44132',
                    '44990',
                    '44231',
                    '58937',
                    '11743',
                    '69236',
                    '41126',
                    '78465',
                    '86295',
                    '61241',
                    '68196',
                    '16430',
                    '43294',
                    '66451',
                    '43935',
                    '93893',
                    '87016',
                    '11220',
                    '23144',
                    '91132',
                    '91231',
                    '59352',
                    '81199',
                    '82291',
                    '26352',
                    '37194',
                    '45238',
                    '98199',
                    '69430',
                    '98331',
                    '73361',
                    '41720',
                    '73194',
                    '27140',
                    '14151',
                    '41647',
                    '42457',
                    '56434',
                    '29434',
                    '64534',
                    '54155',
                    '13758',
                    '62352',
                    '12748',
                    '45393',
                    '16474',
                    '85234',
                    '18463',
                    '12333',
                    '57930',
                    '44536',
                    '52337',
                    '82662',
                    '85599',
                    '85731',
                    '36335',
                    '95532',
                    '24431',
                    '95271',
                    '84194',
                    '45643',
                    '31497',
                    '26941',
                    '12030',
                    '63519',
                    '41739',
                    '70214',
                    '71493',
                    '41764',
                    '24732',
                    '27261',
                    '29175',
                    '42349',
                    '41324',
                    '24372',
                    '26253',
                    '33392',
                    '44330',
                    '73396',
                    '79251',
                    '53394',
                    '90643',
                    '13640',
                    '75460',
                    '74650',
                    '11541',
                    '29535',
                    '64435',
                    '46255',
                    '14995',
                    '97754',
                    '13831',
                    '93156',
                    '94591',
                    '16575',
                    '58665',
                    '72630',
                    '25438',
                    '42251',
                    '60385',
                    '24336',
                    '80321',
                    '90320',
                    '34250',
                    '44374',
                    '58225',
                    '41566',
                    '44734',
                    '52135',
                    '60336',
                    '63225',
                    '24633',
                    '82460',
                    '42655',
                    '72137',
                    '27296',
                    '62150',
                    '97251',
                    '80642',
                    '38290',
                    '18742',
                    '12232',
                    '74012',
                    '52236',
                    '69676',
                    '13561',
                    '65597',
                    '21560',
                    '12571',
                    '44448',
                    '69135',
                    '59554',
                    '55303',
                    '45191',
                    '76133',
                    '13442',
                    '75222',
                    '65560',
                    '57192',
                    '28192',
                    '67292',
                    '57442',
                    '72481',
                    '22356',
                    '50454',
                    '19550',
                    '62149',
                    '51693',
                    '11347',
                    '71691',
                    '43263',
                    '82479',
                    '36533',
                    '13930',
                    '35262',
                    '44275',
                    '38694',
                    '95334',
                    '77190',
                    '98133',
                    '77440',
                    '83751',
                    '54450',
                    '61160',
                    '90441',
                    '44635',
                    '13763',
                    '11239',
                    '21762',
                    '95631',
                    '11264',
                    '72476',
                    '24134',
                    '68592',
                    '13974',
                    '37590',
                    '43971',
                    '47542',
                    '11624',
                    '87052',
                    '72335',
                    '82695',
                    '62455',
                    '22478',
                    '98291',
                    '61994',
                    '12932',
                    '80636',
                    '12246',
                    '12833',
                    '18736',
                    '43370',
                    '37430',
                    '11355',
                    '36240',
                    '37531',
                    '44267',
                    '38473',
                    '15250',
                    '73430',
                    '41879',
                    '59043',
                    '35252',
                    '17072',
                    '44146',
                    '55614',
                    '21213',
                    '68432',
                    '26438',
                    '68533',
                    '83392',
                    '57436',
                    '28436',
                    '51250',
                    '77434',
                    '29440',
                    '64540',
                    '39364',
                    '91597',
                    '13771',
                    '47132',
                    '57331',
                    '12761',
                    '21752',
                    '28331',
                    '15168',
                    '41709',
                    '24793',
                    '42739',
                    '78433',
                    '52491',
                    '60591',
                    '85240',
                    '84531',
                    '17995',
                    '43963',
                    '81930',
                    '81831',
                    '11847',
                    '79360',
                    '27530',
                    '92132',
                    '77232',
                    '78172',
                    '17731',
                    '34141',
                    '46238',
                    '79490',
                    '80434',
                    '18534',
                    '18435',
                    '74145',
                    '57375',
                    '30239',
                    '16361',
                    '18129',
                    '41710',
                    '88193',
                    '93441',
                    '27170',
                    '36493',
                    '77672',
                    '83796',
                    '23534',
                    '43532',
                    '25352',
                    '43433',
                    '85644',
                    '24397',
                    '55452',
                    '74594',
                    '33377',
                    '41680',
                    '58248',
                    '42490',
                    '28634',
                    '57735',
                    '31199',
                    '54192',
                    '71894',
                    '46494',
                    '54266',
                    '11157',
                    '73632',
                    '37373',
                    '14262',
                    '58574',
                    '73733',
                    '13669',
                    '75449',
                    '83145',
                    '38891',
                    '21585',
                    '23332',
                    '78631',
                    '87141',
                    '73272',
                    '34194',
                    '19641',
                    '13133',
                    '21154',
                    '17234',
                    '26539',
                    '81442',
                    '11416',
                    '86151',
                    '39238',
                    '53234',
                    '41314',
                    '35599',
                    '51153',
                    '43136',
                    '93494',
                    '43895',
                    '66641',
                    '75753',
                    '62179',
                    '74743',
                    '68234',
                    '19164',
                    '77571',
                    '80276',
                    '18376',
                    '18277',
                    '39247',
                    '18637',
                    '58732',
                    '79162',
                    '27732',
                    '13548',
                    '75328',
                    '12558',
                    '23376',
                    '44461',
                    '96136',
                    '25455',
                    '92275',
                    '78334',
                    '64191',
                    '17173',
                    '72240',
                    '78235',
                    '76165',
                    '13436',
                    '59160',
                    '13537',
                    '26160',
                    '53432',
                    '57177',
                    '87194',
                    '58372',
                    '73531',
                    '14341',
                    '38330',
                    '41512',
                    '70343',
                    '44931',
                    '52163',
                    '50790',
                    '36295',
                    '42162',
                    '82450',
                    '38770',
                    '95791',
                    '57537',
                    '44830',
                    '28537',
                    '53173',
                    '16491',
                    '43235',
                    '58961',
                    '41482',
                    '14464',
                    '14745',
                    '81695',
                    '66694',
                    '72358',
                    '62438',
                    '43334',
                    '16972',
                    '16873',
                    '90587',
                    '37135',
                    '21228',
                    '58336',
                    '27336',
                    '47198',
                    '91931',
                    '91704',
                    '50464',
                    '61499',
                    '24140',
                    '65228',
                    '29495',
                    '94152',
                    '22762',
                    '58431',
                    '27431',
                    '34396',
                    '69491',
                    '19443',
                    '73135',
                    '33571',
                    '57991',
                    '23435',
                    '41116',
                    '15249',
                    '21617',
                    '68137',
                    '58925',
                    '12459',
                    '11128',
                    '52361',
                    '41251',
                    '78477',
                    '51843',
                    '16444',
                    '47536',
                    '54138',
                    '25268',
                    '11254',
                    '25657',
                    '59362',
                    '26362',
                    '16765',
                    '54147',
                    '62362',
                    '30220',
                    '18130',
                    '70224',
                    '23233',
                    '15153',
                    '44391',
                    '73373',
                    '14143',
                    '27134',
                    '41655',
                    '77636',
                    '59492',
                    '42445',
                    '26492',
                    '64393',
                    '82753',
                    '13230',
                    '13331',
                    '60225',
                    '57230',
                    '67130',
                    '72691',
                    '66496',
                    '37236',
                    '74190',
                    '17269',
                    '18648',
                    '90749',
                    '37337',
                    '13670',
                    '75450',
                    '33333',
                    '73337',
                    '57771',
                    '95263',
                    '45750',
                    '45651',
                    '51168',
                    '33232',
                    '30264',
                    '12044',
                    '34260',
                    '44344',
                    '58273',
                    '38231',
                    '29833',
                    '23736',
                    '46166',
                    '69693',
                    '23637',
                    '29167',
                    '44795',
                    '19139',
                    '59241',
                    '26241',
                    '94699',
                    '83541',
                    '30594',
                    '17270',
                    '90750',
                    '90651',
                    '85358',
                    '11452',
                    '57274',
                    '11553',
                    '28274',
                    '42243',
                    '24591',
                    '17148',
                    '91795',
                    '21550',
                    '68630',
                    '38275',
                    '47231',
                    '70378',
                    '50745',
                    '18332',
                    '17674',
                    '18233',
                    '76291',
                    '90354',
                    '58237',
                    '27237',
                    '18772',
                    '33131',
                    '53137',
                    '43369',
                    '44193',
                    '41556',
                    '63237',
                    '41457',
                    '38734',
                    '59294',
                    '38635',
                    '26294',
                    '19560',
                    '79296',
                    '50439',
                    '12642',
                    '75313',
                    '59179',
                    '57133',
                    '67332',
                    '28133',
                    '16848',
                    '83594',
                    '95395',
                    '92231',
                    '77131',
                    '55311',
                    '91193',
                    '19478',
                    '24195',
                    '55650',
                    '16936',
                    '74392',
                    '61150',
                    '43730',
                    '16837',
                    '75652',
                    '24544',
                    '57472',
                    '54395',
                    '66295',
                    '22363',
                    '16933',
                    '61155',
                    '43735',
                    '16832',
                    '75657',
                    '24541',
                    '76241',
                    '61991',
                    '12937',
                    '80633',
                    '12243',
                    '12836',
                    '18733',
                    '43375',
                    '37435',
                    '11350',
                    '37534',
                    '43274',
                    '33431',
                    '33530',
                    '98205',
                    '73435',
                    '59046',
                    '13941',
                    '35257',
                    '17077',
                    '44143',
                    '78199',
                    '21216',
                    '83397',
                    '57433',
                    '28433',
                    '45153',
                    '23168',
                    '19439',
                    '25669',
                    '77431',
                    '55611',
                    '64545',
                    '39361',
                    '91592',
                    '25229',
                    '57334',
                    '21757',
                    '28334',
                    '24796',
                    '65216',
                    '41838',
                    '60594',
                    '62442',
                    '81834',
                    '98241',
                    '78436',
                    '27535',
                    '73749',
                    '92137',
                    '27568',
                    '17734',
                    '34144',
                    '79495',
                    '80431',
                    '18531',
                    '12360',
                    '18430',
                    '74140',
                    '11842',
                    '47173',
                    '63535',
                    '16364',
                    '41715',
                    '45250',
                    '27175',
                    '36496',
                    '58128',
                    '41748',
                    '14139',
                    '83793',
                    '23531',
                    '43537',
                    '70595',
                    '43436',
                    '85641',
                    '55457',
                    '42338',
                    '21454',
                    '37637',
                    '33372',
                    '57631',
                    '24462',
                    '28631',
                    '57730',
                    '89250',
                    '54197',
                    '71891',
                    '29159',
                    '41308',
                    '24392',
                    '46491',
                    '17770',
                    '37277',
                    '74850',
                    '11152',
                    '84299',
                    '58571',
                    '52441',
                    '27571',
                    '83140',
                    '38894',
                    '96177',
                    '34191',
                    '13136',
                    '21151',
                    '17231',
                    '16559',
                    '58649',
                    '21580',
                    '23337',
                    '22644',
                    '53231',
                    '41311',
                    '51156',
                    '43133',
                    '93491',
                    '36443',
                    '75756',
                    '81294',
                    '82895',
                    '68231',
                    '68330',
                    '19161',
                    '41469',
                    '42679',
                    '43634',
                    '18632',
                    '12162',
                    '58737',
                    '27737',
                    '27636',
                    '38841',
                    '46297',
                    '73233',
                    '96133',
                    '51453',
                    '25450',
                    '13172',
                    '78331',
                    '26695',
                    '64194',
                    '72245',
                    '78230',
                    '76160',
                    '13433',
                    '72218',
                    '50478',
                    '26165',
                    '59138',
                    '16247',
                    '57172',
                    '26138',
                    '87191',
                    '19691',
                    '73534',
                    '14344',
                    '38335',
                    '59695',
                    '44934',
                    '60347',
                    '42167',
                    '82455',
                    '38775',
                    '95794',
                    '62244',
                    '62138',
                    '57532',
                    '97239',
                    '44835',
                    '28532',
                    '41517',
                    '70346',
                    '43230',
                    '58964',
                    '14461',
                    '14740',
                    '81690',
                    '54791',
                    '66691',
                    '74793',
                    '81241',
                    '43331',
                    '81160',
                    '16876',
                    '53473',
                    '90582',
                    '37130',
                    '58333',
                    '27333',
                    '50461',
                    '38599',
                    '21252',
                    '58434',
                    '27434',
                    '11215',
                    '34393',
                    '69494',
                    '11248',
                    '19446',
                    '73130',
                    '11754',
                    '28994',
                    '64260',
                    '41113',
                    '59039',
                    '21612',
                    '93693',
                    '68132',
                    '33574',
                    '57994',
                    '41254',
                    '78472',
                    '16441',
                    '47432',
                    '53374',
                    '11251',
                    '73992',
                    '31253',
                    '76492',
                    '79091',
                    '62367',
                    '30225',
                    '18135',
                    '70221',
                    '23236',
                    '15156',
                    '23843',
                    '12058',
                    '14146',
                    '27131',
                    '41650',
                    '77633',
                    '42440',
                    '92432',
                    '77732',
                    '64396',
                    '54142',
                    '95596',
                    '13235',
                    '13334',
                    '80428',
                    '53330',
                    '28941',
                    '60220',
                    '81492',
                    '28235',
                    '54593',
                    '74638',
                    '28268',
                    '11529',
                    '66493',
                    '37233',
                    '74195',
                    '37332',
                    '41281',
                    '13675',
                    '57235',
                    '96032',
                    '73332',
                    '38533',
                    '28675',
                    '57774',
                    '31150',
                    '45755',
                    '98492',
                    '22240',
                    '33237',
                    '30261',
                    '75598',
                    '34265',
                    '44341',
                    '18249',
                    '58276',
                    '17668',
                    '38234',
                    '23733',
                    '56162',
                    '74948',
                    '46163',
                    '69696',
                    '23632',
                    '29162',
                    '56692',
                    '26244',
                    '29692',
                    '64792',
                    '21115',
                    '30591',
                    '17275',
                    '13149',
                    '90755',
                    '21148',
                    '90654',
                    '11457',
                    '11556',
                    '28271',
                    '46242',
                    '42246',
                    '84233',
                    '93163',
                    '84332',
                    '16562',
                    '71198',
                    '68635',
                    '28149',
                    '91341',
                    '74951',
                    '52292',
                    '50740',
                    '18337',
                    '17671',
                    '18236',
                    '76294',
                    '90351',
                    '58232',
                    '27232',
                    '82150',
                    '33134',
                    '53132',
                    '44196',
                    '41553',
                    '44970',
                    '63232',
                    '41452',
                    '38731',
                    '59291',
                    '38630',
                    '26291',
                    '69292',
                    '19565',
                    '79293',
                    '17549',
                    '18777',
                    '75217',
                    '12647',
                    '75316',
                    '57136',
                    '28136',
                    '83591',
                    '77134',
                    '55314',
                    '34336',
                    '76154',
                    '75218',
                    '50433',
                    '12648',
                    '75319',
                    '59173',
                    '97632',
                    '57139',
                    '26173',
                    '28139',
                    '16842',
                    '37140',
                    '15360',
                    '42531',
                    '21875',
                    '45145',
                    '68096',
                    '19472',
                    '73140',
                    '90426',
                    '75658',
                    '51793',
                    '56013',
                    '23440',
                    '17465',
                    '12938',
                    '12839',
                    '22472',
                    '58950',
                    '79430',
                    '18594',
                    '45495',
                    '73692',
                    '41873',
                    '35258',
                    '17078',
                    '54572',
                    '64650',
                    '78196',
                    '26432',
                    '23594',
                    '94141',
                    '83398',
                    '79070',
                    '89495',
                    '23167',
                    '19436',
                    '25666',
                    '94491',
                    '77696',
                    '59432',
                    '21219',
                    '25341',
                    '54176',
                    '61835',
                    '43446',
                    '25226',
                    '21758',
                    '74534',
                    '28344',
                    '15162',
                    '16350',
                    '41703',
                    '14172',
                    '24799',
                    '51397',
                    '65219',
                    '57694',
                    '19735',
                    '41260',
                    '41837',
                    '82762',
                    '59731',
                    '26731',
                    '46434',
                    '37296',
                    '84094',
                    '78439',
                    '73746',
                    '14576',
                    '27567',
                    '83174',
                    '46232',
                    '17744',
                    '96196',
                    '54275',
                    '73296',
                    '34134',
                    '37261',
                    '30233',
                    '26962',
                    '70237',
                    '41747',
                    '41664',
                    '43538',
                    '53294',
                    '43439',
                    '62371',
                    '21424',
                    '93232',
                    '58242',
                    '51591',
                    '31193',
                    '82830',
                    '54198',
                    '54891',
                    '46131',
                    '29156',
                    '66991',
                    '41307',
                    '55458',
                    '42337',
                    '61295',
                    '37278',
                    '37379',
                    '14235',
                    '13663',
                    '75443',
                    '69152',
                    '14941',
                    '23365',
                    '19634',
                    '13139',
                    '27396',
                    '25464',
                    '59533',
                    '26533',
                    '93131',
                    '16556',
                    '79171',
                    '58646',
                    '23338',
                    '79236',
                    '35593',
                    '51159',
                    '45932',
                    '50730',
                    '26270',
                    '80302',
                    '39232',
                    '75759',
                    '62173',
                    '62270',
                    '82193',
                    '63361',
                    '60351',
                    '51195',
                    '42171',
                    '41466',
                    '82443',
                    '42676',
                    '61024',
                    '43644',
                    '58738',
                    '17852',
                    '79135',
                    '13542',
                    '75322',
                    '12552',
                    '74332',
                    '72217',
                    '59137',
                    '16961',
                    '26137',
                    '65460',
                    '81154',
                    '14895',
                    '41545',
                    '44944',
                    '42135',
                    '50334',
                    '62137',
                    '97236',
                    '62234',
                    '18761',
                    '70349',
                    '11320',
                    '60348',
                    '70385',
                    '31391',
                    '11643',
                    '11760',
                    '72352',
                    '41105',
                    '62432',
                    '77463',
                    '83772',
                    '74381',
                    '21222',
                    '47192',
                    '61493',
                    '59371',
                    '26371',
                    '31245',
                    '65222',
                    '16754',
                    '22735',
                    '92039',
                    '33292',
                    '18190',
                    '11247',
                    '19449',
                    '70284',
                    '50631',
                    '27194',
                    '15243',
                    '59036',
                    '92192',
                    '35241',
                    '26036',
                    '17061',
                    '39470',
                    '44155',
                    '43952',
                    '11122',
                    '18440',
                    '74130',
                    '60214',
                    '26775',
                    '82391',
                    '12453',
                    '74233',
                    '30570',
                    '13740',
                    '21741',
                    '68061',
                    '37692',
                    '72455',
                    '19331',
                    '59335',
                    '21291',
                    '46333',
                    '54132',
                    '62368',
                    '22274',
                    '62335',
                    '80292',
                    '30277',
                    '23239',
                    '15159',
                    '18167',
                    '12057',
                    '45293',
                    '14149',
                    '64399',
                    '45743',
                    '31164',
                    '45660',
                    '86241',
                    '83130',
                    '23392',
                    '78161',
                    '54231',
                    '34170',
                    '66331',
                    '80427',
                    '13344',
                    '12354',
                    '37342',
                    '93333',
                    '95599',
                    '82795',
                    '11441',
                    '67392',
                    '74637',
                    '28267',
                    '11526',
                    '71593',
                    '17263',
                    '18642',
                    '74893',
                    '65345',
                    '90743',
                    '90660',
                    '43161',
                    '14631',
                    '24755',
                    '23642',
                    '61691',
                    '51162',
                    '42373',
                    '33238',
                    '75597',
                    '61341',
                    '18246',
                    '43853',
                    '90347',
                    '38244',
                    '74947',
                    '68340',
                    '19133',
                    '38794',
                    '26995',
                    '26234',
                    '13146',
                    '21147',
                    '12156',
                    '93993',
                    '15591',
                    '90624',
                    '85352',
                    '11458',
                    '11559',
                    '53492',
                    '96161',
                    '83332',
                    '57496',
                    '17142',
                    '21831',
                    '55320',
                    '34372',
                    '71197',
                    '54330',
                    '66133',
                    '13461',
                    '66230',
                    '12651',
                    '68492',
                    '28146',
                    '42249',
                    '53142',
                    '70372',
                    '52152',
                    '73850',
                    '19274',
                    '18338',
                    '80265',
                    '18239',
                    '18365',
                    '64751',
                    '61934',
                    '79531',
                    '12846',
                    '43363',
                    '33144',
                    '68142',
                    '11364',
                    '36253',
                    '43240',
                    '14433',
                    '14730',
                    '45541',
                    '78592',
                    '17546',
                    '13038',
                ],
                tag: 'OneOf',
            },
            defaultValue: null,
            questionName: 'GUI_PostCode',
            section: {
                tag: 'ProductArguments',
            },
            friendlyName: 'postalCode',
            humanReadableName: 'Postal code',
        },
        {
            fieldSchema: {
                contents: '0000000000',
                tag: 'FreeText',
            },
            defaultValue: null,
            questionName: 'socialSecurity',
            section: {
                tag: 'PersonData',
            },
            friendlyName: 'socialSecurity',
            humanReadableName: 'Social Security',
        },
        {
            fieldSchema: {
                contents: ['7', '1', '4', '3', '6', '2', '5', '8'],
                tag: 'OneOf',
            },
            defaultValue: null,
            questionName: 'GUI_NumberOfResidents',
            section: {
                tag: 'ProductArguments',
            },
            friendlyName: 'residents',
            humanReadableName: 'Residents',
        },
        {
            fieldSchema: {
                contents: ['1500000', '300000', '1000000', '2000000'],
                tag: 'OneOf',
            },
            defaultValue: null,
            questionName: 'GUI_AmountInsured',
            section: {
                tag: 'ProductArguments',
            },
            friendlyName: 'sumInsured',
            humanReadableName: 'Sum insured',
        },
        {
            fieldSchema: {
                contents: {
                    rFrom: 20,
                    rTo: 200,
                },
                tag: 'ValueInRanges',
            },
            defaultValue: null,
            questionName: 'GUI_Area',
            section: {
                tag: 'ProductArguments',
            },
            friendlyName: 'area',
            humanReadableName: 'Area',
        },
        {
            fieldSchema: {
                contents: 'an, example address, 100',
                tag: 'FreeText',
            },
            defaultValue: null,
            questionName: 'address',
            section: {
                tag: 'PersonData',
            },
            friendlyName: 'address',
            humanReadableName: 'Address',
        },
        {
            fieldSchema: {
                contents: ['Ja', 'Nej'],
                tag: 'OneOf',
            },
            defaultValue: null,
            questionName: 'GUI_RentedOut',
            section: {
                tag: 'ProductArguments',
            },
            friendlyName: 'rentedOut',
            humanReadableName: 'Rented out',
        },
        {
            fieldSchema: {
                contents: ['Ja', 'Nej'],
                tag: 'OneOf',
            },
            defaultValue: null,
            questionName: 'GUI_SecuritySolution',
            section: {
                tag: 'ProductArguments',
            },
            friendlyName: 'securitySolution',
            humanReadableName: 'Security Solution',
        },
        {
            fieldSchema: {
                contents: ['true', 'false'],
                tag: 'OneOf',
            },
            defaultValue: null,
            questionName: 'OPT_Extra',
            section: {
                tag: 'ProductArguments',
            },
            friendlyName: 'optExtra',
            humanReadableName: 'Extra?',
        },
        {
            fieldSchema: {
                contents: ['6000', '1500', '3000', '1800', '2000'],
                tag: 'OneOf',
            },
            defaultValue: null,
            questionName: 'GUI_Excess',
            section: {
                tag: 'ProductArguments',
            },
            friendlyName: 'excess',
            humanReadableName: 'Excess',
        },
        {
            fieldSchema: {
                contents: ['Base'],
                tag: 'OneOf',
            },
            defaultValue: null,
            questionName: 'coverLevel',
            section: {
                tag: 'MandatoryQuoteInputs',
            },
            friendlyName: 'coverLevel',
            humanReadableName: 'Cover Level',
        },
        {
            fieldSchema: {
                contents: ['true', 'false'],
                tag: 'OneOf',
            },
            defaultValue: null,
            questionName: 'OPT_CondoAddOn',
            section: {
                tag: 'ProductArguments',
            },
            friendlyName: 'optCondoAddOn',
            humanReadableName: 'Condo?',
        },
    ],
    productVersionField: {
        fieldSchema: {
            contents: 'latest',
            tag: 'FreeText',
        },
        defaultValue: null,
        questionName: 'productVersion',
        section: {
            tag: 'MandatoryQuoteInputs',
        },
        friendlyName: 'productVersion',
        humanReadableName: 'Product Version',
    },
    startDayField: {
        fieldSchema: {
            contents: '2022-11-29',
            tag: 'DayValue',
        },
        defaultValue: null,
        questionName: 'startDate',
        section: {
            tag: 'MandatoryQuoteInputs',
        },
        friendlyName: 'startDate',
        humanReadableName: 'Start Day',
    },
    coverLevelField: {
        fieldSchema: {
            contents: ['Base'],
            tag: 'OneOf',
        },
        defaultValue: null,
        questionName: 'coverLevel',
        section: {
            tag: 'MandatoryQuoteInputs',
        },
        friendlyName: 'coverLevel',
        humanReadableName: 'Cover Level',
    },
    policyDefaultDuration: 365,
    endDayField: {
        fieldSchema: {
            contents: '2023-07-18',
            tag: 'DayValue',
        },
        defaultValue: null,
        questionName: 'endDate',
        section: {
            tag: 'MandatoryQuoteInputs',
        },
        friendlyName: 'endDate',
        humanReadableName: 'End Day',
    },
    productNameField: {
        fieldSchema: {
            contents: 'lin-contents',
            tag: 'FreeText',
        },
        defaultValue: null,
        questionName: 'product',
        section: {
            tag: 'MandatoryQuoteInputs',
        },
        friendlyName: 'product',
        humanReadableName: 'Product Name',
    },
    referenceField: {
        fieldSchema: {
            contents: 'a custom reference',
            tag: 'FreeText',
        },
        defaultValue: null,
        questionName: 'reference',
        section: {
            tag: 'MandatoryQuoteInputs',
        },
        friendlyName: 'reference',
        humanReadableName: 'Reference',
    },
};

var img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='iso-8859-1'%3f%3e%3c!-- Generator: Adobe Illustrator 19.0.0%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 512 512' style='enable-background:new 0 0 512 512%3b' xml:space='preserve'%3e%3cpath style='fill:%23E2E5E7%3b' d='M128%2c0c-17.6%2c0-32%2c14.4-32%2c32v448c0%2c17.6%2c14.4%2c32%2c32%2c32h320c17.6%2c0%2c32-14.4%2c32-32V128L352%2c0H128z'/%3e%3cpath style='fill:%23B0B7BD%3b' d='M384%2c128h96L352%2c0v96C352%2c113.6%2c366.4%2c128%2c384%2c128z'/%3e%3cpolygon style='fill:%23CAD1D8%3b' points='480%2c224 384%2c128 480%2c128 '/%3e%3cpath style='fill:%23F15642%3b' d='M416%2c416c0%2c8.8-7.2%2c16-16%2c16H48c-8.8%2c0-16-7.2-16-16V256c0-8.8%2c7.2-16%2c16-16h352c8.8%2c0%2c16%2c7.2%2c16%2c16 V416z'/%3e%3cg%3e %3cpath style='fill:white%3b' d='M101.744%2c303.152c0-4.224%2c3.328-8.832%2c8.688-8.832h29.552c16.64%2c0%2c31.616%2c11.136%2c31.616%2c32.48 c0%2c20.224-14.976%2c31.488-31.616%2c31.488h-21.36v16.896c0%2c5.632-3.584%2c8.816-8.192%2c8.816c-4.224%2c0-8.688-3.184-8.688-8.816V303.152z M118.624%2c310.432v31.872h21.36c8.576%2c0%2c15.36-7.568%2c15.36-15.504c0-8.944-6.784-16.368-15.36-16.368H118.624z'/%3e %3cpath style='fill:white%3b' d='M196.656%2c384c-4.224%2c0-8.832-2.304-8.832-7.92v-72.672c0-4.592%2c4.608-7.936%2c8.832-7.936h29.296 c58.464%2c0%2c57.184%2c88.528%2c1.152%2c88.528H196.656z M204.72%2c311.088V368.4h21.232c34.544%2c0%2c36.08-57.312%2c0-57.312H204.72z'/%3e %3cpath style='fill:white%3b' d='M303.872%2c312.112v20.336h32.624c4.608%2c0%2c9.216%2c4.608%2c9.216%2c9.072c0%2c4.224-4.608%2c7.68-9.216%2c7.68 h-32.624v26.864c0%2c4.48-3.184%2c7.92-7.664%2c7.92c-5.632%2c0-9.072-3.44-9.072-7.92v-72.672c0-4.592%2c3.456-7.936%2c9.072-7.936h44.912 c5.632%2c0%2c8.96%2c3.344%2c8.96%2c7.936c0%2c4.096-3.328%2c8.704-8.96%2c8.704h-37.248V312.112z'/%3e%3c/g%3e%3cpath style='fill:%23CAD1D8%3b' d='M400%2c432H96v16h304c8.8%2c0%2c16-7.2%2c16-16v-16C416%2c424.8%2c408.8%2c432%2c400%2c432z'/%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3c/svg%3e";

const Documents = () => {
    return (jsxs(Section, { children: [jsx("header", { children: jsx("h3", { children: "Dokument" }) }), jsx("main", { children: jsxs(DocumentsList, { children: [jsxs("li", { children: [jsx(Icon, { src: img, alt: 'PDF dokument' }), jsx("a", Object.assign({ href: '#' }, { children: "F\u00F6rk\u00F6psinformation" }))] }), jsxs("li", { children: [jsx(Icon, { src: img, alt: 'PDF dokument' }), jsx("a", Object.assign({ href: '#' }, { children: "Produktblad" }))] }), jsxs("li", { children: [jsx(Icon, { src: img, alt: 'PDF dokunebt' }), jsx("a", Object.assign({ href: '#' }, { children: "F\u00F6rs\u00E4kringsvillkor" }))] })] }) })] }));
};
const DocumentsList = styled.ul `
  list-style: none;
  padding: 0;

  li {
    display: flex;
    gap: 0.25rem;
    align-items: center;
  }
`;
const Icon = styled.img `
  width: auto;
  height: 1.2rem;
`;

const Input$1 = styled.input `
  font-size: 1.4rem;
  line-height: 1;
  border-radius: 0.25rem;
  background-color: #f5f5f5;
  border: 0;
  padding: 0.75rem 0.5rem;
  transition: none;
  transition: background-color 0.2s ease;

  &:focus {
    background-color: #fff;
    border: 0.125rem solid var(--eir-partner-primary-color);
    padding: 0.625rem 0.375rem;
  }
`;

const RadioButton = ({ name, value, onChange }) => {
    var _a;
    const inputRef = useRef(null);
    const [isChecked, setIsChecked] = useState(true);
    useEffect(() => {
        if (inputRef.current) {
            setIsChecked(inputRef.current.checked);
        }
    }, [(_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.checked]);
    return (jsxs(RadioButtonLabel, Object.assign({ isChecked: isChecked }, { children: [jsx(Input, { ref: inputRef, name: name, type: 'radio', value: value, onChange: onChange }), value === 'true'
                ? 'Ja'
                : value === 'false'
                    ? 'Nej'
                    : Number.isNaN(Number(value))
                        ? value
                        : Number(value).toLocaleString('sv-SE')] })));
};
const Input = styled.input `
  height: 1.25rem;
  width: 1.25rem;
  padding: 0;
  appearance: none;
  border-radius: 50%;
  background-color: #f5f5f5;
  border: 0.1875rem solid #fff;
  box-shadow: 0 0 0 0.0625rem #dedede;

  &:checked {
    background-color: #20d8a9;
    box-shadow: 0 0 0 0.0625rem #1ecb9f;

    &:hover {
      background-color: #20d8a9;
      box-shadow: 0 0 0 0.0625rem #1ecb9f;
    }
  }

  &:hover {
    border: 0.1875rem solid #fff;
    box-shadow: 0 0 0 0.0625rem #dedede;
  }
`;
const RadioButtonLabel = styled.label `
  border: 0.125rem solid
    ${({ isChecked }) => (isChecked ? '#20d8a9' : '#dedede')};
  border-radius: 2.2rem;
  padding: 0.25rem 0.5rem;
  display: flex;
  gap: 0.5rem;
  background-color: ${({ isChecked }) => (isChecked ? '#edfcf9' : '#f5f5f5')};
  font-size: 1rem;
  align-items: center;
  cursor: pointer;
`;

const RangeSlider = ({ name, value, minValue, maxValue, onChange, }) => {
    return (jsxs(Fragment, { children: [jsx(RangeSliderWrapper, { children: jsx(RangeInput, { name: name, type: 'range', value: value === '' ? minValue : value, min: minValue, max: maxValue, onChange: onChange }) }), jsx(RangeValueInput, { name: name, value: value, onChange: onChange })] }));
};
var RangeSlider$1 = memo(RangeSlider);
const RangeSliderWrapper = styled.div `
  width: 100%;
  position: relative;
  margin-bottom: 0.5rem;
`;
const RangeInput = styled.input `
  appearance: none;
  width: 100%;
  height: 0.25rem;
  border: 0;
  padding: 0;
  background-color: #ebebeb;
  border-radius: 0.25rem;
  background-image: linear-gradient(
    rgba(0, 194, 255, 0.25),
    rgba(0, 194, 255, 0.8)
  );
  background-size: ${props => `${((Number(props.value) - Number(props.min)) * 100) /
    (Number(props.max) - Number(props.min))}%`}
    100%;
  background-repeat: no-repeat;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 2rem;
    width: 2rem;
    border-radius: 50%;
    background: var(--eir-partner-primary-color);
    cursor: ew-resize;
    box-shadow: 0 0 2px 0 #555;

    @media (min-width: 54rem) {
      height: 1.5rem;
      width: 1.5rem;
    }
  }

  &::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
  }
`;
const RangeValueInput = styled(Input$1) `
  width: 4rem;
`;

var e = [],
    t = [];

function n(n, r) {
  if (n && "undefined" != typeof document) {
    var a,
        s = !0 === r.prepend ? "prepend" : "append",
        d = !0 === r.singleTag,
        i = "string" == typeof r.container ? document.querySelector(r.container) : document.getElementsByTagName("head")[0];

    if (d) {
      var u = e.indexOf(i);
      -1 === u && (u = e.push(i) - 1, t[u] = {}), a = t[u] && t[u][s] ? t[u][s] : t[u][s] = c();
    } else a = c();

    65279 === n.charCodeAt(0) && (n = n.substring(1)), a.styleSheet ? a.styleSheet.cssText += n : a.appendChild(document.createTextNode(n));
  }

  function c() {
    var e = document.createElement("style");
    if (e.setAttribute("type", "text/css"), r.attributes) for (var t = Object.keys(r.attributes), n = 0; n < t.length; n++) e.setAttribute(t[n], r.attributes[t[n]]);
    var a = "prepend" === s ? "afterbegin" : "beforeend";
    return i.insertAdjacentElement(a, e), e;
  }
}

var css = ".react-datepicker-wrapper,\n.react-datepicker__input-container,\n.react-datepicker__input-container input {\n  display: block;\n  width: 100%;\n}\n";
n(css,{});

const FieldItem = ({ field, value, onChange, onDateChange, }) => {
    const handleDateChangeRaw = (event) => event.preventDefault();
    const getInput = (field) => {
        var _a, _b, _c;
        if (field.fieldSchema.tag === 'DayValue') {
            return (jsx(DatePicker, { customInput: jsx(Input$1, { readOnly: true }), locale: 'sv', dateFormat: 'yyyy-MM-dd', minDate: new Date(), selected: value === '' ? new Date() : new Date(value), onChange: date => { var _a; return onDateChange((_a = field.friendlyName) !== null && _a !== void 0 ? _a : field.questionName, date); }, onChangeRaw: handleDateChangeRaw, onFocus: event => event.target.blur() }));
        }
        if (field.fieldSchema.tag === 'ValueInRanges') {
            return (jsx(RangeSlider$1, { name: (_a = field.friendlyName) !== null && _a !== void 0 ? _a : field.questionName, value: value, minValue: field.fieldSchema.contents.rFrom.toString(), maxValue: field.fieldSchema.contents.rTo.toString(), onChange: onChange }));
        }
        if (field.fieldSchema.tag === 'OneOf' &&
            field.fieldSchema.contents.length > 1) {
            return field.fieldSchema.contents.length < 6 ? (jsx(RadioButtonsContainer, { children: field.fieldSchema.contents.map(content => {
                    var _a;
                    return (jsx(RadioButton, { name: (_a = field.friendlyName) !== null && _a !== void 0 ? _a : field.questionName, value: content, onChange: onChange }, `${field.questionName}_${content}`));
                }) })) : (jsxs(Fragment, { children: [jsx(Input$1, { name: (_b = field.friendlyName) !== null && _b !== void 0 ? _b : field.questionName, value: value, onChange: onChange, list: field.questionName, autoComplete: 'off' }), jsx("datalist", Object.assign({ id: field.questionName }, { children: field.fieldSchema.contents.map(content => (jsx("option", { value: content }, `${field.questionName}_${content}`))) }))] }));
        }
        return (jsx(Input$1, { name: (_c = field.friendlyName) !== null && _c !== void 0 ? _c : field.questionName, value: value, autoComplete: 'off', onChange: onChange }));
    };
    return (jsxs(ItemWrapper, Object.assign({ show: field.fieldSchema.tag === 'OneOf' &&
            field.fieldSchema.contents.length === 1
            ? false
            : true }, { children: [jsx(Label, { children: field.humanReadableName }), getInput(field)] }), field.questionName));
};
const ItemWrapper = styled.div `
  display: ${({ show }) => (show ? 'flex' : 'none')};
  flex-direction: column;
  gap: 0.125rem;
`;
const Label = styled.label `
  font-size: 0.9rem;
  font-weight: 300;
  color: #707070;
`;
const RadioButtonsContainer = styled.div `
  display: flex;
  justify-content: start;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

const SalesFormView = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    let ButtonText;
    (function (ButtonText) {
        ButtonText["DEFAULT"] = "Ber\u00E4kna ditt pris";
        ButtonText["CALCULATED"] = "Ditt pris \u00E4r ber\u00E4knat";
        ButtonText["CALCULATING"] = "Vi ber\u00E4knar ditt pris";
        ButtonText["CALCULATE_NEW"] = "Ber\u00E4kna nytt pris";
    })(ButtonText || (ButtonText = {}));
    const getOnlyValueFromOneOf = (field) => {
        if (field.fieldSchema.tag === 'OneOf' &&
            field.fieldSchema.contents.length === 1) {
            return field.fieldSchema.contents[0];
        }
        return null;
    };
    const initialFormValues = Object.assign(Object.assign({ [(_a = response.coverLevelField.friendlyName) !== null && _a !== void 0 ? _a : response.coverLevelField.questionName]: (_b = response.coverLevelField.defaultValue) !== null && _b !== void 0 ? _b : '', [(_c = response.endDayField.friendlyName) !== null && _c !== void 0 ? _c : response.endDayField.questionName]: (_d = response.endDayField.defaultValue) !== null && _d !== void 0 ? _d : '', [(_e = response.paymentMethodField.friendlyName) !== null && _e !== void 0 ? _e : response.paymentMethodField.questionName]: (_f = response.paymentMethodField.defaultValue) !== null && _f !== void 0 ? _f : '' }, Object.fromEntries(response.productFields.map(field => {
        var _a, _b, _c;
        return [
            (_a = field.friendlyName) !== null && _a !== void 0 ? _a : field.questionName,
            (_c = (_b = field.defaultValue) !== null && _b !== void 0 ? _b : getOnlyValueFromOneOf(field)) !== null && _c !== void 0 ? _c : '',
        ];
    }))), { [(_g = response.productVersionField.friendlyName) !== null && _g !== void 0 ? _g : response.productVersionField.questionName]: (_h = response.productVersionField.defaultValue) !== null && _h !== void 0 ? _h : '', [(_j = response.productNameField.friendlyName) !== null && _j !== void 0 ? _j : response.productNameField.questionName]: (_k = response.productNameField.defaultValue) !== null && _k !== void 0 ? _k : '', [(_l = response.referenceField.friendlyName) !== null && _l !== void 0 ? _l : response.referenceField.questionName]: (_m = response.referenceField.defaultValue) !== null && _m !== void 0 ? _m : '', [(_o = response.startDayField.friendlyName) !== null && _o !== void 0 ? _o : response.startDayField.questionName]: (_p = response.startDayField.defaultValue) !== null && _p !== void 0 ? _p : formatDate(new Date()), [(_q = response.productNameField.friendlyName) !== null && _q !== void 0 ? _q : response.productNameField.questionName]: response.productNameField.fieldSchema.contents.toString(), [(_r = response.productVersionField.friendlyName) !== null && _r !== void 0 ? _r : response.productVersionField.questionName]: response.productVersionField.fieldSchema.contents.toString() });
    const [formValues, setFormValues] = useState(initialFormValues);
    const [quoteResponse, setQuoteResponse] = useState(null);
    const [buttonText, setButtonText] = useState(ButtonText.DEFAULT);
    const [isFetchingPrice, setIsFetchingPrice] = useState(false);
    const priceRef = useRef(null);
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormValues(state => (Object.assign(Object.assign({}, state), { [name]: value })));
    };
    const handleDateChange = (fieldName, date) => {
        if (date) {
            setFormValues(state => (Object.assign(Object.assign({}, state), { [fieldName]: formatDate(date) })));
        }
    };
    const handleGetPriceClick = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsFetchingPrice(true);
        setButtonText(ButtonText.CALCULATING);
        const calculateEndDate = () => {
            var _a;
            if (formValues[response.startDayField.questionName]) {
                const endDate = new Date((_a = formValues[response.startDayField.questionName]) !== null && _a !== void 0 ? _a : new Date());
                endDate.setFullYear(endDate.getFullYear() + 1);
                endDate.setDate(endDate.getDate() - 1);
                return formatDate(endDate);
            }
            return '';
        };
        formValues[response.endDayField.questionName] = calculateEndDate();
        try {
            const response = yield createQuoteService('LinAPI', formValues);
            setQuoteResponse(response);
            setButtonText(ButtonText.CALCULATED);
            setTimeout(() => {
                setButtonText(ButtonText.CALCULATE_NEW);
            }, 1500);
            if (priceRef.current) {
                priceRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }
        catch (error) {
            alert('Nåt gick fel!!!');
            setButtonText(quoteResponse ? ButtonText.CALCULATE_NEW : ButtonText.DEFAULT);
        }
        finally {
            setIsFetchingPrice(false);
        }
    });
    return (jsxs(PageWrapper, { children: [jsxs("header", { children: [jsx("h1", { children: "Ber\u00E4kna ditt pris" }), jsx("h2", { children: "PRODUKT" })] }), jsxs(ContentWrapper, { children: [jsx("main", { children: jsxs(Section, { children: [jsx("h3", { children: "Formul\u00E4r" }), [
                                    ...response.productFields.filter(field => field.section.tag === 'PersonData'),
                                    ...response.productFields.filter(field => field.section.tag === 'MandatoryQuoteInputs'),
                                    ...response.productFields.filter(field => field.section.tag === 'ProductArguments'),
                                ].map(field => {
                                    var _a, _b;
                                    return (jsx(FieldItem, { field: field, value: (_b = formValues[(_a = field.friendlyName) !== null && _a !== void 0 ? _a : field.questionName]) !== null && _b !== void 0 ? _b : '', onChange: handleChange, onDateChange: handleDateChange }, field.questionName));
                                }), jsx(FieldItem, { field: response.startDayField, value: (_s = formValues[response.startDayField.questionName]) !== null && _s !== void 0 ? _s : '', onChange: handleChange, onDateChange: handleDateChange }, response.startDayField.questionName), jsx(ButtonWrapper, { children: jsx(Button, Object.assign({ size: 'large', disabled: isFetchingPrice, onClick: handleGetPriceClick }, { children: buttonText })) })] }) }), jsxs(Aside, { children: [jsx(Documents, {}), quoteResponse && jsx(Price, { ref: priceRef, quote: quoteResponse })] })] })] }));
};
const PageWrapper = styled.div `
  background-color: var(--eir-partner-background-color);
  margin: auto;
  padding: 2rem 0;

  @media (min-width: 54rem) {
    padding: 2rem;
  }

  header {
    padding: 0 1rem;

    @media (min-width: 54rem) {
      padding: 0;
    }
  }
`;
const ContentWrapper = styled.div `
  display: grid;
  grid-template-columns: minmax(100%, 37.5rem);
  gap: 1rem;

  @media (min-width: 54rem) {
    grid-template-columns: minmax(auto, 42rem) 18.25rem;
  }
`;
const Aside = styled.aside `
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: 54rem) {
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
`;
const ButtonWrapper = styled.div `
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`;

export { SalesFormView };
